function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#c1e4f7;}.cls-3{fill:#9fd2f4;}.cls-25,.cls-4,.cls-6,.cls-7,.cls-8,.cls-9{fill:#fff;}.cls-4{opacity:0.25;}.cls-5{opacity:0.32;}.cls-6{opacity:0.51;}.cls-7{opacity:0.59;}.cls-8{opacity:0.6;}.cls-10{fill:#edb9d9;}.cls-11{fill:#e588b1;}.cls-12,.cls-32,.cls-33,.cls-40,.cls-45,.cls-47,.cls-48,.cls-56,.cls-62,.cls-63,.cls-64,.cls-68,.cls-70{fill:none;}.cls-12,.cls-33,.cls-47,.cls-68,.cls-70{stroke:#06b795;}.cls-12,.cls-32,.cls-33,.cls-48,.cls-56,.cls-62,.cls-68,.cls-70{stroke-miterlimit:10;}.cls-12{stroke-width:10px;}.cls-13{fill:#54bc8b;}.cls-14{fill:#06b795;}.cls-15{fill:#87cdab;}.cls-16{fill:#eaa9ce;}.cls-17{fill:#f9d9f2;}.cls-18{fill:#f2c9e5;}.cls-19{fill:#17aa8e;}.cls-20{fill:#97ddb8;}.cls-21{fill:#129aa0;}.cls-22{fill:#1aaaaa;}.cls-23{fill:#0eaf90;}.cls-24{fill:#0a8787;}.cls-25{opacity:0.27;}.cls-26{fill:#4b88e2;}.cls-27{fill:#2e6cd8;}.cls-28{fill:#1ad2bd;}.cls-29{fill:#6cadef;}.cls-30{fill:#5b9ce8;}.cls-31{fill:#108a7d;}.cls-32{stroke:#17aa8e;stroke-width:11px;}.cls-33,.cls-48{stroke-width:13px;}.cls-34{fill:#69e2ce;}.cls-35,.cls-61{fill:#9ef2e2;}.cls-36{fill:#bbf2e8;}.cls-37{fill:#8cedda;}.cls-38{fill:#0dcea9;}.cls-39{fill:#0f7a6a;}.cls-40,.cls-45{stroke:#108a7d;}.cls-40,.cls-45,.cls-47,.cls-63,.cls-64{stroke-linecap:round;stroke-linejoin:round;}.cls-40,.cls-64{stroke-width:3px;}.cls-41{fill:#fcc8c8;}.cls-42{fill:#ffabab;}.cls-43{fill:#ff938e;}.cls-44{fill:#f98080;}.cls-45,.cls-62{stroke-width:0.75px;}.cls-46{fill:#f9d9d9;}.cls-47,.cls-68{stroke-width:4px;}.cls-48,.cls-56{stroke:#1ad2bd;}.cls-49{fill:#9089db;}.cls-50{fill:#8069d8;}.cls-51{fill:#c4c4f2;}.cls-52{fill:#dedef9;}.cls-53{fill:#887bd6;}.cls-54{fill:#aaaae8;}.cls-55{fill:#215ad9;}.cls-56{stroke-width:6px;}.cls-57{fill:#fcbf77;}.cls-58{fill:#f2ad61;}.cls-59{fill:#eef;}.cls-60{fill:#fcd2a7;}.cls-61{mix-blend-mode:multiply;}.cls-62{stroke:#666;}.cls-63{stroke:#ff938e;stroke-width:0.5px;}.cls-64{stroke:#bbf2e8;}.cls-65{fill:#1cc6ad;}.cls-66{fill:#e6e6e6;}.cls-67{fill:#f2f2f2;}.cls-69{fill:#14c9a6;}.cls-70{stroke-width:19px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Background"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: -1.14,
  y: -0.03,
  width: 1921.93,
  height: 1080
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1920,0v234.6c-190.76,25.29-412.34-8-570.81-84.63C984.21-26.6,791.92,130.34,554,140.54,349.27,149.31,81.73,96.21,0,78.67V0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1920.79,417.36V1080H0V203.82c36.64,2.54,79.1,8.74,115.05,22.73,83.19,32.38,176.73-8.47,298.41-40.57S755.79,168.22,841,320.09s221.29-49.42,445,63.36C1627.76,555.83,1741,414.4,1920.79,417.36Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Wind_Streaks",
  "data-name": "Wind Streaks",
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M1921.13,518.57v30.31c-164.8-35.63-334.41-88.74-690-130.5C519.11,334.76,225,770.11,225,770.11l14.86-121.52c421.34-325.38,960-281.89,1279.25-203.12C1662.05,480.75,1805.89,503.84,1921.13,518.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M-16,463.4S483.08,197.14,1063.71,304.5,1767.19,475,1920.79,399.14V357.59s-253.55,103.28-808.42-72.39S65.74,353.62-1.14,414Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M-16,248S292.36,46.23,859.76,96.25a1522.26,1522.26,0,0,1,421.13,99.26c147.83,57.87,408.61,138.94,639.9,103.11V260.07s-354.21,43.45-578.57-58.82S445.21-65.38-16,205.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1920.13,74.56v41C1834,89.9,1681.35,55.23,1511.8,66.18,1276.3,81.39,1018.14,64,817.54,0h66.87c79.4,24.15,219.65,57.29,355.87,42.65C1431.61,22.06,1611.58-10.43,1920.13,74.56Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Rose_Bud_4",
  "data-name": "Rose Bud 4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rose_Bud_4-2",
  "data-name": "Rose Bud 4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M1266.57,463.16a27.42,27.42,0,0,0-1.92,10.49,29.5,29.5,0,0,0,4.49,15.28c14.26-3.95,14.36-35.59,14.36-35.59s-10.35-2.72-15.19,6.08A29.61,29.61,0,0,0,1266.57,463.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1279.81,464.73l45.94,1.09s.23-8.63-10.32-14.72a43.24,43.24,0,0,0-14.87-4.9c-11.62-1.88-17,1.76-19.34,6.31C1278.37,458,1279.81,464.73,1279.81,464.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M1308.82,519.35s41,123.2,22.56,215.22"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M1284,514.55s2.52,10.67,21.47,9.75a15,15,0,0,0,8.7-3.29,25.88,25.88,0,0,0,5.56-6.08,24,24,0,0,0,3.23-7.17,27.09,27.09,0,0,0,.9-6.71h0l-1,.48,0,0c-2.28,1-8.16,3.56-17.61,6.73h0c-3.67,1.24-7.89,2.56-12.64,3.92q-4,1.15-8.46,2.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M1309.78,523.45s-15.35-2.85-16-11.6l-9.78,2.71S1290.49,530.08,1309.78,523.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1315.64,509.14a4.32,4.32,0,0,0,2.57,5.54,4.18,4.18,0,0,0,1.5.25,24,24,0,0,0,3.23-7.17,4.25,4.25,0,0,0-1.75-1.2A4.32,4.32,0,0,0,1315.64,509.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M1279.82,464.71v0a72.45,72.45,0,0,0,1.91,22.16v0c3,11.43,9.81,21.78,23.9,22.45l17.66-6.74s23.58-18-.6-39.82c-8.5-7.66-19.65-4.37-25.81-4.37-5.9,0-9.24-4.85-13.36-3.46a6.83,6.83,0,0,0-2.22,1.33C1280.37,457.1,1280.11,460.49,1279.82,464.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M1267.8,502.58v0a16.65,16.65,0,0,0,1.11,2.13h0a9.06,9.06,0,0,0,.49.77c2.66,3.89,7.36,7.48,15.07,10.13l21.14-6.27c-23.73-1.13-26.81-29.74-25.81-44.63a61,61,0,0,1-2.58,7.74,31.14,31.14,0,0,1-5.1,8.76C1268.59,485.11,1264.2,494.18,1267.8,502.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M1279.82,464.71v0a72.45,72.45,0,0,0,1.91,22.16,18.14,18.14,0,0,1,4.9-10.15c4.62-5.09,4.18-10.33,1.49-14.42-1.33-2-6.36-3.84-4.6-7.35a6.83,6.83,0,0,0-2.22,1.33C1280.37,457.1,1280.11,460.49,1279.82,464.71Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-18",
  cx: 1313.03,
  cy: 473.66,
  r: 7.4
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1266.57,463.16a27.42,27.42,0,0,0-1.92,10.49.45.45,0,0,0,.12.06,5.44,5.44,0,1,0,3.75-10.22A5.16,5.16,0,0,0,1266.57,463.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1269.41,505.5a2.74,2.74,0,0,0-.49-.77A9.06,9.06,0,0,0,1269.41,505.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1267.8,502.58c-1-4.09,3-9.32,6-15.47a38.62,38.62,0,0,0,3.48-14.64,31.14,31.14,0,0,1-5.1,8.76C1268.59,485.11,1264.2,494.18,1267.8,502.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M1281.22,452.51c2.45-3.34,10.6,1.44,16.81-2.05s17.26.59,17.4.64a43.24,43.24,0,0,0-14.87-4.9C1288.94,444.32,1283.59,448,1281.22,452.51Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Large_Wobbly_Leaf",
  "data-name": "Large Wobbly Leaf"
}, /*#__PURE__*/React.createElement("g", {
  id: "Large_Wobbly_Leaf-2",
  "data-name": "Large Wobbly Leaf"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1153.66,679.87c-17.08,43.18-2.25,98.14,8.89,130.22,4.38,12.61,8.19,21.69,9.26,25.12L961.4,740.53s-3.83-151.46,89.75-198.82,47.32-137,169-144.39c-22.1,118.78,50,129.86-38.44,228.13C1167.86,640.89,1161.29,660.56,1153.66,679.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M1153.66,679.87c-17.08,43.18-2.25,98.14,8.89,130.22L1046.12,771c-20.4-23.92-12.64-77.58-6.76-96.34,6.2-19.82,19.27-36.74,35.09-50.19,35.69-30.32,50-52.49,55.17-73.57A48.93,48.93,0,0,0,1131,538c-.49-22.71-7.06-111.76,79.23-137.25l10-3.39c-22.1,118.78,50,129.86-38.44,228.13C1167.86,640.89,1161.29,660.56,1153.66,679.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1217.72,413.05s-1.86,24.86-14.24,33.33-24.11,26.82-15.64,38.5c5.87,8.09,15,14.18,18.9,23.61,6,14.19,4.7,29.85,1.37,44.52-1.46,6.39-3.87,12.6-5,19-2.28,12.67.1,26-7,37.68,23.84-25.58,36.7-61.72,30.52-96.52-3.27-18.4-8.65-37.55-6.83-56.4C1221.72,436.61,1217.72,413.05,1217.72,413.05Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Large_Leaf",
  "data-name": "Large Leaf"
}, /*#__PURE__*/React.createElement("g", {
  id: "Large_Leaf-2",
  "data-name": "Large Leaf"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M1063.71,463.52c-1.13,2.56-2.15,5.11-3.08,7.65-4.59,12.54-3.58,94.51-4.32,107.07-11.24-2-28.79-3.29-45.35,2.81,1.26-.17,20.58-2.42,43.6,13.49-6,72.07-67.69,97-67.69,97l-112-22s-3.16-17.23-.66-41.72c4.8-47.06,30.52-120.94,139.82-150.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M916.82,658l-42.57-30.09c4.8-47.06,30.52-120.94,139.82-150.94l49.64-13.4C911.53,548.72,916.82,658,916.82,658Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M908.88,540.92a29.51,29.51,0,0,1,23.52-7.2c14.75,1.73,26.64-3.67,27.43-17s12-13.14,22.29-14.24c16.29-1.74,14.06-20.29,23-22.9C1005.13,479.54,946.63,493.39,908.88,540.92Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-20",
  cx: 924.51,
  cy: 548.34,
  r: 5.7
}))), /*#__PURE__*/React.createElement("g", {
  id: "Middle_Ground",
  "data-name": "Middle Ground"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M1232,808.48l-11.8,271.5H0V275.16c22.69-3.35,44.86-4.1,65.22-1C116.06,282,145.74,299,176,316c38.06,21.42,77,42.89,160.18,46.16,106,4.16,202.64-18.27,295,23.59,27.23,12.35,54.08,30.28,80.68,56.13a398.42,398.42,0,0,1,30.74,33.65C852.88,610.4,1093.9,775.8,1232,808.48,1252,813.22,1213.66,808,1232,808.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M1165,788.15c-171.31-7.14-315.7-119.9-383.3-192.92-.29-.32-.59-.63-.87-1-17.67-19.21-30.09-36.78-36.44-50.67-60.12-131.54-115.58-158-115.58-158l2.35.11c26.35,11.95,52.35,29.13,78.11,53.66l1.79,1.72.78.75c10.28,10,20.13,21.51,30.74,33.65C890.83,645.12,1165,788.15,1165,788.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M1920,734.55V1080H-1.14V841.39c96.54,4.36,193.12,7.8,289.71,10.88,181.15,5.77,362.48,10.37,543.74,9.12,62.94-.43,126-1.39,188.82-5.27,22.53-1.39,45.21-2.92,67.6-6,100.3-13.6,169.74-99.81,266.19-125,82.32-21.54,173.86-17.64,242.51,37.73,0,0,105.55,68.42,197.43,37.14C1863.82,776.52,1890.93,745.33,1920,734.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M780,940.83C779,761.3,662,602.18,490.24,550.05l-5.73-1.71c-184.16-53.6-462.42,7.12-484.4-151L-1.14,1080l781.93,0Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Blue_Tulip_2",
  "data-name": "Blue Tulip 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Blue_Tulip_2-2",
  "data-name": "Blue Tulip 2"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 967.44,
  cy: 420.12,
  r: 88.99
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M973.28,475.22s-27.1,3.2-43.71-19.4a57.75,57.75,0,0,1-8.26-16.35c-.09-.29-.19-.56-.28-.84-10.57-32-12.77-37.46-13.08-37.59.29-.05,1.84-.34,4.26-.59h0a78.33,78.33,0,0,1,17,.07h0c14.69,1.75,32.63,8.76,38.81,31.43a60.28,60.28,0,0,1,1.62,8.29h0c.3,2.35.49,4.83.57,7.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M968.08,432c-6.18-22.67-24.12-29.68-38.81-31.43h0c-1.81-.34-1.91-9.55-1.44-16.12s-.6-19.21-.6-19.21A60.5,60.5,0,0,1,941.57,368c13,4.32,20.33,12.8,24.26,22.27C972.65,406.62,969.35,426,968.08,432Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M965.83,390.22v0s-10.62,8-20.42-1.42c0,0-4.29-4.11-3.3-14.14a16.1,16.1,0,0,0-.54-6.73C954.59,372.27,961.9,380.75,965.83,390.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M963.67,403.64s6.88,14.67,6,36.62c0,0-1.41-10.35-3.85-14.81,0,0-1.45-11.42-4.57-19.9A5,5,0,0,0,963.67,403.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M961.27,405.54a6,6,0,0,1-8-3.09L950,394.84a6.06,6.06,0,0,1,.63-6,6,6,0,0,1,2.47-2,5.81,5.81,0,0,1,2.29-.51A6.07,6.07,0,0,1,961,390l3.34,7.61a6.25,6.25,0,0,1,.43,1.42A6.08,6.08,0,0,1,961.27,405.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M964.81,399a6,6,0,0,1-10.44-1.09L951,390.3a6.22,6.22,0,0,1-.42-1.42,6,6,0,0,1,2.47-2,5.81,5.81,0,0,1,2.29-.51A6.07,6.07,0,0,1,961,390l3.34,7.61A6.25,6.25,0,0,1,964.81,399Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 956.55,
  cy: 391.28,
  r: 2.68
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M963.67,403.64s1.54,3.89,2,5.28a3.7,3.7,0,0,1-2.71,1.9l-1.66-5.28h0A6,6,0,0,0,963.67,403.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M969.7,440.24c-6.31-14.57-27.12-14.13-31.38-26.44s-26.11-13.35-26.11-13.35h0a78.33,78.33,0,0,1,17,.07h0c14.69,1.75,32.63,8.76,38.81,31.43A60.28,60.28,0,0,1,969.7,440.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M939.5,445.15a10.48,10.48,0,0,1-9.93,10.67,57.75,57.75,0,0,1-8.26-16.35c-.09-.29-.19-.56-.28-.84a10.46,10.46,0,0,1,18.47,6.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M967.15,475.35s27.2,2.08,42.87-21.19a57.84,57.84,0,0,0,7.58-16.69l.24-.84c9.24-32.42,11.21-38,11.52-38.1-.3,0-1.85-.26-4.29-.42h0a77.13,77.13,0,0,0-17,.77h0c-14.61,2.36-32.23,10.1-37.47,33a58.67,58.67,0,0,0-1.28,8.36h0c-.21,2.36-.29,4.85-.26,7.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M970.56,431.89c5.24-22.9,22.86-30.64,37.47-33h0c1.78-.41,1.5-9.61.77-16.16s-.2-19.22-.2-19.22a60.33,60.33,0,0,0-14.23,3.36c-12.83,4.86-19.78,13.63-23.33,23.25C964.94,406.78,969,426,970.56,431.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M973.79,403.43s-6.26,14.94-4.51,36.83c0,0,1-10.39,3.23-14.95,0,0,1-11.47,3.75-20.07A5,5,0,0,1,973.79,403.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M976.26,405.23a6.05,6.05,0,0,0,7.83-3.42l3-7.74a6.08,6.08,0,0,0-.88-5.93,6,6,0,0,0-2.56-1.9,6,6,0,0,0-2.3-.41,6.06,6.06,0,0,0-5.52,3.84l-3,7.74a6.15,6.15,0,0,0-.37,1.43A6.08,6.08,0,0,0,976.26,405.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M972.46,398.84a6,6,0,0,0,2.56,1.9,6,6,0,0,0,7.82-3.42l3-7.74a5.76,5.76,0,0,0,.37-1.44,6,6,0,0,0-2.56-1.9,6,6,0,0,0-2.3-.41,6.06,6.06,0,0,0-5.52,3.84l-3,7.74A6.15,6.15,0,0,0,972.46,398.84Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 980.39,
  cy: 390.79,
  r: 2.68
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M973.79,403.43s-1.38,4-1.75,5.36a3.69,3.69,0,0,0,2.78,1.78l1.44-5.34h0A6,6,0,0,1,973.79,403.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M939.93,466.11s11.62-11.36,26.83-9.57,34.85,13.2,48.78-13c0,0-5.79,25.68-42.26,31.64C973.28,475.22,956.8,477.19,939.93,466.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M977.57,416s13.59-7.08,27.73-6c0,0,7.2-.23,16.05-7.5,0,0,5-5,8-3.91C1029.36,398.53,994.29,393,977.57,416Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M973.68,384.38s3.07-5.51,12.36-5.7S1000.42,365,1000.42,365,981,367.15,973.68,384.38Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-30",
  cx: 1002,
  cy: 380.17,
  r: 3.62
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M995.69,468.06S993,490,974.13,492.72a27,27,0,0,1-3.34.27c-25.6.57-26.11-23.88-26.11-23.88s12,7.32,29.32,5.65A57.69,57.69,0,0,0,995.69,468.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M995.69,468.06S993,490,974.13,492.72c5.23-2.5,12.14-11.85,4.84-16.13a12.73,12.73,0,0,0-5.69-1.37l.72-.46A57.69,57.69,0,0,0,995.69,468.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M970.79,493s11.34,174.94-79.12,256.28"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Rose_Bud_2",
  "data-name": "Rose Bud 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rose_Bud_2-2",
  "data-name": "Rose Bud 2"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-25",
  x: 453.09,
  y: 307.74,
  width: 143.97,
  height: 149.96,
  rx: 71.98,
  transform: "translate(194.13 -176.44) rotate(23.29)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M556.83,361.52a27.68,27.68,0,0,1,1.93,10.5,29.55,29.55,0,0,1-4.5,15.27c-14.26-4-14.35-35.58-14.35-35.58s10.35-2.72,15.18,6.08A29.5,29.5,0,0,1,556.83,361.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M543.59,363.09l-45.94,1.1s-.23-8.63,10.32-14.72a43.3,43.3,0,0,1,14.88-4.9c11.61-1.88,17,1.76,19.33,6.3C545,356.33,543.59,363.09,543.59,363.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M514.58,417.72s-41,123.2-22.56,215.21"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M539.42,412.92s-2.52,10.66-21.47,9.74a14.73,14.73,0,0,1-4.32-.85,15,15,0,0,1-4.38-2.43,26.53,26.53,0,0,1-5.56-6.08,24.21,24.21,0,0,1-3.23-7.18,26.56,26.56,0,0,1-.89-6.7h0l1.05.49h0c2.27,1,8.15,3.56,17.61,6.73h0c3.68,1.23,7.89,2.56,12.64,3.92,2.66.77,5.47,1.55,8.47,2.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M513.63,421.81s15.35-2.84,16-11.6l9.78,2.71S532.92,428.45,513.63,421.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M507.76,407.5a4.32,4.32,0,0,1-2.57,5.54,4.12,4.12,0,0,1-1.5.26,24.21,24.21,0,0,1-3.23-7.18,4.39,4.39,0,0,1,1.76-1.2A4.32,4.32,0,0,1,507.76,407.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M543.58,363.08h0a72.22,72.22,0,0,1-1.91,22.17v0c-3,11.42-9.81,21.77-23.9,22.45L500.12,401s-23.57-18,.61-39.82c8.5-7.66,19.65-4.37,25.8-4.37,5.91,0,9.25-4.85,13.36-3.45a6.59,6.59,0,0,1,2.23,1.33C543,355.47,543.29,358.86,543.58,363.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M555.6,401v0a16.45,16.45,0,0,1-1.1,2.12h0a8.9,8.9,0,0,1-.49.76c-2.65,3.89-7.36,7.48-15.07,10.14l-21.14-6.27c23.73-1.13,26.81-29.75,25.81-44.64a60.46,60.46,0,0,0,2.59,7.75,30.71,30.71,0,0,0,5.1,8.75C554.81,383.48,559.2,392.55,555.6,401Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M543.58,363.08h0a72.22,72.22,0,0,1-1.91,22.17,18.12,18.12,0,0,0-4.89-10.16c-4.62-5.09-4.19-10.32-1.5-14.41,1.34-2,6.36-3.84,4.6-7.35a6.59,6.59,0,0,1,2.23,1.33C543,355.47,543.29,358.86,543.58,363.08Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-18",
  cx: 510.37,
  cy: 372.03,
  r: 7.4
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M556.83,361.52a27.68,27.68,0,0,1,1.93,10.5l-.13.05a5.44,5.44,0,1,1-1.8-10.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M554,403.86a3,3,0,0,1,.49-.76A8.9,8.9,0,0,1,554,403.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M555.6,401c1-4.09-3.05-9.32-6-15.47a38.49,38.49,0,0,1-3.47-14.64,30.71,30.71,0,0,0,5.1,8.75C554.81,383.48,559.2,392.55,555.6,401Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M542.18,350.87c-2.45-3.34-10.59,1.44-16.81-2s-17.26.58-17.4.64a43.3,43.3,0,0,1,14.88-4.9C534.46,342.69,539.81,346.33,542.18,350.87Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Rose_3",
  "data-name": "Rose 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rose_3-2",
  "data-name": "Rose 3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-25",
  x: 739.79,
  y: 390.42,
  width: 223.54,
  height: 274.78,
  rx: 95.95,
  transform: "translate(-100.23 215.03) rotate(-13.6)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-33",
  d: "M883,606.3s40.84,149.63-18.71,222.37"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M788.17,485.13l0,0,1.74,2.93c2.71,3.82,8.83,10.47,20.77,14.24l.46.12c8,2.47,18.62,3.63,32.47,1.82,11.59-1.5,20.32-4.84,26.88-8.92v0c17.43-10.85,19.6-26.86,19.6-26.86l11.73,71.82a46.68,46.68,0,0,1-38.55,53.61l-9.56,1.56s79.9-7.28,73.49-65.09l-9.56-58.55a42.74,42.74,0,0,0-26.07-33c-.38-.16-.77-.31-1.16-.45-11.16-4.05-26.71-5.94-47.95-1.58C784.66,448.7,788.17,485.13,788.17,485.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M863.29,593.91l28.49-115.2S940.1,554.43,904.5,578C904.5,578,891.38,587.59,863.29,593.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M788.17,485.13l11.69,71.59a46.93,46.93,0,0,0,53.87,38.75l9.56-1.56a46.69,46.69,0,0,0,38.55-53.61l-11.73-71.82s-2.17,16-19.6,26.86v0c-6.56,4.08-15.29,7.42-26.88,8.92-13.85,1.81-24.44.65-32.47-1.82l-.46-.12c-11.94-3.77-18.06-10.42-20.77-14.24a19.52,19.52,0,0,1-1.74-2.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M806.37,475.79l4.79,26.68c8,2.46,18.62,3.62,32.48,1.82,11.57-1.5,20.29-4.86,26.85-8.93h0c17.45-10.87,19.61-26.88,19.61-26.88s-1.92-18.62-32.5-18.28a68.24,68.24,0,0,0-8.82.69c-1.29.15-2.56.36-3.81.62h-.1a76.39,76.39,0,0,0-19.19,6.5C816.86,462.38,807,468.75,806.37,475.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M847.74,469c3.64,4.39,9.32,11.34,4.75,14.58,10.87-5.47,12.86-14.42,12.86-14.42l5.16,26.15c17.44-10.86,19.6-26.86,19.6-26.86s-1.92-18.62-32.5-18.28a68.24,68.24,0,0,0-8.82.69l-3.91.63S841.31,461.29,847.74,469Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M806.37,475.79l3,16.82,1.76,9.86c8,2.46,18.62,3.62,32.48,1.82,11.57-1.5,20.29-4.86,26.85-8.93h0v0l-5.16-26.15s-2,8.95-12.86,14.42a7.14,7.14,0,0,1-2.2,1,39.24,39.24,0,0,1-8.12,2.32l-1.19.21C814.15,491.43,806.37,475.79,806.37,475.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M844,486.65s-2.12,2.18-1,9.39a33.69,33.69,0,0,0,2.41,7.95s-11,1.85-17.89,1.11a44.37,44.37,0,0,1-2.26-9,34.07,34.07,0,0,1,.18-8.62A63.76,63.76,0,0,0,844,486.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M901.37,555.14s-.09.71-.28,2A3.81,3.81,0,0,0,901.37,555.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M796.17,534.1l3.69,22.62a46.93,46.93,0,0,0,53.87,38.75l9.56-1.56a46.67,46.67,0,0,0,37-31.88c.39-2,.67-3.73.85-4.91-3.68,9.65-38.06,31.49-67.94,20.38C801.32,565.66,796.17,534.1,796.17,534.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M807.82,483.86s-1.88,11.74-17.89,4.24c0,0,19.73,18.11,37.62,17C827.55,505.1,813,501.78,807.82,483.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M891.44,451.71a37.15,37.15,0,0,0,27.85,30.11l-1.63-10a42.74,42.74,0,0,0-26.07-33A36.9,36.9,0,0,0,891.44,451.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M853.73,595.46s2.6,12.25,24.28,11.7a17.21,17.21,0,0,0,10-3.53,29.87,29.87,0,0,0,6.52-6.8,27.72,27.72,0,0,0,3.88-8.12,30.44,30.44,0,0,0,1.19-7.64h0l-1.21.53h0c-2.63,1.12-9.41,3.86-20.3,7.23h0c-4.23,1.32-9.08,2.72-14.55,4.15q-4.57,1.22-9.73,2.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M883,606.3s-17.46-3.65-18-13.67l-11.24,2.84S860.75,613.38,883,606.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M890.05,590.1a4.93,4.93,0,0,0,2.79,6.4,4.68,4.68,0,0,0,1.71.33,27.72,27.72,0,0,0,3.88-8.12,5,5,0,0,0-8.38,1.39Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "_3_Leaves",
  "data-name": "3 Leaves"
}, /*#__PURE__*/React.createElement("g", {
  id: "_3_Leaves-2",
  "data-name": "3 Leaves"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M488,622.09l-13.56,1.17c7.85-64.32-27.52-106.25-60.86-144.14-11-12.46-21.71-24.49-30.63-36.73-18.06-24.8-15.06-48.12-13.64-71.75s1.27-47.31-22.66-73.21C310.52,258.34,312.09,228,312.09,228c24.13,15.37,56.93,34.78,78.39,47.32l.16.1c13.09,7.65,21.92,12.72,21.92,12.72,55.84,39.43,77.6,106.68,84.27,170.54C505.68,543.38,488,622.09,488,622.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M496.83,458.7l-.14.3s-43.75-11.35-55.82-48.21c-3.13-9.56-4.36-21.09-5.42-33.5-.93-10.8-1.72-22.26-3.51-33.66-4.1-25.92-13.39-51.51-41.3-68.19,13.09,7.65,21.92,12.72,21.92,12.72C468.4,327.59,490.16,394.84,496.83,458.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-36",
  d: "M457.48,359.85a17.92,17.92,0,0,1-17.92,17.92,17.38,17.38,0,0,1-4.11-.48c-.93-10.8-1.72-22.26-3.51-33.66a17.92,17.92,0,0,1,25.54,16.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M596.42,479.62h0a74.69,74.69,0,0,1-9,19.82c-29.81,45.7-91.28,62.67-85.25,133.48H492s-.12-.48-.32-1.41c-3-13.52-24.83-121.1,26.15-172.52,44.45-44.84,59.65-79.37,61.07-101.47a44.07,44.07,0,0,0-.7-11.92l-.06-.31-.18-.78.07.15c.32.75,1.82,4.27,3.9,9.85C590.57,377.65,609.28,436.18,596.42,479.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M521.8,515.18c-45.94,51-29.32,116.26-29.32,116.26l-.78.08c-3-13.52-24.83-121.1,26.15-172.52,44.45-44.84,59.65-79.37,61.07-101.47a44.07,44.07,0,0,0-.7-11.92l-.06-.31-.18-.78.07.15c.32.75,1.82,4.27,3.9,9.85C602.06,428,565.52,466.7,521.8,515.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M596.42,479.62h0c-1.34-24-27.52-11.94-20.89-56.62,2.08-14.05,3.67-46.69,3.4-65.48a91.12,91.12,0,0,0-.7-11.92l-.06-.31q-.09-.44-.18-.78l.07.15C579.71,348.54,612.38,425.7,596.42,479.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M448.17,522.36c-11-12.46-55.16-68.66-65.24-80-22.86-25.67-14.09-64.62-14.15-100.46,6.46,45.44,7.32,52.59,39.51,68.86C476.49,445.28,438.6,502.91,448.17,522.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M446.19,609.9H433.56s10-56.94-58.71-93.53-111.15,4.46-148-149.57h0c.41.55,13.68,18.12,50.28,21.85,37.18,3.79,131,16.74,157.1,96.79C454.81,548.54,446.65,596.67,446.19,609.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M446.19,609.9h-5.78C435,500.34,401.46,478.19,359,468,304.52,455,254.39,415,226.82,366.81c.41.55,13.68,18.12,50.28,21.85,37.18,3.79,131,16.74,157.1,96.79C454.81,548.54,446.65,596.67,446.19,609.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M269.52,387.65s4.33,21.81,31.69,24.43,40.4-1,57.78,13.61,25.8-1.72,39.4,6.46c0,0-38-32.71-91.92-39.42C306.47,392.73,277,389.16,269.52,387.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-36",
  d: "M584.11,460.11s4.89-12,0-24.13-8.59-13-8.59-13S569.82,448.6,584.11,460.11Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Big_Leaves_Left",
  "data-name": "Big Leaves Left"
}, /*#__PURE__*/React.createElement("g", {
  id: "Big_Leaves_Left-2",
  "data-name": "Big Leaves Left"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M63.81,564.53H-1.14V305.2A59.26,59.26,0,0,1,18.5,279,46,46,0,0,1,40.27,291.3c-2.34-9.67-7.27-15.46-11.7-18.82,19-10.24,41-12.41,52.48-12.8h.15c4.87-.16,7.83,0,7.83,0-11.67,29.56-17,39.25-10.24,63.25.5,1.8,1.08,3.68,1.73,5.66,4.77,14.64,13.4,34.5,26.89,65.44a128.74,128.74,0,0,1,6.35,18.07h0C136.21,495.14,63.81,564.53,63.81,564.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M203.77,543s30.26,5.68,46.53-16.28,17.31-36.94,17.31-36.94-22.68,2.84-35.13,26.94C218.51,543.71,203.77,543,203.77,543Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M176,506.69s20.33,3.18,32-2.33c0,0-4,24.27-29.45,37.12-10.43,5.26-12.76,8.82-12.76,8.82s-28.33-2-60.1-1.7A436.66,436.66,0,0,0,60.58,551s-19.57-43.38,42-72c64.89-30.22,89.11-44.51,85.66-76.44,0,0,37.2,41.09,24.11,83.8C212.31,486.36,204.22,502.55,176,506.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M127.58,510.48c-24.07,17.6-22.18,36.06-21.88,38.12A436.66,436.66,0,0,0,60.58,551s-19.57-43.38,42-72c64.89-30.22,89.11-44.51,85.66-76.44C211.73,473.33,156.88,489,127.58,510.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M38.52,366.8C55.13,431.52,86.75,467,35.87,553.49l-29.38,11H-1.14V305.2A59.26,59.26,0,0,1,18.5,279,46,46,0,0,1,40.27,291.3c-2.34-9.67-7.27-15.46-11.7-18.82,19-10.24,41-12.41,52.48-12.8h8S21.9,302.08,38.52,366.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-38",
  d: "M113.76,412.1A51.52,51.52,0,0,0,89,402.56C74.68,401.22,60,382.65,68.81,369c7.88-12.25,15.3-24.66,11.71-40.38,4.77,14.64,13.4,34.5,26.89,65.44A128.74,128.74,0,0,1,113.76,412.1Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-38",
  cx: 86.63,
  cy: 421.62,
  r: 11.73
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grassy_Plant",
  "data-name": "Grassy Plant"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grassy_Plant-2",
  "data-name": "Grassy Plant"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M1472,1037.91c0,1.49.08,3,.1,4.44l-57.54,18.34s-45.12-54.44-90.94-182c-15.45-43.05-14.13-109.85-49-183.72l-3.45-69.24a15.67,15.67,0,0,1,0-2.74,11,11,0,0,1,.54-2.58c2.07-6.24,6.74-12.27,12.2-16.73,2.53-1.53,4.36-2.64,4.68-2.92,8-5.92,18.37-6.51,27.61-4.56a33.65,33.65,0,0,1,7.23,2.38,33.28,33.28,0,0,1,10.21,7.29C1378.6,652.65,1467.94,860,1472,1037.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-39",
  d: "M1300.66,771.35s-1.15-37.14,9.43-56.42c8.1-14.77-1-33.42-16.42-44.43s-26-43.15-9.8-66.78l-35.33,30.56S1277.34,701.06,1300.66,771.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1205.59,671.6,1242,743.85c7.52,14.9,29.92,10.11,30.68-6.55l2.85-61.65-.22-2.37-1.81-20.87c-1.64-18.95-6.54-35,10.42-48.69a38.51,38.51,0,0,1,8.62-5.34l-72.15,32.21A30,30,0,0,0,1205.59,671.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1472,1037.91l-17,4.77s-3.94-13.58-64.21-206.57-116.2-210.82-116.2-210.82a16.13,16.13,0,0,1-3.45-2.26,11,11,0,0,1,.54-2.58c2.07-6.24,6.74-12.27,12.2-16.73,2.53-1.53,4.36-2.64,4.68-2.92,8-5.92,18.37-6.51,27.61-4.56a33.65,33.65,0,0,1,7.23,2.38,33.28,33.28,0,0,1,10.21,7.29C1378.6,652.65,1467.94,860,1472,1037.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M1777.19,670.42a30,30,0,0,0-37.41-22.35l-73.51,20.63a33.92,33.92,0,0,1,27.39,4,13.38,13.38,0,0,1,3.78,3.79l28.26,41.32L1767,763.74c11.16,12.41,31.51,1.9,27.88-14.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M1442.12,1050.77S1340.3,629.59,1493.79,456.1c6.26-7.08,17.78-4.73,20.36,4.35,6.65,23.41-1.85,72,9.59,127.07,27,129.8,42.55,291.64-29.81,448.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1472.55,1042.79s-18.19-50.24-6.75-76.63,32.63-30.82,25.56-70.12c-6.51-36.2-5.94-52.06,13.35-71.07a128.22,128.22,0,0,0,33.48-57.85c3.46-12.72,5.19-35.12,5.53-45.17,0,0,11.13,126.56-14.42,214.57s-30,91.3-30,91.3l-4.83,8.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M1472.06,1042.36l52.62-12.6s166.32-140,201-311.91l-28.34-41.44a12.92,12.92,0,0,0-3.58-3.6,34,34,0,0,0-27.51-4.11,34.56,34.56,0,0,0-7.06,2.88,33.79,33.79,0,0,0-9.72,7.94C1607.34,729.57,1514.44,856.24,1472.06,1042.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-39",
  d: "M1554.92,920.9s3.64-72.27,58.53-77c55.46-4.84,82.36-36.68,82.36-36.68s-45.37,90.33-89.1,137.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1417.26,897.21s62.19-130.5,50.62-238.87-13.83-158.09,26.2-204.38C1494.08,454,1371.66,565.44,1417.26,897.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1776.94,669.53l3.25,14.52c-2.6-11-15.66-10.51-28.59-6.13s-22.32-3.51-17.64-13.83-8.57-12-8.57-12l15.24-4.28A29.12,29.12,0,0,1,1776.94,669.53Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-15",
  cx: 1767.48,
  cy: 697.13,
  r: 9.16
}), /*#__PURE__*/React.createElement("g", {
  id: "Grass_Leaf_1",
  "data-name": "Grass Leaf 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M1407.08,1012.85s-8.83-.78-17-1.83c-3.06-.4-6-.83-8.41-1.28,0,0-29.75-33.9-60.42-49.69-46.41-23.9-70.83-64.66-71.79-66.32L1276.91,864l7.37-8a18.48,18.48,0,0,1,5.92-4.43,47.06,47.06,0,0,1,38.37,0C1374.43,883.64,1407.08,1012.85,1407.08,1012.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1176.21,831.62l-7.59,19.84-.09.23-32.34,84.59c-8.25,21.56,17.54,40.07,35.33,25.29l65.75-54.63,12.16-13.21h0l29.93-32.46,0,0,4.86-5.27a18.38,18.38,0,0,1,5.93-4.43,47,47,0,0,1,38.36,0l-96.61-43A41.57,41.57,0,0,0,1176.21,831.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-40",
  d: "M1288.34,882.37c14.75,19,34.12,32.74,34.12,32.74,42.16,39.72,60.47,77.18,67.62,95.91"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Lotus_2",
  "data-name": "Lotus 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lotus_2-2",
  "data-name": "Lotus 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-33",
  d: "M1166.24,632.34s28.07,114.77-68,306.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M1162.25,662.12a169,169,0,0,1,.82,33.45c5.49,5.88,12.9,1.88,12.9,1.88a209.88,209.88,0,0,0,.21-29.13A122.8,122.8,0,0,1,1162.25,662.12Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1167.86,
  cy: 632.93,
  r: 159.64
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1170.65,
  cy: 628.14,
  r: 116.06
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1172.21,567.62a136,136,0,0,1,7.59,24.6,85.4,85.4,0,0,1,17.54-18.51,52.15,52.15,0,0,1,10.79,14.9,138.41,138.41,0,0,1,12.58-11s-1-26.27-26-45.16C1194.67,532.44,1173.67,554.1,1172.21,567.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1172.21,567.62a115.92,115.92,0,0,1,7.59,24.6L1194,579.93s0-9-8-10.79-10.67-4.2-11.24-9.78A26.31,26.31,0,0,0,1172.21,567.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1256.24,597.39s-5.76,4.53-10.46,8.35c-2.22,1.81-4.21,3.46-5.24,4.39,0,0,2.77-10.63,5-20.43,3.89-17.4-4.42-38.05-7.38-41C1238.66,549,1255.47,558.76,1256.24,597.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1211,595.68a49.77,49.77,0,0,1,.8,27.89,25.92,25.92,0,0,0,10.22-5.14,69.41,69.41,0,0,1,12.3-8.48c.16,1.72.27,3.39.33,5,2.36-1.84,4.41-3.5,5.89-4.82h0c.1-.39,2.81-10.81,5-20.42,3.9-17.4-4.41-38.05-7.37-41h0a67.62,67.62,0,0,1-4.6,12.17h0c-2.78,5.72-6.94,12.24-12.82,16.75a138.3,138.3,0,0,0-12.53,11l0,0A52.86,52.86,0,0,1,1211,595.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1118.34,577.91c1.64,1.26,7.5,6,8.48,9.46a37.36,37.36,0,0,1,6-4.88,190.29,190.29,0,0,0,11.37,19.73h0a40.28,40.28,0,0,1,6-2,68.14,68.14,0,0,1,25.4-1.43c1.29-2.2,2.7-4.41,4.26-6.61-.58-2.8-1.38-6.25-2.51-10.14a132.15,132.15,0,0,0-5.07-14.46c-5.29-12.66-13.61-26.73-26.55-37.55a74.9,74.9,0,0,0-14.15,13.9,64.65,64.65,0,0,0-10.07,17.74A50.64,50.64,0,0,0,1118.34,577.91Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-38",
  cx: 1164.38,
  cy: 623.02,
  rx: 32.27,
  ry: 26.33
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M1111.56,630.9a33.3,33.3,0,0,0,3.48,12.57c.21.39.42.78.65,1.17s.31.56.48.83c.31.52.63,1,1,1.51C1130,665.69,1160,667.5,1160,667.5a39.86,39.86,0,0,0,4.27-15.2c.1-1.23.15-2.47.15-3.71a56.26,56.26,0,0,0-1.84-14.06c-2.88-11.24-8.72-21.3-14.39-27.24a43,43,0,0,1-4-5.07h0a190.29,190.29,0,0,1-11.37-19.73,37.36,37.36,0,0,0-6,4.88h0l-.52.53-.54.54c-.35.37-.72.76-1.09,1.18a51.55,51.55,0,0,0-12.8,28c-.23,1.74-.4,3.55-.48,5.43A62,62,0,0,0,1111.56,630.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1111.87,617.59a35.64,35.64,0,0,0,2.8,7.36c.25.47.48.91.74,1.35s.36.64.55,1c.35.59.72,1.17,1.12,1.73,7.46,10.88,20,16.76,30.5,19.92a11.92,11.92,0,0,0,15-14.23s0-.09,0-.14c-2.88-11.24-8.72-21.3-14.39-27.24a43,43,0,0,1-4-5.07h0a190.29,190.29,0,0,1-11.37-19.73,37.36,37.36,0,0,0-6,4.88h0l-.52.53-.54.54c-.35.37-.72.76-1.09,1.18-.76.83-1.53,1.74-2.3,2.72a51.15,51.15,0,0,0-7.77,14.06A54.14,54.14,0,0,0,1111.87,617.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1068.13,658.58s14.89,41.34,56.28,34.24c27.11-4.65,35.29-24.67,35.54-25.3v0s-23.13-1.39-37.46-14.42l0,0a34.46,34.46,0,0,1-5.32-6.07,31.37,31.37,0,0,1-2.11-3.51,88.09,88.09,0,0,0-10.74.51c-2.15.23-4.49.56-6.9,1l-1.17.23c-1.07.22-2.14.47-3.22.75a44.2,44.2,0,0,0-11.9,4.74l-5.38,3.26,0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1068.13,658.58s14.9,41.34,56.29,34.24c27.11-4.65,35.29-24.67,35.53-25.3-.55.54-22.28,21.64-48.61,12.31C1084.66,670.39,1068.13,658.58,1068.13,658.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1081.12,650.71A44.13,44.13,0,0,1,1093,646a79.15,79.15,0,0,1,11.29-2c-42.55-13-40.89-57.82-40.89-57.82C1051.21,626.7,1081.12,650.71,1081.12,650.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1104.3,644a88.23,88.23,0,0,1,10.75-.51,33.12,33.12,0,0,1-3.49-12.57,61.86,61.86,0,0,1-.16-7.88s-5.31-5.73-13.31-12.89a1.62,1.62,0,0,1-.2-.18l-.47-.41c-9.26-8.21-21.87-18.11-34-23.38C1063.41,586.16,1061.75,631,1104.3,644Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1082.39,597.39s5.76,4.53,10.46,8.35c2.22,1.81,4.21,3.46,5.24,4.39,0,0-2.78-10.63-5-20.43-3.9-17.4,4.41-38.05,7.38-41C1100,549,1083.16,558.76,1082.39,597.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1093.12,589.7c2.15,9.61,4.86,20,5,20.42h0c8,7.16,13.31,12.89,13.31,12.89a52.16,52.16,0,0,1,13.27-33.39c.74-.83,1.47-1.57,2.16-2.25h0c-1-3.5-6.84-8.2-8.48-9.46l-.43-.31c-12.69-9.74-17.41-28.94-17.41-28.94h0C1097.53,551.65,1089.22,572.3,1093.12,589.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1181.05,671.94c4,6.33,13.74,17.56,33.16,20.88,41.39,7.1,56.28-34.24,56.28-34.24l-4.38-2.66h0l-8.58-5.2a44.2,44.2,0,0,0-11.9-4.74c-1.08-.28-2.16-.53-3.23-.75l-1.16-.23c-2.41-.45-4.75-.78-6.9-1-1.69-.18-3.27-.3-4.67-.38h0a32.39,32.39,0,0,1-6.07,9.46C1209.65,668.76,1193.56,672.3,1181.05,671.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1181.06,672c4,6.32,13.73,17.55,33.15,20.87,41.39,7.1,56.29-34.24,56.29-34.24s-16.53,11.81-43.22,21.25c-18.67,6.62-35-2.08-43.16-7.88C1183.08,672,1182.05,672,1181.06,672Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1257.51,650.71a44.26,44.26,0,0,0-11.89-4.74,79.39,79.39,0,0,0-11.29-2c42.55-13,40.89-57.82,40.89-57.82C1287.42,626.7,1257.51,650.71,1257.51,650.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1229.66,643.6c1.39.09,3,.2,4.66.38,42.55-13,40.9-57.82,40.9-57.82-7.77,3.37-15.11,6.85-22,11.76-8.12,5.79-18.6,16.82-18.57,17.65C1235.07,628.26,1232.45,637.49,1229.66,643.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1160,667.52a50.34,50.34,0,0,0,9.2,2.91,64.38,64.38,0,0,0,8.54,1.33c1.08.09,2.21.15,3.37.19,1,0,2,0,3.06,0,12-.29,26.65-4.43,39.46-18.88a32.74,32.74,0,0,0,6.08-9.47c2.79-6.11,5.41-15.34,5-28,0-.2,0-.41,0-.62-.05-1.61-.16-3.28-.33-5a70.3,70.3,0,0,0-12.29,8.48,26,26,0,0,1-10.23,5.14h0a57.61,57.61,0,0,1-14.45,1.42c-8.62,0-24.33,7.34-32.41,23.68A49.79,49.79,0,0,0,1160,667.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M1159.88,667.52a51.31,51.31,0,0,0,9.2,2.91,62.71,62.71,0,0,0,8.53,1.32c1.09.09,2.21.16,3.37.19,1,0,2,0,3.07,0,12-.29,26.64-4.44,39.46-18.88a32.74,32.74,0,0,0,6.08-9.47,54.47,54.47,0,0,0,3.45-10.42,31.84,31.84,0,0,1-5.71,8.67c-12.81,14.45-27.45,18.6-39.46,18.89-1,0-2.07,0-3.06,0-1.16,0-2.29-.1-3.37-.19a63,63,0,0,1-8.54-1.33C1167.22,657.93,1160.38,660.38,1159.88,667.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1162.54,634.53c1.17,4.55,2.17,10.86,1.72,15.58l.67-1.43c8.08-16.34,23.79-23.68,32.41-23.68a57.61,57.61,0,0,0,14.45-1.42h0a49.68,49.68,0,0,0-.8-27.89c-.12-.35-.23-.71-.35-1s-.31-.86-.46-1.28-.32-.83-.49-1.24a.61.61,0,0,0,0-.12c-.15-.36-.3-.72-.46-1.08-.34-.79-.7-1.56-1.06-2.3a52.15,52.15,0,0,0-10.79-14.9,85.4,85.4,0,0,0-17.54,18.51c-1.56,2.2-3,4.41-4.26,6.61A103.61,103.61,0,0,0,1162.54,634.53Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 1151.63,
  cy: 603.82,
  rx: 2.56,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 1156.28,
  cy: 609.95,
  rx: 2.56,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 1164.74,
  cy: 608.53,
  rx: 2.56,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 1160.86,
  cy: 602.1,
  rx: 2.56,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 1169.65,
  cy: 602.1,
  rx: 2.56,
  ry: 1.6
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-45",
  d: "M1168.46,613.36s-7.62,2.19-14.6,1.27"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1156.28,618.72s4.93,9.06,6.26,15.81A129.72,129.72,0,0,1,1167.1,617s-1-.62-2.72,2.62S1158,621.63,1156.28,618.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1118.34,577.91c1.64,1.26,7.5,6,8.48,9.46a37.36,37.36,0,0,1,6-4.88,190.29,190.29,0,0,0,11.37,19.73h0c.19-.08,12.59-4.39,16.25-5.33-11.7-.67-6.59-5.49-11.35-10.77-4.38-4.85-8.56,2.12-16.44-6.72-3.1-3.48.19-11.53-9.53-21.76C1120.23,563.38,1118.47,572.07,1118.34,577.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-46",
  d: "M1208.17,588.57c1.8,3.52,4.31,9.33,4.67,14.8,0,0,9.82-4.56,10-11.8s1.62-10.18,6.06-13.88,3.57-9.06,4.65-16.85c-2.78,5.72-6.94,12.24-12.82,16.75A138.3,138.3,0,0,0,1208.17,588.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M1164.26,650.12l.67-1.44c8.08-16.34,23.79-23.68,32.41-23.68a57.56,57.56,0,0,0,14.45-1.42h0a50,50,0,0,0,.51-23.05c-1.51,9.8-10.61,9.35-15.63,9.43s-7.38-.08-15.94,4.9c-5.93,3.45-9.88-.22-11.74-2.82a97.23,97.23,0,0,0-6.45,22.5C1163.72,639.08,1164.71,645.4,1164.26,650.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1164.74,648.68s11.72-6.7,20-4.7,20.35,1.51,23.62-9.45a27.34,27.34,0,0,1,9.33-13.3,28.25,28.25,0,0,1-6.05,2.34h0a57.61,57.61,0,0,1-14.45,1.42C1188.54,625,1172.83,632.34,1164.74,648.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1134.26,602.22c3.54,7.06,9.15,3.21,12.69,14.72,4.31,14,13.16,14.45,15.59,17.4-2.89-11.17-8.69-21.15-14.33-27.05a43,43,0,0,1-4-5.07h0a188.76,188.76,0,0,1-11.34-19.7l0,0S1130.71,595.16,1134.26,602.22Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-42",
  cx: 1222.19,
  cy: 626.37,
  r: 5.13
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1114.6,606.41a8.37,8.37,0,1,0,7.77-14.06A51.15,51.15,0,0,0,1114.6,606.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1229.64,643.61c.6.08,5.49.94,16.89,9,12.19,8.59,19.58,3.35,19.58,3.35h0l-8.58-5.2a44.2,44.2,0,0,0-11.9-4.74c-1.08-.28-2.16-.53-3.23-.75l-1.16-.23c-2.41-.45-4.75-.78-6.9-1-1.69-.18-3.27-.3-4.67-.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1075.71,654a16.68,16.68,0,0,1,16.39,3.21c7.86,6.69,17.9,6.11,20.85,1.38s9.55-5.5,9.55-5.5l0,0a79.84,79.84,0,0,1-7.43-9.58,88.09,88.09,0,0,0-10.74.51c-2.15.23-4.49.56-6.9,1l-1.17.23c-1.07.22-2.14.47-3.22.75a44.2,44.2,0,0,0-11.9,4.74l-5.38,3.26Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-41",
  cx: 1234.57,
  cy: 655.47,
  r: 4.92
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-46",
  d: "M1131.51,544l3.78,2.44c3.77,2.43,9.74,3.54,13.78,2.26s8.35,3.35,15.31,17.48c6.52,13.25,12.22,15.68,12.9,15.93a132.15,132.15,0,0,0-5.07-14.46c-5.29-12.66-13.61-26.73-26.55-37.55A74.9,74.9,0,0,0,1131.51,544Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Money_Leaf_3",
  "data-name": "Money Leaf 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Money_Leaf_3-2",
  "data-name": "Money Leaf 3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-47",
  d: "M1031.84,701.53s-8.24,195,71.91,416"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1131.29,663.08c-1.27,24.07-45.81,41.3-99.45,38.46-22.3-1.18-42.67-5.64-58.77-12.21-22.61-9.15-36.82-22.45-36.07-36.53,1.28-24.08,45.79-41.3,99.45-38.47,34.26,1.84,64,11.4,80.64,24.36C1126.5,646,1131.76,654.39,1131.29,663.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M1131.29,663.08c-1.27,24.07-45.81,41.3-99.45,38.46-5.32-.28-10.56-.75-15.63-1.37-3.49-.44-6.92-1-10.28-1.59a174.06,174.06,0,0,1-18-4.17,130,130,0,0,1-14.83-5.08C963.66,682,958.43,673.67,958.9,665c1.24-24.08,45.78-41.31,99.45-38.47,22.3,1.18,42.64,5.64,58.74,12.18C1126.5,646,1131.76,654.39,1131.29,663.08Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-47",
  x1: 1019.73,
  y1: 652.84,
  x2: 1043.35,
  y2: 652.84
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M1131.29,663.08c-1.27,24.07-45.81,41.3-99.45,38.46-5.32-.28-10.56-.75-15.63-1.37,5.88-2.58,2.4-7.38,3.52-9.16,1.49-2.36,6.94-2.71,21.83-2.71s3.52-22.14,3.52-22.14-1.74-13.33,32.67-2.15S1131.76,654.39,1131.29,663.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M1007,694.16a9.24,9.24,0,0,1-1.09,4.42,174.06,174.06,0,0,1-18-4.17.55.55,0,0,1,0-.25,9.58,9.58,0,0,1,19.16,0Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Lotus_3",
  "data-name": "Lotus 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lotus_3-2",
  "data-name": "Lotus 3"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 230.79,
  cy: 299.51,
  r: 195.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 234.21,
  cy: 293.63,
  r: 142.28
}), /*#__PURE__*/React.createElement("g", {
  id: "Lotus_3-3",
  "data-name": "Lotus 3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-33",
  d: "M201.68,303.33s28.07,114.76-68,306.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M197.69,333.11a169,169,0,0,1,.82,33.45c5.49,5.87,12.9,1.87,12.9,1.87a209.87,209.87,0,0,0,.21-29.13A124.66,124.66,0,0,1,197.69,333.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M241.59,227.55a162,162,0,0,1,1.28,30.82,102.64,102.64,0,0,1,26-16.1,62.67,62.67,0,0,1,8,20.56c6.82-4.22,17.93-8.93,17.93-8.93s6.92-30.72-16.39-60.26C278.34,193.64,247.4,212.34,241.59,227.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M241.59,227.55s2.36,12.53,1.28,30.82l20.24-9.9s2.75-10.46-5.94-14.94-11.08-8.11-10-14.75C247.13,218.78,243.14,223.16,241.59,227.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M329.86,287.67s-8.05,3.5-14.66,6.48c-3.12,1.43-5.94,2.73-7.41,3.5,0,0,6.46-11.48,12-22.16,9.82-19,6.49-45.43,4-49.79C324.26,226.2,340.75,242.67,329.86,287.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M278,271.89a59.52,59.52,0,0,1-7.58,32.56,31.16,31.16,0,0,0,13.42-2.83,83.24,83.24,0,0,1,16.83-6.08c-.34,2-.72,4-1.15,5.89,3.3-1.41,6.18-2.7,8.3-3.79h0c.24-.41,6.56-11.66,12-22.15,9.82-19,6.49-45.42,4-49.78v0a81.2,81.2,0,0,1-9,12.7h0c-5,5.78-11.77,12.07-20,15.51,0,0-11.05,4.68-17.87,8.89l-.06,0A63.54,63.54,0,0,1,278,271.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M176,223.05c1.52,2,6.88,9.19,6.94,13.55a45.44,45.44,0,0,1,8.42-3.84s3.15,15.3,7.15,26.33h0a46.85,46.85,0,0,1,7.5-.47,82,82,0,0,1,29.87,6.1c2.16-2.16,4.47-4.29,7-6.36.18-3.42.3-7.67.18-12.52a157.49,157.49,0,0,0-1.47-18.3c-2.27-16.28-7.62-35.12-19.31-51.6a89.86,89.86,0,0,0-20.64,11.79,77.36,77.36,0,0,0-17.07,17.49A60.43,60.43,0,0,0,176,223.05Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-38",
  cx: 215.62,
  cy: 289.35,
  rx: 31.54,
  ry: 38.67,
  transform: "matrix(0.25, -0.97, 0.97, 0.25, -119.08, 424.24)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M152,282.38a39.58,39.58,0,0,0,.21,15.62c.12.53.24,1,.39,1.56s.19.74.3,1.11c.2.69.42,1.38.67,2.05,9.16,25.59,43.35,36.83,43.35,36.83a47.79,47.79,0,0,0,9.58-16.31c.49-1.4.93-2.82,1.31-4.26A67.77,67.77,0,0,0,210,302.13c.09-13.9-3.61-27.34-8.37-35.95a52.34,52.34,0,0,1-3.06-7.08h0c-4-11-7.15-26.33-7.15-26.33A45.44,45.44,0,0,0,183,236.6h0l-.77.45-.79.46c-.52.33-1.07.67-1.62,1a61.66,61.66,0,0,0-23.35,28.49q-1.22,2.93-2.22,6.14A77.81,77.81,0,0,0,152,282.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M156.44,267.05a42.58,42.58,0,0,0,1,9.39c.15.61.28,1.2.44,1.79.12.42.23.84.36,1.26.22.79.48,1.58.77,2.35,5.32,14.88,18.05,25.51,29.26,32.38A14.29,14.29,0,0,0,210,302.3a1,1,0,0,1,0-.17c.09-13.9-3.61-27.34-8.37-35.95a52.34,52.34,0,0,1-3.06-7.08h0c-4-11-7.15-26.33-7.15-26.33A45.44,45.44,0,0,0,183,236.6h0l-.77.45-.79.46c-.52.33-1.07.67-1.62,1-1.13.73-2.3,1.55-3.49,2.46A60.86,60.86,0,0,0,163,254.93,64.06,64.06,0,0,0,156.44,267.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M93.25,301.21S97.91,353.64,148,358c32.82,2.89,48.41-17.82,48.88-18.47l0,0s-26.38-8.67-39-28.13l0,0a41.73,41.73,0,0,1-4.33-8.66,38.29,38.29,0,0,1-1.36-4.72,108,108,0,0,0-12.61-2.68c-2.56-.39-5.36-.72-8.3-.93-.47,0-.95-.06-1.42-.09-1.31-.07-2.63-.12-4-.12A53.12,53.12,0,0,0,110.7,296c-2.85.85-5.24,1.56-7.24,2.14l0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M93.25,301.21s4.66,52.44,54.78,56.84c32.83,2.88,48.41-17.83,48.89-18.48-.8.45-32.41,18.28-60.08-.56C108.8,319.93,93.25,301.21,93.25,301.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M110.7,296.05a53.19,53.19,0,0,1,15.23-1.87,95,95,0,0,1,13.69,1.15c-45.34-28.06-29.75-79.47-29.75-79.47C83.37,259.11,110.7,296.05,110.7,296.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M139.62,295.33a105.65,105.65,0,0,1,12.6,2.68,39.82,39.82,0,0,1-.21-15.63,75.24,75.24,0,0,1,2.22-9.18s-4.41-8.26-11.5-19l-.17-.27-.42-.63c-8.22-12.33-19.81-27.64-32.27-37.45C109.87,215.86,94.28,267.27,139.62,295.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M128.44,234.66s5.28,7,9.57,12.86c2,2.78,3.82,5.3,4.72,6.69,0,0,0-13.17.48-25.19.79-21.34,16.72-42.74,21.06-45.29C163.57,183.91,141.11,190.13,128.44,234.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M143.21,229c-.44,11.8-.48,24.7-.47,25.18h0c7.09,10.73,11.5,19,11.5,19,5.67-18.44,16.92-29,25.56-34.64,1.11-.73,2.18-1.37,3.18-1.95h0c-.07-4.36-5.43-11.59-6.95-13.54l-.39-.5c-11.74-15.16-11.36-38.83-11.36-38.83h0C159.93,186.28,144,207.68,143.21,229Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M220,351.13c2.73,8.55,10.56,24.52,32,34.29,45.79,20.84,75.65-22.51,75.65-22.51l-4.27-4.41v0c-1.87-1.91-4.53-4.68-8.36-8.64a53,53,0,0,0-12.34-9.12c-1.16-.65-2.34-1.26-3.51-1.84-.43-.22-.85-.43-1.28-.63-2.66-1.26-5.27-2.35-7.69-3.27-1.9-.73-3.7-1.34-5.29-1.86h0c-5.36,6.59-9.92,9.11-9.92,9.11C254.12,356.16,234.41,355.35,220,351.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M220,351.13c2.73,8.55,10.57,24.52,32,34.3,45.79,20.84,75.66-22.51,75.66-22.51s-22.75,8.64-56.55,11.44c-23.66,2-40-13.09-47.61-22.29C222.35,351.78,221.17,351.47,220,351.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M315.09,349.83a53.45,53.45,0,0,0-12.34-9.11A94.27,94.27,0,0,0,290.27,335c53.27-2.11,65-54.53,65-54.53C357.06,331.13,315.09,349.83,315.09,349.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M285,333.11c1.59.52,3.38,1.14,5.29,1.86,53.27-2.11,65-54.53,65-54.53-10,1.54-19.59,3.34-29,6.92-11.17,4.24-26.68,13.82-26.9,14.8C295.92,317,290.08,326.87,285,333.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M196.92,339.57a61.39,61.39,0,0,0,9.77,6.18,75.12,75.12,0,0,0,9.48,4.13c1.24.44,2.52.85,3.85,1.25,1.15.34,2.33.65,3.55.94,14,3.33,32.23,3,51.48-9.84,0,0,4.56-2.53,9.93-9.12,5.1-6.24,10.94-16.12,14.35-30.95.06-.23.11-.48.17-.72.43-1.89.81-3.85,1.14-5.9a83.24,83.24,0,0,0-16.83,6.08,31.1,31.1,0,0,1-13.42,2.83h0a68.45,68.45,0,0,1-17.18-2.76c-10-2.63-30.43,1.09-44.77,17.55A59.87,59.87,0,0,0,196.92,339.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M196.84,339.55a60.55,60.55,0,0,0,9.76,6.17,75.9,75.9,0,0,0,9.49,4.14c1.23.43,2.52.85,3.85,1.25,1.14.33,2.33.64,3.54.94,14,3.32,32.23,3,51.48-9.85,0,0,4.56-2.52,9.93-9.11a64.39,64.39,0,0,0,7.18-11c-5.08,6-9.26,8.3-9.26,8.3-19.25,12.83-37.48,13.17-51.48,9.85-1.21-.3-2.39-.61-3.54-1-1.33-.39-2.62-.81-3.85-1.24a75.07,75.07,0,0,1-9.48-4.14C208.26,330.67,199.59,331.43,196.84,339.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M210,302.14c0,5.62-.81,13.24-2.77,18.57l1.22-1.46c14.34-16.46,34.79-20.18,44.77-17.55a68.45,68.45,0,0,0,17.18,2.76h0A59.51,59.51,0,0,0,278,271.9c0-.45-.05-.9-.09-1.33s-.09-1.09-.14-1.62-.12-1.06-.19-1.59a.89.89,0,0,0,0-.15c-.06-.47-.12-.93-.2-1.4-.16-1-.33-2-.53-3a62.67,62.67,0,0,0-8-20.56,102.64,102.64,0,0,0-26,16.1q-3.72,3.12-7,6.37A123.93,123.93,0,0,0,210,302.14Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 206.7,
  cy: 263.23,
  rx: 1.92,
  ry: 3.07,
  transform: "matrix(0.25, -0.97, 0.97, 0.25, -100.47, 396.13)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 210.22,
  cy: 271.75,
  rx: 1.92,
  ry: 3.07,
  transform: "translate(-106.08 405.88) rotate(-75.26)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 220.46,
  cy: 272.68,
  rx: 1.92,
  ry: 3.07,
  transform: "translate(-99.35 416.48) rotate(-75.26)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 217.91,
  cy: 264.05,
  rx: 1.92,
  ry: 3.07,
  transform: "matrix(0.25, -0.97, 0.97, 0.25, -92.9, 407.59)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 228.11,
  cy: 266.73,
  rx: 1.92,
  ry: 3.07,
  transform: "translate(-87.89 419.44) rotate(-75.26)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-45",
  d: "M223.29,279.41s-9.49.21-17.31-3"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M207.55,281.9s2.94,12,2.43,20.24A154.33,154.33,0,0,1,220.6,283.2s-.93-1-3.94,2.21S208.62,285.79,207.55,281.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M176,223.05c1.52,2,6.88,9.19,6.94,13.55a45.44,45.44,0,0,1,8.42-3.84s3.15,15.3,7.15,26.33h0c.23,0,15.92-1.26,20.45-1.23-13.36-4.34-6-8.36-9.87-15.94-3.59-7-10.57-.15-17-12.79-2.53-5,3.73-13.31-4.4-28.12C182.65,206.79,178,216.32,176,223.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-46",
  d: "M276.86,262.79c1,4.63,2.15,12.13.89,18.58,0,0,12.78-2.3,15.16-10.64s5-11.3,11.25-14.23,6.9-9.41,10.53-18.11c-5,5.78-11.77,12.07-20,15.51C294.73,253.9,283.68,258.58,276.86,262.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M207.21,320.72l1.22-1.47c14.35-16.46,34.79-20.18,44.77-17.55,5.64,1.48,11.43,2.75,17.18,2.76h0A60.12,60.12,0,0,0,278,277.9c-4.73,10.9-15.14,7.6-21,6.16s-8.52-2.34-20,.82c-7.91,2.19-11.37-3.27-12.74-6.84A116.69,116.69,0,0,0,210,302.14C210,307.76,209.18,315.38,207.21,320.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M208.22,319.19s15.61-4.18,24.58.66,23.11,7.94,30.24-3.75a32.79,32.79,0,0,1,14.87-12.57,33.81,33.81,0,0,1-7.73.87h0A68.45,68.45,0,0,1,253,301.64C243,299,222.56,302.73,208.22,319.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M187.06,256.07c1.95,9.26,9.62,6.51,10.22,20.92.71,17.55,10.84,20.76,12.76,24.92.06-13.82-3.63-27.15-8.36-35.71a50.74,50.74,0,0,1-3.06-7.09h0c-3.88-10.68-7-25.38-7.14-26.28,0,0,0-.05,0-.05S185.1,246.81,187.06,256.07Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-42",
  cx: 281.58,
  cy: 310.86,
  r: 6.15
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M163,254.93A10,10,0,1,0,176.3,241,60.86,60.86,0,0,0,163,254.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M285,333.11c.67.28,6.06,2.77,16.83,15.54,11.51,13.67,21.66,9.85,21.66,9.85v0c-1.87-1.91-4.53-4.68-8.36-8.64a53,53,0,0,0-12.34-9.12c-1.16-.65-2.34-1.26-3.51-1.84-.43-.22-.85-.43-1.28-.63-2.66-1.26-5.27-2.35-7.69-3.27-1.9-.73-3.7-1.34-5.29-1.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M103.44,298.2a20,20,0,0,1,18,8.72c7.06,10.15,18.87,12.54,23.74,8s12.74-3.46,12.74-3.46l0,0A94,94,0,0,1,152.22,298a108,108,0,0,0-12.61-2.68c-2.56-.39-5.36-.72-8.3-.93-.47,0-.95-.06-1.42-.09-1.31-.07-2.63-.12-4-.12A53.12,53.12,0,0,0,110.7,296c-2.85.85-5.24,1.56-7.24,2.14Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-41",
  cx: 287.05,
  cy: 348.36,
  r: 5.89
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-46",
  d: "M201.63,187.74l3.64,4c3.63,4,10.2,7.07,15.28,6.82S229.21,205,233,223.46c3.52,17.34,9.38,21.89,10.09,22.39a157.49,157.49,0,0,0-1.47-18.3c-2.27-16.28-7.62-35.12-19.31-51.6A89.86,89.86,0,0,0,201.63,187.74Z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Multicoloured_Flower_4",
  "data-name": "Multicoloured Flower 4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Multicoloured_Flower_4-2",
  "data-name": "Multicoloured Flower 4"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1737.02,
  cy: 641.37,
  r: 153.74
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1737.02,
  cy: 644.37,
  r: 111.77
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1737.02,
  cy: 647.33,
  r: 78.42
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-48",
  d: "M1740.77,700.16s3.58,133.44-49.58,229.44"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M1737.35,617.07c-1.41-3-24.24-57-45.17-47.81,0,0-5.07,2-6.34,9.17s-14.58,1-17.75,6.63,1.27,9.68-4.44,13.25-33.6,24.65,55.8,38.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1726.62,622.4c-4.88-8-17.16-28.1-23.81-28.38-9-.37-3,4.8-6.61,8.4s-10.16-1.32-10.36,5.06c-.27,8.67,36.66,19.42,36.66,19.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1756.51,654.85s26.3,52.17,16.57,73.59c-3.17,7-13.42,10.06-21.69,6.7-4.13-1.67-9.91-3.6-14-3.31-7.12.51-57.35,14.21-4-77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M1720.86,643.3s-96.52,30.28-59.22,64c3.5,3.16,8.32,3.89,12.1,6.43,3.62,2.42,3.63,6.92,7.5,9.1,7.22,4.06,19.86-2.54,23-7.83,4.76-8,24-35.86,29.1-60.16a34.85,34.85,0,0,1-9.14-6.1A11.43,11.43,0,0,1,1720.86,643.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1724.13,648.83q-9.54,5.16-18.68,10.79c-5.44,3.35-10.77,6.83-15.89,10.5a45.89,45.89,0,0,0-8.26,7.09c-1.5,1.75-2.67,4.17-1.17,5.92a5.46,5.46,0,0,0,3.56,1.56c1.37.14,3.72,1.08,3.64,3.31a3.26,3.26,0,0,0,2.18,2.91c1.71.72,3.8.14,5.49-.59a40.75,40.75,0,0,0,8.67-5.38,80.83,80.83,0,0,0,15.75-16.07,62.53,62.53,0,0,0,8.92-16.74A13.64,13.64,0,0,1,1724.13,648.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1630.38,658.56c.7,6.47,13.92,9.76,20.4,8.42,6.28-1.29,23.21-4,40.93-8.8h0l.12,0a179,179,0,0,0,28.78-10.07,21,21,0,0,1,0-8.75,10.22,10.22,0,0,1,2.84-5.09s-83.32-36.89-91,4.08c-.7,3.83,1.49,7,1.49,10.63C1634,652.43,1630,655.08,1630.38,658.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1720.52,639.35q-10.14-2.39-20.45-4.25c-6.14-1.11-12.32-2.08-18.55-2.82a57.08,57.08,0,0,0-11.08-.51c-2.42.18-5.22.93-5.87,2.82a3.12,3.12,0,0,0,.72,2.92,2.62,2.62,0,0,1-.77,4,2.73,2.73,0,0,0-1.27,3c.38,1.39,2.11,2.24,3.75,2.76a44.51,44.51,0,0,0,9.82,1.75,107.31,107.31,0,0,0,23.36-.52,93.79,93.79,0,0,0,19.91-4.79A8.72,8.72,0,0,1,1720.52,639.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M1713.08,577.68c2.6,16.8,14.39,38.45,15.33,40.33l29.63,4.72c54.48-58.59,16.17-59,9-58.55s-7.35-4.95-14.39-7.36-11.74,9.31-18.65,4.74-12.38-3.34-12.38-3.34a10.9,10.9,0,0,0-4.85,2.16C1712.53,563.79,1711.91,570.26,1713.08,577.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1740.8,616.12c-3.13-8.56-11-30-6.27-33.86,6.31-5.15,6.25,1.91,11.92,2.61s6.39-6.48,11.9-1.88c7.47,6.24-10.73,34.22-10.73,34.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1746,656.28a258.94,258.94,0,0,0,12.53,23.11l0,.07c9.45,15.58,23.15,34.29,37,40.1,8.21,3.43,18.34.15,21.64-6.82,1.63-3.48,4.29-8,7.56-10.07,5.69-3.47,54.24-20.62-61.69-59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M1763.09,643.7c24.2,15.14,61.74,25.25,72,28.61,6.74,2.18,21.6.21,23.53-6.71,1-3.71-2.74-7-2.13-10.8s3.62-7.06,3.53-11.31A23,23,0,0,0,1857,631.9c-5.2-8.73-16.5-12.29-29.52-13.09-28.35-1.76-64.87,9.6-64.87,9.6a10.54,10.54,0,0,1,2.14,5.84A23.28,23.28,0,0,1,1763.09,643.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1764.82,634.27q11.39-1.38,22.85-2.18c6.84-.48,13.68-.8,20.54-.87a62.81,62.81,0,0,1,12,.74c2.58.49,5.47,1.63,5.83,3.74a3.61,3.61,0,0,1-1.3,3.08,2.82,2.82,0,0,0,.09,4.42,2.83,2.83,0,0,1,.84,3.33c-.66,1.45-2.69,2.16-4.55,2.54a49.76,49.76,0,0,1-10.92.73,115.23,115.23,0,0,1-25.12-3.31A96.25,96.25,0,0,1,1764.5,639,9.32,9.32,0,0,0,1764.82,634.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1753.08,623.13a15.61,15.61,0,0,1,6.36,2.23,28.68,28.68,0,0,1,7.36,6.47c3.47-.61,7-1.38,10.57-2.3l.2,0,1.66-.43c23.8-6.36,47.36-17.92,55-21.21a18.51,18.51,0,0,0,8.72-9.06c1.29-2.95,1.38-6-.75-8.21-2.66-2.74-7.8-2.58-10.72-5.14s-4.09-6.21-7.85-8.66C1783.56,550.72,1753.08,623.13,1753.08,623.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1759.53,625.31q5.49-7.26,11.52-14.22c3.6-4.16,7.34-8.23,11.31-12.15a43.1,43.1,0,0,1,7.74-6.39c1.94-1.18,4.65-2.14,6.71-1.11a3.69,3.69,0,0,1,1.93,2.55,3.58,3.58,0,0,0,3.93,2.55,4,4,0,0,1,3.42,1.48c.88,1.23.31,2.79-.45,4.07a30.72,30.72,0,0,1-5.78,6.62A84.31,84.31,0,0,1,1782.19,621a88.18,88.18,0,0,1-18.72,7.27A12.57,12.57,0,0,0,1759.53,625.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1741,656.77c-3.68,8.41-12.88,29.54-8.46,33.55,6,5.4,6.36-1.64,12.08-2.11s6,6.74,11.75,2.38c7.88-5.92-8.49-34.62-8.49-34.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1759.06,649.27c9.78,4.21,34.32,14.81,34.42,20.16.14,7.23-6.08,2.24-10.68,5s1.27,8.21-6.67,8.13c-10.79-.09-22.82-30.14-22.82-30.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M1716.67,639.11c0,12.08,12.21,21.89,27.27,21.89s27.24-9.81,27.24-21.89a16.24,16.24,0,0,0-.47-4c-2.28-10.23-13.4-17.95-26.77-17.95s-24.52,7.72-26.8,17.95A16.24,16.24,0,0,0,1716.67,639.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1717.14,635.16c2.31,10.21,13.43,18,26.8,18s24.46-7.74,26.77-18a20.8,20.8,0,0,0-8.23-12.06v0a30.87,30.87,0,0,0-18.54-5.87,7.86,7.86,0,0,0-.85,0C1730.07,617.54,1719.36,625.14,1717.14,635.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1736.87,630.42c2.51,5.68,10.28,8.64,17.35,6.62s10.77-8.24,8.26-13.94v0a30.87,30.87,0,0,0-18.54-5.87,7.86,7.86,0,0,0-.85,0C1737.37,619.77,1734.63,625.31,1736.87,630.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1630.38,658.56c.7,6.47,13.92,9.76,20.4,8.42,6.28-1.29,23.21-4,40.93-8.8-2.42.38-33.45,5-41.22-1.08-8.09-6.31-12.61-3.47-16.52-8.14C1634,652.43,1630,655.08,1630.38,658.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1777.42,629.51l.15,0,1.66-.43c23.8-6.36,47.36-17.92,55-21.21a18.51,18.51,0,0,0,8.72-9.06s-12.2,4.93-29.34,3.62S1790.07,624.77,1777.42,629.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1758.51,679.39l0,.07c9.45,15.58,23.15,34.29,37,40.1,8.21,3.43,18.34.15,21.64-6.82,0,0-18.37,7.62-26.92-9.2S1769,680.85,1758.51,679.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1826.12,624.09c0,7.53,7.59,13.63,17,13.63a18.43,18.43,0,0,0,13.9-5.82c-5.2-8.73-16.5-12.29-29.52-13.09A11.07,11.07,0,0,0,1826.12,624.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-53",
  d: "M1713.08,577.68c9.08,10.7,19.24,28.9,20,30.2-.35-1.27-6-22-6.42-30.84-.29-5.82-5.87-12.53-9.9-16.66C1712.53,563.79,1711.91,570.26,1713.08,577.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-54",
  d: "M1748.29,661s3.32,49,27,57.45c0,0-1.16-14.68-1.84-17.27,0,0-20.66-30.11-22.09-41Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-52",
  cx: 1809.17,
  cy: 583.03,
  r: 6.58
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-53",
  cx: 1672.86,
  cy: 607.88,
  r: 6.58
}))), /*#__PURE__*/React.createElement("g", {
  id: "Lavender_1",
  "data-name": "Lavender 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lavender_1-2",
  "data-name": "Lavender 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1639.53,591s-16.86,6-32.63,2.63c0,0-4.44-7.51,1.75-32.2l23.37-9.71,12.8,18.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1628.27,593.71s-5.43-12.85,2.62-25.1l8.64,3s-4.85,10.19,0,19.42C1639.53,591,1635.83,592.88,1628.27,593.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1727.88,499.26a16,16,0,1,1,1.69-13.4A16,16,0,0,1,1727.88,499.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1727.6,490.47a16,16,0,0,1-28.81-3.64,16,16,0,0,1,30.78-1A16,16,0,0,1,1727.6,490.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1712.36,485.2c-5.92-2.69-9.23-2.93-13.57,1.63a16,16,0,0,1,24-9.65S1718.27,487.89,1712.36,485.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1724.18,523.73a16,16,0,0,1-29.09-12.42,15.8,15.8,0,0,1,2-4.61,16,16,0,0,1,27.11,17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1723.9,515a16,16,0,0,1-28.81-3.64,15.8,15.8,0,0,1,2-4.61,16,16,0,0,1,28.79,3.63A15.68,15.68,0,0,1,1723.9,515Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1708.66,509.68c-5.93-2.69-9.23-2.93-13.57,1.63a15.8,15.8,0,0,1,2-4.61,16,16,0,0,1,22.07-5S1714.57,512.36,1708.66,509.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1708.23,503.75a19.79,19.79,0,0,1-36-15.35,19.52,19.52,0,0,1,2.44-5.7,19.79,19.79,0,0,1,33.51,21.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1707.87,492.89a19.77,19.77,0,0,1-35.59-4.5,19.58,19.58,0,0,1,2.44-5.69,19.78,19.78,0,0,1,35.59,4.49A19.52,19.52,0,0,1,1707.87,492.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1689,486.38c-7.32-3.32-11.4-3.62-16.76,2a19.58,19.58,0,0,1,2.44-5.69,19.78,19.78,0,0,1,27.28-6.23S1696.35,489.69,1689,486.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1676.79,512.87a18.18,18.18,0,1,1,1.91-15.2A18.17,18.17,0,0,1,1676.79,512.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1676.47,502.9a18.17,18.17,0,0,1-32.68-4.12,18.18,18.18,0,0,1,27.28-10.95,18,18,0,0,1,7.63,9.84A18,18,0,0,1,1676.47,502.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1659.18,496.93c-6.72-3.05-10.46-3.33-15.39,1.85a18.18,18.18,0,0,1,27.28-10.95S1665.89,500,1659.18,496.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1677,542.2a16,16,0,1,1,1.68-13.4A16,16,0,0,1,1677,542.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1676.7,533.42a16,16,0,0,1-28.8-3.64,16,16,0,0,1,30.77-1A15.71,15.71,0,0,1,1676.7,533.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1704.71,536.15a20,20,0,0,1-36.26-15.48,20.26,20.26,0,0,1,2.46-5.75,19.93,19.93,0,0,1,35.8,4.24c0,.09.06.19.1.29A19.9,19.9,0,0,1,1704.71,536.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1704.35,525.2a20,20,0,0,1-35.9-4.53,20.26,20.26,0,0,1,2.46-5.75,19.93,19.93,0,0,1,35.8,4.24c0,.09.06.19.1.29A20,20,0,0,1,1704.35,525.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1685.36,518.63c-7.38-3.35-11.5-3.65-16.91,2a20,20,0,0,1,30-12S1692.73,522,1685.36,518.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1697.34,567.92a20,20,0,1,1,2.1-16.7A20,20,0,0,1,1697.34,567.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1697,557a19.94,19.94,0,0,1-35.89-4.53,19.95,19.95,0,0,1,38.35-1.22A19.48,19.48,0,0,1,1697,557Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1678,550.41c-7.38-3.35-11.49-3.66-16.9,2a20,20,0,0,1,30-12S1685.37,553.75,1678,550.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1678.36,590.28a23.2,23.2,0,0,1-42.15-18,23.69,23.69,0,0,1,2.86-6.68,23.19,23.19,0,0,1,32-7.29,23.6,23.6,0,0,1,3.52,2.7,22.94,22.94,0,0,1,5.27,7.38,24,24,0,0,1,1,2.48A23.15,23.15,0,0,1,1678.36,590.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1677.94,577.55a23.19,23.19,0,0,1-41.73-5.27,23.69,23.69,0,0,1,2.86-6.68,23.19,23.19,0,0,1,32-7.29,23.6,23.6,0,0,1,3.52,2.7,22.94,22.94,0,0,1,5.27,7.38,24,24,0,0,1,1,2.48A23.17,23.17,0,0,1,1677.94,577.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1655.87,569.92c-8.58-3.89-13.37-4.24-19.66,2.37a23.22,23.22,0,0,1,34.84-14S1664.44,573.81,1655.87,569.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1629.92,552.57a20,20,0,1,1,2.09-16.71A20,20,0,0,1,1629.92,552.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1629.56,541.61a19.95,19.95,0,0,1-35.9-4.53,20,20,0,0,1,38.36-1.22A19.74,19.74,0,0,1,1629.56,541.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1610.57,535.05c-7.38-3.35-11.5-3.65-16.91,2a20,20,0,0,1,30-12S1617.94,538.39,1610.57,535.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1656.61,529.5A20,20,0,0,1,1620.36,514h0a20,20,0,0,1,30-12c.26.16.52.33.76.5.51.35,1,.71,1.44,1.09a19.27,19.27,0,0,1,1.61,1.51h0a18.47,18.47,0,0,1,1.43,1.66,19.9,19.9,0,0,1,3.16,6,20.29,20.29,0,0,1,.94,5.2A19.81,19.81,0,0,1,1656.61,529.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1656.25,518.55c-.19.31-.39.61-.61.91a19.94,19.94,0,0,1-35.28-5.44,20,20,0,0,1,30-12c.26.16.52.33.76.5.51.35,1,.71,1.44,1.09a19.27,19.27,0,0,1,1.61,1.51,16,16,0,0,1,1.42,1.66,19.9,19.9,0,0,1,3.16,6A19.59,19.59,0,0,1,1656.25,518.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1637.26,512c-7.38-3.35-11.5-3.65-16.9,2a19.59,19.59,0,0,1,2.46-5.75,19.94,19.94,0,0,1,27.51-6.28S1644.64,515.33,1637.26,512Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1699,493a16,16,0,0,1-29.1-12.42,16.29,16.29,0,0,1,2-4.62A16,16,0,0,1,1699,493Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1698.74,484.19a16,16,0,0,1-20.54,5.89,16.1,16.1,0,0,1-8.27-9.52,16,16,0,0,1,30.78-1A15.93,15.93,0,0,1,1698.74,484.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1683.5,478.92c-5.92-2.69-9.23-2.93-13.57,1.63a16.36,16.36,0,0,1,2-4.61,16,16,0,0,1,22.07-5S1689.42,481.61,1683.5,478.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M1681.5,487.82a5,5,0,0,1-3.3,2.26,15.82,15.82,0,0,1-6-5,4.84,4.84,0,0,1,.76-2.59,5,5,0,1,1,8.53,5.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1725.19,478.66a16,16,0,1,1,1.69-13.4A16,16,0,0,1,1725.19,478.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1724.91,469.87a16,16,0,0,1-28.81-3.63,16,16,0,0,1,30.78-1A15.81,15.81,0,0,1,1724.91,469.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1709.67,464.61c-5.92-2.69-9.23-2.93-13.57,1.63a16,16,0,0,1,24.05-9.65S1715.58,467.29,1709.67,464.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M1658.41,562.32a20,20,0,1,1,2.09-16.7A20,20,0,0,1,1658.41,562.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1658.05,551.37a19.95,19.95,0,0,1-35.9-4.53,19.95,19.95,0,0,1,38.35-1.22A19.45,19.45,0,0,1,1658.05,551.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1639.06,544.81c-7.38-3.35-11.5-3.66-16.91,2a20,20,0,0,1,30-12S1646.43,548.15,1639.06,544.81Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 1635.63,
  cy: 551.38,
  r: 5.04
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M1706.45,519.63a5,5,0,1,1-4-7.72,19.83,19.83,0,0,1,4.31,7.25C1706.63,519.32,1706.54,519.47,1706.45,519.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M1659.65,518a7.27,7.27,0,0,1-4,1.46,7.23,7.23,0,0,1-1.52-14.37h0a16,16,0,0,1,1.42,1.66,19.9,19.9,0,0,1,3.16,6A20.29,20.29,0,0,1,1659.65,518Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M1679.32,569.45a5.5,5.5,0,1,1-4.75-8.44,22.94,22.94,0,0,1,5.27,7.38A5.47,5.47,0,0,1,1679.32,569.45Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 1721.48,
  cy: 464.53,
  r: 2.39
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-56",
  d: "M1620.35,581.22s-172.18,142.14-121.52,465.62"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Orange_Tulip_3",
  "data-name": "Orange Tulip 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pink_Tulip_3",
  "data-name": "Pink Tulip 3"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1429.52,
  cy: 582.75,
  r: 121.65
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M1451.17,655.06s-33.34,10.65-59.78-13.76A74,74,0,0,1,1377,622.72c-.19-.34-.38-.66-.55-1-21.13-37.74-25.24-44.07-25.65-44.15.36-.14,2.23-.88,5.22-1.79h0a99.94,99.94,0,0,1,21.47-4.07h0c18.92-1.38,43.22,3.07,56.54,30.11a77.32,77.32,0,0,1,4.06,10h0a95.63,95.63,0,0,1,2.54,9.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M1434.07,601.84c-13.32-27-37.62-31.49-56.54-30.11h0c-2.36,0-4.73-11.55-5.75-19.94s-5.44-24-5.44-24a78.34,78.34,0,0,1,18.76,0c17.45,2.27,28.73,11.16,36,22.12C1433.64,568.82,1434.21,594,1434.07,601.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M1421.05,549.83v0s-11.43,12.66-26.07,3.2c0,0-6.4-4.14-7.6-17a20.63,20.63,0,0,0-2.33-8.34C1402.51,530,1413.79,538.87,1421.05,549.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1421.61,567.26s12.24,16.8,16.52,44.65c0,0-4.29-12.68-8.46-17.72,0,0-4.62-14-10.61-23.94A6.39,6.39,0,0,0,1421.61,567.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1419.05,570.25a7.77,7.77,0,0,1-10.78-2l-6.07-8.77a7.76,7.76,0,0,1-.66-7.65,7.68,7.68,0,0,1,2.63-3.13,7.55,7.55,0,0,1,2.75-1.2,7.77,7.77,0,0,1,8,3.16l6.07,8.76a8.48,8.48,0,0,1,.89,1.68A7.82,7.82,0,0,1,1419.05,570.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M1421.91,561.14a7.62,7.62,0,0,1-2.63,3.13,7.75,7.75,0,0,1-10.78-2l-6.07-8.76a8,8,0,0,1-.89-1.68,7.68,7.68,0,0,1,2.63-3.13,7.55,7.55,0,0,1,2.75-1.2,7.77,7.77,0,0,1,8,3.16l6.07,8.76A8.48,8.48,0,0,1,1421.91,561.14Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 1409.62,
  cy: 553.44,
  r: 3.44
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1421.61,567.26s2.88,4.53,3.77,6.18a4.73,4.73,0,0,1-3,3l-3.38-6.23h0A7.7,7.7,0,0,0,1421.61,567.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M1438.13,611.89c-11.51-16.82-37.6-11.18-46-25.65S1356,575.8,1356,575.8h0a99.94,99.94,0,0,1,21.47-4.07h0c18.92-1.38,43.22,3.07,56.54,30.11A77.32,77.32,0,0,1,1438.13,611.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M1401.29,625.44a13.43,13.43,0,0,1-9.9,15.86A74,74,0,0,1,1377,622.72c-.19-.34-.38-.66-.55-1a13.41,13.41,0,0,1,24.84,3.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M1443.49,656.72s34.76-4,48.81-37.15a74.12,74.12,0,0,0,5.48-22.86c0-.38.07-.75.1-1.12,3.72-43.08,4.86-50.54,5.2-50.79-.38,0-2.39.12-5.5.52h0a99.65,99.65,0,0,0-21.24,5.13l0,0c-17.82,6.53-38.13,20.59-39.14,50.71a76.43,76.43,0,0,0,.44,10.83v0a92.87,92.87,0,0,0,1.5,9.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M1437.17,601.17c1-30.12,21.32-44.18,39.14-50.71l0,0c2.15-1-.45-12.48-3-20.54s-4.94-24.16-4.94-24.16a77.59,77.59,0,0,0-17.1,7.71c-15,9.24-21.59,22-23.7,35C1424,570.9,1433.83,594.12,1437.17,601.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1434.3,564.53s-4.24,20.35,3.31,47.49c0,0-1.3-13.33.42-19.62,0,0-1.56-14.69-.18-26.2A6.43,6.43,0,0,1,1434.3,564.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1437.85,566.2a7.75,7.75,0,0,0,9-6.22l1.93-10.49a7.8,7.8,0,0,0-2.55-7.25,7.68,7.68,0,0,0-3.68-1.77,7.75,7.75,0,0,0-9,6.22l-1.92,10.49a7.64,7.64,0,0,0-.11,1.9A7.79,7.79,0,0,0,1437.85,566.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M1431.51,559.08a7.75,7.75,0,0,0,12.7-4.46l1.93-10.48a8.15,8.15,0,0,0,.11-1.9,7.68,7.68,0,0,0-3.68-1.77,7.75,7.75,0,0,0-9,6.22l-1.92,10.49A7.64,7.64,0,0,0,1431.51,559.08Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 1439.53,
  cy: 547,
  r: 3.44
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1434.3,564.53s-.77,5.32-.89,7.18a4.71,4.71,0,0,0,3.93,1.56s.52-7.08.51-7.07h0A7.69,7.69,0,0,1,1434.3,564.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M1407,651.74s11.86-17.15,31.46-18.61,47.1,8.12,58.26-28.23c0,0-1,33.76-45.5,50.16C1451.17,655.06,1430.9,661.56,1407,651.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M1442.12,579.38s15.38-12.24,33.45-14.34c0,0,9-2,18.39-13.36,0,0,5-7.52,9.12-6.88C1503.08,544.8,1457.56,546.33,1442.12,579.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M1429.52,540.56s2.52-7.68,14.17-10.19,14.77-20.74,14.77-20.74S1434.5,517.08,1429.52,540.56Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-57",
  cx: 1464.15,
  cy: 528.35,
  r: 4.65
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1477.65,640.57s1.9,28.26-21.14,36.33a35.48,35.48,0,0,1-4.14,1.16c-32.1,7-38.7-23.71-38.7-23.71s16.91,6.28,38.31,0A74.07,74.07,0,0,0,1477.65,640.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M1477.65,640.57s1.9,28.26-21.14,36.33c6-4.43,12.4-17.89,2.17-21.49a16.29,16.29,0,0,0-7.51-.35l.81-.75A74.07,74.07,0,0,0,1477.65,640.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M1452.37,678.06s57,217.54-37.09,342.06"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Lavender_2",
  "data-name": "Lavender 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lavender_2-2",
  "data-name": "Lavender 2"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-25",
  x: 512.25,
  y: 128.91,
  width: 161.9,
  height: 253.74,
  rx: 77.64,
  transform: "translate(-43.51 146.66) rotate(-13.6)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M592.39,319.18s9.54,11.1,22.1,15.11c0,0,6.2-3.52,11.83-23.56l-12.64-16.38L597.24,302Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M599.28,325.68s9.08-6.91,8.33-18.88l-7.33-1.41s-.7,9.21-7.89,13.79C592.39,319.18,594.26,322,599.28,325.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M566.54,218.58a13.12,13.12,0,1,0,4.14-10.23A13.1,13.1,0,0,0,566.54,218.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M570.25,212.42a13.09,13.09,0,0,0,22,8.89,13.08,13.08,0,0,0-21.58-13A13.05,13.05,0,0,0,570.25,212.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M583.23,214.74c5.3.44,7.75,1.58,9,6.57a13.1,13.1,0,0,0-13.32-16.48S577.93,214.29,583.23,214.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M559.43,237.53a13.1,13.1,0,1,0,4.14-10.24A13.09,13.09,0,0,0,559.43,237.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M563.14,231.37a13.09,13.09,0,0,0,22,8.89,13.09,13.09,0,0,0-21.58-13A12.86,12.86,0,0,0,563.14,231.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M576.12,233.68c5.3.45,7.75,1.59,9,6.58a13.1,13.1,0,0,0-13.32-16.48S570.82,233.24,576.12,233.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M578.79,229.62A16.18,16.18,0,1,0,583.9,217,16.18,16.18,0,0,0,578.79,229.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M583.37,222a16.17,16.17,0,0,0,27.2,11,16.18,16.18,0,0,0-26.67-16A15.87,15.87,0,0,0,583.37,222Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M599.41,224.87c6.54.54,9.58,2,11.16,8.12a16.19,16.19,0,0,0-16.46-20.36S592.86,224.32,599.41,224.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M597.59,248.66a14.86,14.86,0,1,0,4.7-11.61A14.86,14.86,0,0,0,597.59,248.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M601.8,241.68a14.85,14.85,0,0,0,25,10.08,14.85,14.85,0,0,0-24.48-14.71A14.48,14.48,0,0,0,601.8,241.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M616.52,244.3c6,.5,8.79,1.8,10.25,7.46a14.88,14.88,0,0,0-15.12-18.69S610.52,243.8,616.52,244.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M585.76,269.53a13.1,13.1,0,1,0,4.14-10.24A13.08,13.08,0,0,0,585.76,269.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M589.47,263.37a13.08,13.08,0,0,0,22,8.88,13.09,13.09,0,0,0-21.58-13A12.83,12.83,0,0,0,589.47,263.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M568.38,254.16a16.32,16.32,0,1,0,11.31-16.38,16,16,0,0,0-6,3.45l-.19.17A16.31,16.31,0,0,0,568.38,254.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M573,246.48a16.31,16.31,0,0,0,27.44,11.07A16.34,16.34,0,0,0,583.83,237a16.21,16.21,0,0,0-4.14.76,16,16,0,0,0-6,3.45l-.19.17A16.12,16.12,0,0,0,573,246.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M589.18,249.36c6.6.55,9.66,2,11.26,8.19A16.34,16.34,0,0,0,583.83,237S582.58,248.81,589.18,249.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M561,279.78a16.32,16.32,0,0,0,32,3.39,16.12,16.12,0,0,0,.54-5.08A16.32,16.32,0,0,0,561,279.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M565.6,272.1A16.31,16.31,0,0,0,593,283.17a16.12,16.12,0,0,0,.54-5.08A16.31,16.31,0,0,0,566.14,267,16.12,16.12,0,0,0,565.6,272.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M581.77,275c6.61.55,9.67,2,11.26,8.19a16.12,16.12,0,0,0,.54-5.08,16.32,16.32,0,0,0-17.14-15.45S575.18,274.43,581.77,275Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M565.62,303.31a19,19,0,0,0,37.26,3.94,18.58,18.58,0,0,0,.62-5.9,19,19,0,0,0-19.92-18,20.18,20.18,0,0,0-3.59.53,18.74,18.74,0,0,0-6.7,3.17,15.78,15.78,0,0,0-1.67,1.39A18.92,18.92,0,0,0,565.62,303.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M571,294.39a19,19,0,0,0,31.89,12.86,18.58,18.58,0,0,0,.62-5.9,19,19,0,0,0-19.92-18,20.18,20.18,0,0,0-3.59.53,18.74,18.74,0,0,0-6.7,3.17,15.78,15.78,0,0,0-1.67,1.39A18.93,18.93,0,0,0,571,294.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M589.79,297.74c7.68.63,11.24,2.29,13.09,9.52a18.67,18.67,0,0,0,.62-5.91,19,19,0,0,0-19.92-18S582.13,297.1,589.79,297.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M615.24,295.69a16.34,16.34,0,1,0,5.16-12.76A16.31,16.31,0,0,0,615.24,295.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M619.86,288a16.31,16.31,0,0,0,27.43,11.07,16.34,16.34,0,0,0-16.6-20.53,16.15,16.15,0,0,0-10.29,4.38A15.56,15.56,0,0,0,619.86,288Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M636,290.89c6.61.55,9.66,2,11.26,8.19a16.34,16.34,0,0,0-16.6-20.53S629.43,290.34,636,290.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M605.37,268.58a16.32,16.32,0,0,0,32,3.4h0a16.09,16.09,0,0,0,.54-5.08,16.32,16.32,0,0,0-17.13-15.45l-.75.06c-.49.05-1,.12-1.46.21a14.26,14.26,0,0,0-1.74.43h0a15.21,15.21,0,0,0-1.68.61,16.14,16.14,0,0,0-4.67,3.06,16.38,16.38,0,0,0-2.74,3.34A16.19,16.19,0,0,0,605.37,268.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M610,260.9a8.66,8.66,0,0,0,.07.89A16.3,16.3,0,0,0,637.42,272a16.09,16.09,0,0,0,.54-5.08,16.32,16.32,0,0,0-17.13-15.45l-.75.06c-.49.05-1,.12-1.46.21a14.26,14.26,0,0,0-1.74.43,13.46,13.46,0,0,0-1.68.62,16.14,16.14,0,0,0-4.67,3.06A15.87,15.87,0,0,0,610,260.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M626.17,263.78c6.6.55,9.66,2,11.26,8.2a16.52,16.52,0,0,0,.53-5.09,16.32,16.32,0,0,0-17.14-15.45S619.57,263.23,626.17,263.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M589.65,225.6a13.1,13.1,0,1,0,4.14-10.24A13.09,13.09,0,0,0,589.65,225.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M593.35,219.44a13.09,13.09,0,0,0,12.32,12.39,11.36,11.36,0,0,0,1.43,0,13.19,13.19,0,0,0,8.27-3.51,13.09,13.09,0,0,0-21.58-13A12.86,12.86,0,0,0,593.35,219.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M606.33,221.75c5.3.45,7.76,1.59,9,6.58A13.1,13.1,0,0,0,602,211.85S601,221.31,606.33,221.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M604.21,228.9a4.07,4.07,0,0,0,1.46,2.93,11.36,11.36,0,0,0,1.43,0,12.79,12.79,0,0,0,4.85-1.21,4,4,0,0,0,.49-2.15,4.12,4.12,0,0,0-8.23.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M576.67,205a13.1,13.1,0,1,0,4.14-10.24A13.1,13.1,0,0,0,576.67,205Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M580.38,198.79a13.09,13.09,0,0,0,22,8.89,13.09,13.09,0,0,0-21.58-13A12.86,12.86,0,0,0,580.38,198.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M593.36,201.1c5.3.44,7.75,1.59,9,6.58a13.1,13.1,0,0,0-13.32-16.48S588.06,200.66,593.36,201.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M591,291.3a16.32,16.32,0,0,0,32,3.39,16.12,16.12,0,0,0,.54-5.08A16.32,16.32,0,0,0,591,291.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M595.63,283.62a16.31,16.31,0,0,0,27.43,11.07,16.12,16.12,0,0,0,.54-5.08,16.31,16.31,0,0,0-27.43-11.07A16.12,16.12,0,0,0,595.63,283.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M611.8,286.5c6.61.55,9.67,2,11.26,8.19a16.12,16.12,0,0,0,.54-5.08,16.32,16.32,0,0,0-17.14-15.45S605.21,286,611.8,286.5Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 611.63,
  cy: 292.56,
  r: 4.12
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M573.73,241.67a4.12,4.12,0,1,0,6-3.89,16,16,0,0,0-6,3.45A3.23,3.23,0,0,0,573.73,241.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M607.79,259.16a6,6,0,0,0,5.74,3.55,5.92,5.92,0,0,0,3.35-10.56h0a13.46,13.46,0,0,0-1.68.62,16.14,16.14,0,0,0-4.67,3.06A16.38,16.38,0,0,0,607.79,259.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M573.24,288.05a4.5,4.5,0,1,0,6.75-4.13,18.74,18.74,0,0,0-6.7,3.17A4.35,4.35,0,0,0,573.24,288.05Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 584.96,
  cy: 196.34,
  r: 1.95
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-56",
  d: "M610,320s64.51,170.77-102.76,379.8"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Lavender_3",
  "data-name": "Lavender 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lavender_3-2",
  "data-name": "Lavender 3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-25",
  x: 715.11,
  y: 311.39,
  width: 101.76,
  height: 144.97,
  rx: 44.04,
  transform: "translate(239.23 -291.86) rotate(25.44)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Lavender_3-3",
  "data-name": "Lavender 3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M768.71,414.65s-7.77,5.91-16.52,6.77c0,0-3.55-3.16-4.43-17l10.52-8.92,9.66,7.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M763.31,417.93a15.54,15.54,0,0,1-2.81-13.48l5,.11s-.83,6.1,3.23,10.09A19.74,19.74,0,0,1,763.31,417.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M799.37,352.34a8.73,8.73,0,0,1-17.17-1.62,9,9,0,0,1,.26-2.72,8.73,8.73,0,0,1,16.91,4.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M797.77,347.83a8.73,8.73,0,0,1-15.57,2.89,9,9,0,0,1,.26-2.72A8.72,8.72,0,0,1,798,345.11,8.75,8.75,0,0,1,797.77,347.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M789,347.62c-3.52-.41-5.28,0-6.78,3.1a9,9,0,0,1,.26-2.72,8.72,8.72,0,0,1,10.63-6.28S792.5,348,789,347.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M801.51,365.67a8.74,8.74,0,1,1-1.35-7.24A8.73,8.73,0,0,1,801.51,365.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M799.9,361.15A8.73,8.73,0,0,1,784.34,364a8.73,8.73,0,0,1,15.82-5.61A8.44,8.44,0,0,1,799.9,361.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M791.12,361c-3.53-.42-5.28,0-6.78,3.09a8.74,8.74,0,0,1,10.89-9S794.63,361.36,791.12,361Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M789.91,357.94a10.81,10.81,0,1,1-1.67-8.95A10.8,10.8,0,0,1,789.91,357.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M787.92,352.36a10.78,10.78,0,0,1-19.23,3.57A10.78,10.78,0,0,1,788.24,349,10.78,10.78,0,0,1,787.92,352.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M777.06,352.1c-4.35-.51-6.52,0-8.37,3.83a10.79,10.79,0,0,1,13.46-11.13S781.41,352.61,777.06,352.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M775.09,367.89a9.9,9.9,0,0,1-19.47-1.84,10.2,10.2,0,0,1,.29-3.09A9.9,9.9,0,0,1,768,355.84a9.9,9.9,0,0,1,7.12,12.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M773.27,362.77a9.9,9.9,0,0,1-17.65,3.28,10.2,10.2,0,0,1,.29-3.09,9.89,9.89,0,0,1,17.65-3.28A9.62,9.62,0,0,1,773.27,362.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M763.3,362.53c-4-.47-6,0-7.68,3.52a10.2,10.2,0,0,1,.29-3.09A9.91,9.91,0,0,1,768,355.83S767.29,363,763.3,362.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M780.06,383.09a8.7,8.7,0,1,1-1.34-7.24A8.72,8.72,0,0,1,780.06,383.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M778.46,378.58a8.73,8.73,0,0,1-15.57,2.89,8.73,8.73,0,0,1,15.83-5.62A8.79,8.79,0,0,1,778.46,378.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M793.46,375.35a10.88,10.88,0,1,1-7.83-13.25,11.05,11.05,0,0,1,2.61,1,10.82,10.82,0,0,1,3.44,3l.1.14A10.88,10.88,0,0,1,793.46,375.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M791.46,369.72a10.88,10.88,0,0,1-19.4,3.6,10.88,10.88,0,0,1,13.57-11.22,11.05,11.05,0,0,1,2.61,1,10.82,10.82,0,0,1,3.44,3l.1.14A10.93,10.93,0,0,1,791.46,369.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M780.5,369.46c-4.39-.51-6.58,0-8.44,3.86a10.88,10.88,0,0,1,13.57-11.22S784.89,370,780.5,369.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M794.9,393.08a10.88,10.88,0,0,1-21.4-2,10.65,10.65,0,0,1,.33-3.39,10.88,10.88,0,1,1,21.07,5.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M792.9,387.45a10.88,10.88,0,0,1-19.4,3.6,10.65,10.65,0,0,1,.33-3.39,10.88,10.88,0,0,1,19.39-3.61A11,11,0,0,1,792.9,387.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M782,387.19c-4.39-.52-6.58,0-8.45,3.86a10.65,10.65,0,0,1,.33-3.39,10.87,10.87,0,0,1,13.24-7.83S786.33,387.7,782,387.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M788.75,407.84a12.65,12.65,0,1,1-9.1-15.4,14,14,0,0,1,2.28.82,12.54,12.54,0,0,1,4,3,14.05,14.05,0,0,1,.91,1.13A12.6,12.6,0,0,1,788.75,407.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M786.42,401.3a12.64,12.64,0,0,1-22.54,4.18,12.64,12.64,0,0,1,15.77-13,14,14,0,0,1,2.28.82,12.54,12.54,0,0,1,4,3,14.05,14.05,0,0,1,.91,1.13A12.72,12.72,0,0,1,786.42,401.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M773.69,401c-5.1-.6-7.64,0-9.81,4.49a12.36,12.36,0,0,1,.38-3.94,12.64,12.64,0,0,1,15.39-9.1S778.79,401.59,773.69,401Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M757.34,396.28a10.9,10.9,0,1,1-1.69-9A10.88,10.88,0,0,1,757.34,396.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M755.33,390.66a10.88,10.88,0,0,1-19.39,3.6A10.87,10.87,0,0,1,749.51,383a10.74,10.74,0,0,1,6.14,4.22A10.4,10.4,0,0,1,755.33,390.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M744.38,390.4c-4.39-.52-6.58,0-8.44,3.86A10.87,10.87,0,0,1,749.51,383S748.77,390.91,744.38,390.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M767.37,379.88a10.88,10.88,0,0,1-21.4-2h0a10.88,10.88,0,0,1,13.56-11.22l.48.14a9.25,9.25,0,0,1,.93.32,12,12,0,0,1,1.08.52h0a11.53,11.53,0,0,1,1,.62,11,11,0,0,1,2.64,2.63A10.85,10.85,0,0,1,767,373.4,10.72,10.72,0,0,1,767.37,379.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M765.37,374.25c0,.19-.1.38-.17.57a10.87,10.87,0,0,1-19.22,3,10.88,10.88,0,0,1,13.56-11.22l.48.14a9.25,9.25,0,0,1,.93.32,12,12,0,0,1,1.08.52,10.24,10.24,0,0,1,1,.62,11,11,0,0,1,2.64,2.63A10.64,10.64,0,0,1,765.37,374.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M754.42,374c-4.39-.52-6.58,0-8.45,3.86a10.9,10.9,0,0,1,13.57-11.22S758.8,374.5,754.42,374Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M783.34,353.87a8.73,8.73,0,0,1-17.17-1.63,9.07,9.07,0,0,1,.26-2.72,8.73,8.73,0,0,1,16.91,4.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M781.74,349.36a8.73,8.73,0,0,1-9.69,6.46,7.42,7.42,0,0,1-.94-.18,8.66,8.66,0,0,1-3-1.44,8.55,8.55,0,0,1-1.93-2,9.07,9.07,0,0,1,.26-2.72A8.72,8.72,0,0,1,782,346.63,8.78,8.78,0,0,1,781.74,349.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M773,349.15c-3.52-.42-5.28,0-6.78,3.09a9.07,9.07,0,0,1,.26-2.72,8.73,8.73,0,0,1,10.63-6.28S776.47,349.56,773,349.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M773.39,354.1a2.76,2.76,0,0,1-1.34,1.72,7.42,7.42,0,0,1-.94-.18,8.66,8.66,0,0,1-3-1.44,2.62,2.62,0,0,1,0-1.47,2.75,2.75,0,0,1,5.33,1.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M794.56,342.09a8.73,8.73,0,0,1-17.17-1.62,8.41,8.41,0,0,1,.26-2.72,8.73,8.73,0,0,1,16.91,4.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M793,337.58a8.72,8.72,0,0,1-15.56,2.89,8.5,8.5,0,0,1,.26-2.73,8.72,8.72,0,0,1,15.56-2.89A8.5,8.5,0,0,1,793,337.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M784.16,337.37c-3.52-.42-5.27,0-6.77,3.1a8.5,8.5,0,0,1,.26-2.73,8.74,8.74,0,0,1,10.63-6.28S787.68,337.78,784.16,337.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M773.75,396.63a10.88,10.88,0,0,1-21.4-2,10.65,10.65,0,0,1,.33-3.39,10.88,10.88,0,1,1,21.07,5.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M771.75,391a10.88,10.88,0,0,1-19.4,3.6,10.65,10.65,0,0,1,.33-3.39,10.88,10.88,0,0,1,19.39-3.61A11,11,0,0,1,771.75,391Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M760.8,390.74c-4.39-.52-6.58,0-8.45,3.86a10.65,10.65,0,0,1,.33-3.39,10.87,10.87,0,0,1,13.24-7.83S765.18,391.25,760.8,390.74Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 760.11,
  cy: 394.72,
  r: 2.75
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M791.62,366.48a2.75,2.75,0,1,1-5.32-1.37,2.71,2.71,0,0,1,1.94-2,10.82,10.82,0,0,1,3.44,3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M767,373.4a4,4,0,0,1-4.22,1.56,3.95,3.95,0,0,1-.79-7.35h0a10.24,10.24,0,0,1,1,.62,11,11,0,0,1,2.64,2.63A10.85,10.85,0,0,1,767,373.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M785.8,396.86a3,3,0,1,1-3.87-3.6,12.54,12.54,0,0,1,4,3A3.65,3.65,0,0,1,785.8,396.86Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 790.28,
  cy: 335.37,
  r: 1.3
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-56",
  d: "M757.12,412.76s-65.85,102.38,14.13,262"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Lavender_4",
  "data-name": "Lavender 4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lavender_4-2",
  "data-name": "Lavender 4"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-25",
  x: 647.35,
  y: 210.2,
  width: 107.53,
  height: 168.53,
  rx: 46.98,
  transform: "translate(-17.03 44.39) rotate(-3.58)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-25",
  x: 629.95,
  y: 178.06,
  width: 143.97,
  height: 225.64,
  rx: 71.98,
  transform: "translate(-16.81 44.43) rotate(-3.58)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M689.71,347.14s6.64,10.45,16.66,15.34c0,0,5.62-2.2,12.77-18.29l-8.59-15.26-14.7,4.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M694.68,353.42s8.45-4.69,9.28-14.8l-6-2.07s-1.71,7.62-8.28,10.59A24.68,24.68,0,0,0,694.68,353.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M680.67,259.48a11.08,11.08,0,0,0,21.15,5.63,11.25,11.25,0,0,0,.89-3.36,11.08,11.08,0,0,0-22-2.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M684.57,254.81a11.08,11.08,0,0,0,17.25,10.3,11.25,11.25,0,0,0,.89-3.36,11.08,11.08,0,0,0-17.25-10.29A10.9,10.9,0,0,0,684.57,254.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M695.12,258.44c4.37,1.06,6.28,2.33,6.7,6.67a11.25,11.25,0,0,0,.89-3.36,11.07,11.07,0,0,0-9.88-12.15S690.75,257.38,695.12,258.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M672.25,274.39a11.09,11.09,0,1,0,4.8-8A11.08,11.08,0,0,0,672.25,274.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M676.15,269.73A11.08,11.08,0,0,0,693.4,280a10.9,10.9,0,0,0,.89-3.35,11.07,11.07,0,0,0-17.24-10.3A11,11,0,0,0,676.15,269.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M686.7,273.35c4.38,1.06,6.28,2.34,6.7,6.67a10.9,10.9,0,0,0,.89-3.35,11.08,11.08,0,0,0-9.88-12.16S682.34,272.29,686.7,273.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M689.47,270.3a13.69,13.69,0,0,0,26.13,7,13.53,13.53,0,0,0,1.1-4.14,13.69,13.69,0,0,0-27.23-2.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M694.29,264.54a13.68,13.68,0,0,0,21.31,12.72,13.53,13.53,0,0,0,1.1-4.14,13.68,13.68,0,0,0-21.31-12.73A13.52,13.52,0,0,0,694.29,264.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M707.33,269c5.4,1.31,7.75,2.88,8.27,8.24a13.53,13.53,0,0,0,1.1-4.14,13.69,13.69,0,0,0-12.21-15S701.93,267.71,707.33,269Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M702.71,288.68a12.58,12.58,0,1,0,5.44-9.1A12.56,12.56,0,0,0,702.71,288.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M707.13,283.38a12.57,12.57,0,0,0,19.57,11.69,12.58,12.58,0,0,0-10.2-17.6,12.47,12.47,0,0,0-8.35,2.11A12.34,12.34,0,0,0,707.13,283.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M719.1,287.5c5,1.2,7.12,2.65,7.6,7.57a12.58,12.58,0,0,0-10.2-17.6S714.15,286.29,719.1,287.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M690.09,304.58a11.08,11.08,0,0,0,21.15,5.63,11.08,11.08,0,1,0-21.15-5.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M694,299.91a11.07,11.07,0,0,0,17.24,10.3,11.07,11.07,0,0,0-16.35-13.65A10.7,10.7,0,0,0,694,299.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M677.57,289.46a13.81,13.81,0,0,0,26.36,7A14.09,14.09,0,0,0,705,292.3a13.81,13.81,0,0,0-12.32-15.15,13.71,13.71,0,0,0-9,2.2,1,1,0,0,0-.17.12A13.73,13.73,0,0,0,677.57,289.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M682.43,283.65a13.81,13.81,0,0,0,21.5,12.83A14.09,14.09,0,0,0,705,292.3a13.81,13.81,0,0,0-12.32-15.15,13.71,13.71,0,0,0-9,2.2,1,1,0,0,0-.17.12A13.45,13.45,0,0,0,682.43,283.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M695.58,288.16c5.45,1.32,7.82,2.92,8.35,8.32A14,14,0,0,0,705,292.3a13.81,13.81,0,0,0-12.32-15.15S690.14,286.84,695.58,288.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M668,309.92a13.83,13.83,0,1,0,6-10A13.8,13.8,0,0,0,668,309.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M672.9,304.1a13.81,13.81,0,0,0,21.5,12.84,13.8,13.8,0,0,0-20.38-17A13.6,13.6,0,0,0,672.9,304.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M686.05,308.62c5.45,1.32,7.82,2.91,8.35,8.32a13.85,13.85,0,0,0-11.21-19.34S680.61,307.3,686.05,308.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M668.85,330.2a16.05,16.05,0,1,0,17.61-14.31,16.6,16.6,0,0,0-3.07,0,16,16,0,0,0-6,1.77,14.07,14.07,0,0,0-1.58.95A16,16,0,0,0,668.85,330.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M674.5,323.44a16.05,16.05,0,0,0,25,14.92,16.06,16.06,0,0,0-13-22.47,16.6,16.6,0,0,0-3.07,0,16,16,0,0,0-6,1.77,14.07,14.07,0,0,0-1.58.95A15.93,15.93,0,0,0,674.5,323.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M689.79,328.69c6.33,1.53,9.09,3.38,9.7,9.67a16.07,16.07,0,0,0-13-22.48S683.46,327.16,689.79,328.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M711.33,330.29a13.83,13.83,0,1,0,6-10A13.8,13.8,0,0,0,711.33,330.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M716.19,324.48a13.81,13.81,0,0,0,21.5,12.83,14,14,0,0,0,1.11-4.18,13.8,13.8,0,0,0-21.49-12.83A13.45,13.45,0,0,0,716.19,324.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M729.34,329c5.45,1.33,7.82,2.92,8.35,8.32a14,14,0,0,0,1.11-4.18A13.81,13.81,0,0,0,726.48,318S723.9,327.67,729.34,329Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M706.61,306.34a13.81,13.81,0,0,0,26.36,7h0a13.44,13.44,0,0,0,1.11-4.18A13.79,13.79,0,0,0,721.77,294l-.63,0c-.42,0-.84,0-1.25,0a12.46,12.46,0,0,0-1.51.14h0a12.28,12.28,0,0,0-1.49.3,13.83,13.83,0,0,0-10.28,11.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M711.48,300.53c0,.25,0,.5-.05.75A13.79,13.79,0,0,0,733,313.36a13.44,13.44,0,0,0,1.11-4.18A13.79,13.79,0,0,0,721.77,294l-.63,0c-.42,0-.84,0-1.25,0a12.46,12.46,0,0,0-1.51.14,12.28,12.28,0,0,0-1.49.3,13.63,13.63,0,0,0-4.3,2A13.72,13.72,0,0,0,711.48,300.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M724.63,305.05c5.45,1.32,7.82,2.91,8.34,8.31a13.44,13.44,0,0,0,1.11-4.18A13.79,13.79,0,0,0,721.77,294S719.18,303.73,724.63,305.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M699.07,268.36A11.08,11.08,0,0,0,720.22,274a11.08,11.08,0,1,0-21.15-5.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M703,263.69a11.09,11.09,0,0,0,8.68,12,10,10,0,0,0,1.2.19,11,11,0,0,0,4.22-.38,10.7,10.7,0,0,0,3.15-1.48,11.07,11.07,0,0,0-16.35-13.65A11,11,0,0,0,703,263.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M713.52,267.32c4.38,1.06,6.28,2.33,6.7,6.67a11.09,11.09,0,0,0-9-15.51S709.16,266.26,713.52,267.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M710.82,273a3.5,3.5,0,0,0,.83,2.64,10,10,0,0,0,1.2.19,11,11,0,0,0,4.22-.38,3.48,3.48,0,1,0-6.25-2.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M690.91,249.4A11.08,11.08,0,0,0,712.06,255a11.08,11.08,0,1,0-21.15-5.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M694.82,244.73A11.07,11.07,0,0,0,712.06,255a11.07,11.07,0,0,0-16.35-13.65A11,11,0,0,0,694.82,244.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M705.37,248.36c4.37,1.06,6.27,2.33,6.69,6.67a11.08,11.08,0,0,0-9-15.51S701,247.3,705.37,248.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M691.64,323.47a13.81,13.81,0,0,0,26.36,7,13.44,13.44,0,0,0,1.11-4.18,13.81,13.81,0,0,0-27.47-2.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M696.51,317.65A13.8,13.8,0,0,0,718,330.48a13.44,13.44,0,0,0,1.11-4.18,13.8,13.8,0,0,0-21.49-12.83A13.44,13.44,0,0,0,696.51,317.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M709.66,322.17c5.45,1.32,7.82,2.91,8.34,8.31a13.44,13.44,0,0,0,1.11-4.18,13.81,13.81,0,0,0-12.31-15.15S704.21,320.85,709.66,322.17Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 708.72,
  cy: 327.21,
  r: 3.49
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M683.67,279.72a3.48,3.48,0,1,0,5.49-2.48,13.74,13.74,0,0,0-5.44,2.11C683.7,279.47,683.68,279.59,683.67,279.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M709.87,298.78a5.07,5.07,0,0,0,4.33,3.72,5,5,0,0,0,4.18-8.4h0a12.28,12.28,0,0,0-1.49.3,13.85,13.85,0,0,0-7,4.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M677.21,318.43a3.81,3.81,0,1,0,6.18-2.57,16,16,0,0,0-6,1.77A4.21,4.21,0,0,0,677.21,318.43Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 698.96,
  cy: 243.28,
  r: 1.65
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-56",
  d: "M704.33,350s33.23,150.86-132.28,305.55"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Fore_Ground",
  "data-name": "Fore Ground"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M989.61,861.9C799.1,844,573.47,712.73,573.47,712.73,359.81,602.22,174.21,561.25,22.09,555.46,136.86,537.32,456.49,532.29,989.61,861.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1920.79,1002v78H0V559.58c6.25-1.35,13.61-2.77,22.09-4.11,152.12,5.79,337.72,46.76,551.38,157.27,0,0,225.63,131.24,416.14,149.17l3.15,2S1248.18,1012.42,1445,1015c19.77.26,38.55-.21,56.54-1.23C1662.51,1004.75,1759.18,952.76,1920.79,1002Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1170.82,1080H0V801.29c73.93-10.54,189.05-8.58,286.75,73.26,48.7,40.8,89.93,66.31,126.5,81.46,82.45,34.19,141.23,15.8,208.51,1.53,31.31-6.64,64.68-12.95,99.91-16,74.06-6.48,156.3,1.36,244.7,50.55,47.15,26.23,113.9,57.28,189.92,83.09Q1163.5,1077.61,1170.82,1080Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M1170.82,1080H0V832.14a323.57,323.57,0,0,1,99.27,51.08C249.82,997,327.81,979.32,413.25,956c8.16-2.22,16.4-4.5,24.77-6.72,80.78-21.41,175.76-41.32,283.65-7.77a427.91,427.91,0,0,1,62.26,25c83.6,41.17,226.32,93.72,372.36,108.68Q1163.5,1077.61,1170.82,1080Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Big_Leaves_2",
  "data-name": "Big Leaves 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Big_Leaves_2-2",
  "data-name": "Big Leaves 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1885.68,920a1.59,1.59,0,0,1-.17.31c-7.63,16.25-20.38,34.69-40.68,57.26-15.54,17.29-26.71,38.17-31.45,60.92-2.87,13.88-3.76,29.08.48,42.71H1598.19s-4.33-144.35,100.44-197.39c25.81-13.06,42.12-29,54.06-45.72h0c36.58-51.17,32.47-109.72,135.17-115.94C1868.25,827.69,1915,857.29,1885.68,920Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-47",
  d: "M1788.23,885.28c-4,26.35-18.57,53-63.51,91.18-17.72,15.06-31.57,34.26-39.3,56.19-4.7,13.36-6.46,34.49-4.06,48.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M1813.38,1038.49c-2.87,13.88-3.76,29.08.48,42.71h-33.43a2.35,2.35,0,0,0-.08.29H1661.06l6.51-132.31,81.35-73.82s-3.43,68.18,26.71,45c-.75,1.15-24.9,37.36-50.92,56.14-26.44,19-.64,48.65,12.21,47.07s23.38-20.76,43.37-20.34c19.26-6.3,28.49-4.22,33.57-20,6.4-19.8,18.59-33.4,30.12-34.07s33-11.54,41.53-28.87c-7.63,16.25-20.38,34.69-40.68,57.26C1829.29,994.86,1818.12,1015.74,1813.38,1038.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M1758.93,773.22c-1.69,3.84-3.21,7.65-4.6,11.43-3.47,9.51-4.81,45.7-5.41,81.52-.25,15.06-.37,30.05-.48,43-.14,16.93-.25,30.31-.56,35.55-16.8-3-43-4.93-67.78,4.2,1.87-.25,30.74-3.62,65.16,20.15-15.54,96-84.2,112.18-84.2,112.18h-184.3s-40.37-219.81,208-288Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M1748.92,866.17c-.25,15.06-.37,30.05-.48,43a27.63,27.63,0,1,1,.48-43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1758.93,773.22q-5.4,3.67-10.8,7.38c-60.4,41.24-113.56,77.06-161.47,133-35.69,41.73-59.57,108-66.08,167.57h-43.82s-40.37-219.81,208-288Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M1543.11,989.65s-20.64,83.26,68.17,91.55H1476.76s-7.48-50.89,2.4-85.61c0,0-2.32,52.34,18.5,49.63S1543.11,989.65,1543.11,989.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M1887.88,722.15c-49.6,6-74.4,43.43-90.14,74.67-15.25,30.25-43.29,40.65-45,41.27C1789.29,786.92,1785.18,728.37,1887.88,722.15Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Lily_Leaves",
  "data-name": "Lily Leaves"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lily_Leaves-2",
  "data-name": "Lily Leaves"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M1066.63,870h0c-.51-.64-18.07-22.16-39.62-19.47-9.59,1.2-35.53,1.71-35.53-7.17s-.69-30.07-.69-30.07-12.43,14.49-12.43,29.53a60.59,60.59,0,0,1-29.11-7.65s-.82-25.28,3.27-36.9c-.52.46-17.09,15.23-17.76,28.69,0,0-49.88-2-51.25-49.89,0,0-.11-1.12-.14-3.06-.11-6.35.55-21.51,8.17-35.31,10.07-18.25,32.3-34.15,81-24.24q3.9.78,8,1.8C1085.77,742.16,1066.63,870,1066.63,870Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M839.41,780.11l-.42.08c-58.14,12.89-71.7-28.51-71.7-28.51,9.19-8.25,17.89-28.92,18.48-30.35a41,41,0,0,1-25.37,18.42c-13.91-12.81-18.73-45.17-18.73-45.17,19.23-5.37,31-28.47,31.34-29.19-20.24,16.53-34.21,15.93-34.21,15.93-.1-44.08-28.56-64.45-29.42-65.06h0s59.41-10.83,108.71,11.84c18.2,8.36,35,21.3,47,41,8.72,14.4,13,27.43,14.29,39.07C884.54,755.73,839.41,780.11,839.41,780.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M839,780.19c-58.14,12.89-71.71-28.51-71.71-28.51,9.35-8.37,18.17-29.57,18.51-30.4a41,41,0,0,1-25.4,18.47c-13.9-12.81-18.73-45.17-18.73-45.17,19.24-5.37,31-28.47,31.35-29.19-20.24,16.53-34.22,15.93-34.22,15.93-.1-44.08-28.55-64.45-29.41-65.06a120.75,120.75,0,0,1,21.11,7.26c43.56,19.17,78.94,52.18,95.71,97.18A221,221,0,0,1,839,780.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-38",
  d: "M842.55,864.5S871,735.76,787.63,662.9c0,0,71.57,54.74,46.78,201.94Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-14",
  cx: 806.36,
  cy: 636.74,
  r: 7.14
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-38",
  cx: 972.51,
  cy: 738.65,
  r: 7.14
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1066.62,869.94c-.51-.64-18.07-22.16-39.62-19.47-9.59,1.2-35.53,1.71-35.53-7.17s-.69-30.07-.69-30.07-12.43,14.49-12.43,29.53a60.59,60.59,0,0,1-29.11-7.65s-.82-25.28,3.27-36.9c-.52.46-17.09,15.23-17.76,28.69,0,0-49.88-2-51.25-49.89,0,0-.11-1.12-.14-3.06l2.54-3.85c26.76-24.52,82.6-6.23,82.6-6.23C1027.18,790.08,1066,868.71,1066.62,869.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M844,866.22s14.48-124.73,102-107c0,0,35.55,6.15,58.44,29.73,0,0-39-49.2-95.32-35.54s-74.72,93.31-74.72,111.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-38",
  d: "M938.68,724c-14.12-3.47-9.34,3-23.8,12.6s-23.35,2.07-23.35,2.07c10.07-18.25,32.3-34.15,81-24.24C977.45,730.87,952.79,727.45,938.68,724Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Money_Leaf_3-3",
  "data-name": "Money Leaf 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Money_Leaf_3-4",
  "data-name": "Money Leaf 3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1300.64,820.53c-7.05,13.05-27.88,16.74-53.87,11.62-16.17-3.16-34.32-9.74-52.44-19.58-47.26-25.58-76.24-63.5-64.75-84.72,4.64-8.55,15.11-13.06,29.1-13.72,20.69-1,49,6.42,77.21,21.69C1283.15,761.39,1312.13,799.34,1300.64,820.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M1275.9,818.42c-4.64,8.55-15.14,13.07-29.13,13.73a175.37,175.37,0,0,1-36.81-11.9.14.14,0,0,0,0-.06c-5.16-2.23-10.35-4.8-15.58-7.62-47.26-25.58-76.24-63.5-64.75-84.72,4.64-8.55,15.11-13.06,29.1-13.72,16.16,3.16,34.35,9.73,52.47,19.57C1258.37,759.28,1287.38,797.2,1275.9,818.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-47",
  d: "M1165.43,793.73s-104.31,114-26.93,323.83"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-47",
  x1: 1225.49,
  y1: 775.83,
  x2: 1199.59,
  y2: 760.61
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M1209.91,820.19c-5.16-2.23-10.35-4.8-15.58-7.62-47.26-25.58-76.24-63.5-64.75-84.72-.46,19,14.65,7.38,26.75,13.49s3.75,17.91,9.16,25.22,24.46-1.54,27.93.61,2.83,10.48-2,22C1186.69,800.46,1208.74,819.23,1209.91,820.19Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-37",
  cx: 1215.72,
  cy: 797.72,
  r: 9.57
}))), /*#__PURE__*/React.createElement("g", {
  id: "Money_Leaf_2",
  "data-name": "Money Leaf 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Money_Leaf_2-2",
  "data-name": "Money Leaf 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-62",
  d: "M724,801.69S876.44,951.75,759.2,1198.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M724,801.7c-22.58,15.14-45.75,24.64-64.91,27.79-18.71,3.08-33.57,0-40.21-9.85-13.42-20,11.87-60.51,56.47-90.45,33.42-22.42,68.25-32.54,89.24-27.81,7,1.59,12.52,4.86,15.88,9.87C793.86,731.25,768.57,771.77,724,801.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M724,801.7c-5.26,3.52-10.55,6.73-15.79,9.6a3.56,3.56,0,0,1-.34.22c-17.22,9.46-34.17,15.57-48.78,18-7-1.56-12.52-4.83-15.88-9.85-13.42-20,11.84-60.51,56.47-90.45,22.58-15.13,45.75-24.66,64.91-27.81,7,1.59,12.52,4.86,15.88,9.87C793.86,731.25,768.57,771.77,724,801.7Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-62",
  x1: 684.26,
  y1: 768.44,
  x2: 706.22,
  y2: 749.83
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-37",
  cx: 753.9,
  cy: 723.94,
  r: 7.8
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M724,801.7c-5.26,3.52-10.55,6.73-15.79,9.6,2.28-1.47,15.51-10.56,12.49-21.09-3.3-11.46,8.29-20.8,17.41-28.28s-15.69-13.33-17.22-16.35,6.07-10.16,31.64-7.32,27.94-27,27.94-27C793.86,731.25,768.57,771.77,724,801.7Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Money_Leaf_1",
  "data-name": "Money Leaf 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Money_Leaf_1-2",
  "data-name": "Money Leaf 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-47",
  d: "M950.78,850.06s101.62,107.56,64.88,267.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M950.78,850.07c-18.21,12.83-37,21-52.65,24-15.27,2.88-27.5.66-33.12-7.3-11.38-16.15,8.56-49.81,44.53-75.18,27-19,55.29-28,72.58-24.48,5.8,1.16,10.35,3.74,13.2,7.78C1006.7,791,986.75,824.7,950.78,850.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M950.78,850.07c-4.24,3-8.52,5.71-12.75,8.16a2.31,2.31,0,0,1-.28.18c-13.93,8.09-27.69,13.41-39.62,15.66-5.79-1.15-10.34-3.72-13.2-7.77-11.38-16.15,8.55-49.8,44.54-75.17,18.21-12.83,37-21.08,52.65-24,5.8,1.16,10.35,3.74,13.2,7.78C1006.7,791,986.75,824.7,950.78,850.07Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-62",
  x1: 917.62,
  y1: 823.57,
  x2: 935.25,
  y2: 807.91
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-37",
  cx: 973.82,
  cy: 785.79,
  r: 6.39
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M950.78,850.07c-4.24,3-8.52,5.71-12.75,8.16,1.83-1.24,12.5-9,9.83-17.52-2.92-9.32,6.39-17.2,13.72-23.5s-13.11-10.62-14.42-13.06,4.78-8.44,25.79-6.6,22.37-22.66,22.37-22.66C1006.7,791,986.75,824.7,950.78,850.07Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Blue_Tulip_2-3",
  "data-name": "Blue Tulip 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Blue_Tulip_2-4",
  "data-name": "Blue Tulip 2"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 391.87,
  cy: 534.1,
  r: 121.65
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M405.74,604.37s-38.14,8.32-64.93-21.56a83,83,0,0,1-14-22.14c-.16-.39-.34-.77-.51-1.15-19.49-44.12-23.38-51.58-23.84-51.71.41-.12,2.57-.74,6-1.44h0a111.55,111.55,0,0,1,24.27-2.27s0,0,0,0c21.16.46,47.66,8,59.61,39.37a85.69,85.69,0,0,1,3.46,11.59v0a102.59,102.59,0,0,1,1.84,10.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M392.33,543.47c-11.95-31.41-38.45-38.91-59.61-39.37,0,0,0,0,0,0-2.62-.23-4-13.32-4.29-22.75s-3.52-27.27-3.52-27.27A87,87,0,0,1,345.7,456c19.14,4.35,30.73,15.41,37.65,28.34C395.33,506.77,393.31,534.83,392.33,543.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M383.35,484.36v0s-14,12.85-29.28.81c0,0-6.68-5.26-6.66-19.68A23,23,0,0,0,345.7,456C364.84,460.37,376.43,471.43,383.35,484.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M382.13,503.77s11.83,19.94,13.66,51.31c0,0-3.44-14.53-7.53-20.56,0,0-3.66-16-9.27-27.7A7.1,7.1,0,0,0,382.13,503.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M379,506.82a8.67,8.67,0,0,1-11.77-3.31l-5.82-10.37a8.67,8.67,0,0,1,3.32-11.77,8.55,8.55,0,0,1,3.19-1,8.67,8.67,0,0,1,8.58,4.35l5.82,10.37a8.25,8.25,0,0,1,.8,2A8.7,8.7,0,0,1,379,506.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M383.1,497a8.51,8.51,0,0,1-3.24,3.2,8.66,8.66,0,0,1-11.77-3.31l-5.82-10.37a8.69,8.69,0,0,1-.8-2,8.66,8.66,0,0,1,3.24-3.2,8.55,8.55,0,0,1,3.19-1,8.67,8.67,0,0,1,8.58,4.35l5.82,10.37A8.25,8.25,0,0,1,383.1,497Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 370.28,
  cy: 487.16,
  r: 3.84
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M382.13,503.77s2.73,5.34,3.54,7.26c0,0-1.11,2.68-3.59,3.07l-3.1-7.28h0A8.52,8.52,0,0,0,382.13,503.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M395.79,555.06c-11-19.88-40.58-16.36-48.35-33.3s-39-15.39-39-15.39h0a111.55,111.55,0,0,1,24.27-2.27s0,0,0,0c21.16.46,47.66,8,59.61,39.37A85.69,85.69,0,0,1,395.79,555.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M353.46,566.24a15,15,0,0,1-12.65,16.57,83,83,0,0,1-14-22.14c-.16-.39-.34-.77-.51-1.15a15,15,0,0,1,27.2,6.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M397,605.4s39-.81,58.11-36.12a82.85,82.85,0,0,0,8.48-24.81c.07-.42.15-.82.22-1.23,8.66-47.45,10.71-55.62,11.12-55.85-.43,0-2.67-.12-6.16,0h0a111.1,111.1,0,0,0-24.12,3.46s0,0,0,0c-20.47,5.38-44.49,18.86-48.78,52.19a86,86,0,0,0-.65,12.08v0a103.73,103.73,0,0,0,.67,10.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M395.85,543.05c4.29-33.33,28.31-46.81,48.78-52.19,0,0,0,0,0,0,2.49-.84.81-13.9-1.14-23.12s-2.94-27.34-2.94-27.34a86.82,86.82,0,0,0-19.81,6.76c-17.59,8.69-26.28,22.15-30,36.34C384.37,508.07,392.88,534.88,395.85,543.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M396.51,502.07s-6.85,22.15-1.31,53.08c0,0-.05-14.93,2.52-21.75,0,0-.19-16.46,2.56-29.1A7.16,7.16,0,0,1,396.51,502.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M400.28,504.3a8.67,8.67,0,0,0,10.67-6l3.24-11.44a8.68,8.68,0,0,0-2.07-8.32,8.64,8.64,0,0,0-7.24-2.62,8.69,8.69,0,0,0-7.34,6.23l-3.23,11.44a9,9,0,0,0-.33,2.09A8.71,8.71,0,0,0,400.28,504.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M394,495.72a8.56,8.56,0,0,0,3.9,2.36,8.68,8.68,0,0,0,10.68-6l3.23-11.45a9,9,0,0,0,.33-2.09,8.64,8.64,0,0,0-7.24-2.62,8.69,8.69,0,0,0-7.34,6.23l-3.23,11.44A9,9,0,0,0,394,495.72Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 404.16,
  cy: 483.15,
  r: 3.84
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M396.51,502.07s-1.41,5.83-1.75,7.88c0,0,1.7,2.35,4.21,2.15l1.31-7.8h0A8.51,8.51,0,0,1,396.51,502.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M357,596s15-17.79,36.88-17.35,51.45,14,67.66-25.23c0,0-4.69,37.37-55.79,50.92C405.74,604.37,382.55,609.46,357,596Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M403.63,519.38s18.37-12,38.65-12.41c0,0,10.22-1.32,21.82-12.9,0,0,6.36-7.83,10.86-6.68C475,487.39,424.25,484.31,403.63,519.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M393.71,475s3.61-8.26,16.82-9.83,18.57-21.47,18.57-21.47S401.71,449.41,393.71,475Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-30",
  cx: 433.45,
  cy: 465.03,
  r: 5.18
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M436.66,591.06s-.86,31.58-27.28,38.11a37,37,0,0,1-4.72.85c-36.38,4.36-40.49-30.38-40.49-30.38s18.12,8.75,42.54,4A82.58,82.58,0,0,0,436.66,591.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M436.66,591.06s-.86,31.58-27.28,38.11c7.1-4.29,15.64-18.56,4.66-23.63a18.05,18.05,0,0,0-8.3-1.17l1-.75A82.58,82.58,0,0,0,436.66,591.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M404.66,630s40.43,247.54-77.1,375.92"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Fig_Leaves_3",
  "data-name": "Fig Leaves 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fig_Leaves_3-2",
  "data-name": "Fig Leaves 3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M540.93,836.67A106,106,0,0,1,523,857.77s-76.71,23.58-93.22-38.71c-6.88-25.93-14.77-42-21.88-51.89-11.47-16-20.93-16.08-20.93-16.08l-.1,0a18.36,18.36,0,0,1-6.79-6.62c-3.49-5.92-4.84-16.18,6.89-32.3.55-.77,1.12-1.53,1.68-2.3,19.63-26.22,51.3-56.7,56.13-61.3l.62-.59a12,12,0,0,1,1.65-.11c3.79-.06,13.31,1,20.25,12.35a46,46,0,0,1,5,12c3.92,14.28,15.95,26.79,30.53,42.18,13.44,14.17,29,30.8,42.42,53.49C561,794.55,551.87,819.78,540.93,836.67Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-63",
  x1: 441.09,
  y1: 647.94,
  x2: 445.4,
  y2: 647.94
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M522.55,857.77c-7-24.59-26.49-55.56-46.62-78.15-17.26-19.37-35.28-61.75-35.28-61.75-5.5-12.11-10.86-21.32-10.86-21.32L445,647.94h0c.73-.1,13.29-1.75,21.87,12.25a45.66,45.66,0,0,1,5,12c7.53,27.43,45,48.34,72.95,95.67S522.55,857.77,522.55,857.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M467.29,660.18c-7.21-5.67-11,.58-10.16,6.93s-4.66,21.61-13.88,29.66-7.3,17-7.3,17c-5.15-4.16-21,2.53-19.7,27.32,1.24,24.14-7.88,26-8.36,26.13-11.47-16-20.93-16.08-20.93-16.08a18,18,0,0,1-6.89-6.66l8.57-34.6c21.29-28.44,56.75-61.89,56.75-61.89S458.45,645.76,467.29,660.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M429.77,689.4c-17.22,7.53-27.15,26.17-35.16,42.13-1.87,3.74-4.13,7.53-5.33,11.51-1.33,4.4-2.31,8.61-4.4,12.78a59.06,59.06,0,0,1-18.47,21.36c-12,8.53-27.25,12.1-41.51,7.59-30.12-9.53-29-65.83,1.09-87.71,7.46-5.42,12.19-16.63,15.1-27a30.4,30.4,0,0,1,16.78-19.53,29.78,29.78,0,0,1,12.27-2.62h75.25S450.78,680.22,429.77,689.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M407.52,647.94c-13.07,1-19.12,10.32-21.5,13.42s-8.43,18-9.36,20.3a40.71,40.71,0,0,0,.94-21.33c-2.72-12-19.76-9.74-19.76-9.74l0,0a29.78,29.78,0,0,1,12.27-2.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-64",
  d: "M441.09,717.87s18,42.38,35.28,61.75c26.46,29.69,97.15,118.68,47.74,323.68"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M442.39,676.43a24.46,24.46,0,0,1-12.62,13c-17.22,7.53-27.15,26.17-35.16,42.13-.87,1.75-1.83,3.51-2.73,5.3a38.37,38.37,0,0,0-2.6,6.21c-1.33,4.4-2.31,8.61-4.4,12.78a59.06,59.06,0,0,1-18.47,21.36c-12,8.53-27.25,12.1-41.51,7.59a26.45,26.45,0,0,1-8.4-4.42h0C312,768,330.35,749,341.18,739.25a107,107,0,0,0,19.72-23.71c21-34.52,16.74-59.26,43.61-67.6h40.88S448,663.79,442.39,676.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M442.39,676.43a24.46,24.46,0,0,1-12.62,13c-17.22,7.53-27.15,26.17-35.16,42.13-.87,1.75-1.83,3.51-2.73,5.3.6-5.78.92-15.64-2.93-20.66-5.66-7.37-5.54-25.47,3.29-27.43s18.16,2.27,22.82-3.66,11.78-10.25,20.93-7.67A7.09,7.09,0,0,0,442.39,676.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-64",
  d: "M348.57,732.93c35.5-43.53,24.75-75.31,55.94-85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M541.16,835.62c2.33-10.72,3.08-25.91-8.62-32.63-19.07-10.94-46.39-29.9-36.22-58.87a126.21,126.21,0,0,0,6.47-29.37c0-.14,0-.28,0-.42,13.44,14.17,29,30.8,42.42,53.49,15.76,26.73,6.63,52-4.31,68.85C541,836.33,541.09,836,541.16,835.62Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-35",
  cx: 483.4,
  cy: 736.22,
  r: 8.79
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-35",
  cx: 410.53,
  cy: 667.29,
  r: 9.15
}))), /*#__PURE__*/React.createElement("g", {
  id: "Fig_Leaves_2",
  "data-name": "Fig Leaves 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fig_Leaves_2-2",
  "data-name": "Fig Leaves 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M1426.34,962.51a40.47,40.47,0,0,0-8.12,16.77c-2,9.18-3.06,20.85-6.41,31.92-4,13.18-11.19,25.51-27,31.76-29,11.5-68.64,25.46-79.75,11.69,0,0-43.21-64.56-25.5-106.37,16.21-38.28,37.15-41.71,51.83-60.64,4.49-5.79,8.38-13,11.38-23.14,4.54-15.35,11.59-19.57,11.59-19.57s-5.23,28.42,2.56,41.32c31.07,51.5,85,11,88.62,50.53C1446.46,946.31,1426.34,962.51,1426.34,962.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1426.34,962.51a40.47,40.47,0,0,0-8.12,16.77c-2,9.18-3.06,20.85-6.41,31.92a55.38,55.38,0,0,1-13-17.3c-3.84-8.11-5.79-17.78-4.91-29.2,1.76-22.69-7.89-29.42-20.34-29.57,2.44-16.48-27.62-10.29-41.34-45.22a19.47,19.47,0,0,1-.75-2.27c4.49-5.79,8.38-13,11.38-23.14,4.54-15.35,11.59-19.57,11.59-19.57s-5.23,28.42,2.56,41.32c31.07,51.5,85,11,88.62,50.53C1446.46,946.31,1426.34,962.51,1426.34,962.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M1532,991.59a38.82,38.82,0,0,1-23.69,8.77c-18.12.68-57.38-1.07-75.26-26.58-4.69-6.71-7.92-15.09-8.87-25.49-4-43.09-33-1.53-66.86-57.74-8.5-14.1-2.8-45.12-2.8-45.12l98-5.65a20.49,20.49,0,0,1,13.06,3.76c13.83,9.85,46.31,36.07,49.34,67.14C1518.31,944.33,1552.45,974.36,1532,991.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M1532.36,991.58a35.27,35.27,0,0,1-5,3.53,30.77,30.77,0,0,0-8.57-17.49c-13.57-14-32.51-29.34-32.51-29.34-6.34-4-15.84-15-26.49-54.57s-51-51.39-51-51.39l44.15-2.55a20.49,20.49,0,0,1,13.06,3.78c13.83,9.83,46.31,36.06,49.35,67.13C1518.62,944.32,1552.76,974.36,1532.36,991.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-64",
  d: "M1300.39,1115s3.53-114.53,70.55-175.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1447.62,840.08c-8.35,1.49-8.89,7-.42,14.55,7.92,7.07,4.06,16.62,6.5,24.5,0,0-14.86-29.85-47.42-36.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-64",
  d: "M1408.44,842.32s40.39,11.82,51,51.39,20.15,50.58,26.48,54.58"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-35",
  cx: 1432.18,
  cy: 899.45,
  r: 11.84
}))), /*#__PURE__*/React.createElement("g", {
  id: "Fig_Leaves_1",
  "data-name": "Fig Leaves 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fig_Leaves_1-2",
  "data-name": "Fig Leaves 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M676.34,459.33l.46-.22c3.23-1.54,6.78-2.87,10.23-2.12,7.93,1.73,10.28,12.41,11,21.05q2.13,24.57,4.25,49.14c1.69,19.44,3.37,39.07,1.13,58.49s-8.75,38.89-21.44,53.06c-9.2,10.27-21.4,17.55-28.71,29.44-9.23,15-10.12,33.75-20.93,48C620.74,731.47,600,743,581.64,737c-42.36-13.93-34.77-77.46-17.56-109.61a108.68,108.68,0,0,1,30-35.17c11.68-8.87,29.21-11.62,37.27-24.7,11-17.82,1.09-39.88,4.31-59.22C639.2,486.94,658.57,468,676.34,459.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M670,531.39c5.94,38.66-19.41,59.37-19.41,59.37-42.78,45.47-62.33,97.76-70.24,144.66-40.11-14.78-33.16-75.83-16.58-107.91.19-.38.39-.76.59-1.14a108.82,108.82,0,0,1,30-35.18c11.68-8.87,29.22-11.61,37.27-24.69,5-8,5.67-17,5.23-26.09-.51-11.09-2.69-22.51-.92-33.13,3.56-21.35,22.93-40.31,40.71-49l.45-.22c3.23-1.55,6.79-2.87,10.24-2.12a9.54,9.54,0,0,1,4.19,2.09C685.3,466.71,664.87,498.43,670,531.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-64",
  d: "M587.34,1105.74s-76.76-371.34,63-514"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-36",
  cx: 577.66,
  cy: 652.5,
  r: 14.67
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-36",
  d: "M627.44,589.62c-1.14,15.09-21.46,34.87-40.91,32.43C578,621,570,623.9,563.72,627.51c.19-.38.39-.76.59-1.14a108.82,108.82,0,0,1,30-35.18c11.68-8.87,29.22-11.61,37.27-24.69,5-8,5.67-17,5.23-26.09C653.19,557.21,628.55,575,627.44,589.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M704.52,549.35s-4.92-12.29-13.06-12.89-8.94-21.17-4.18-28.13,13.24-18.1,10.78-30.29S704.66,541.37,704.52,549.35Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Large_Leaves_Front",
  "data-name": "Large Leaves Front"
}, /*#__PURE__*/React.createElement("g", {
  id: "Large_Leaves_Front-2",
  "data-name": "Large Leaves Front"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M551.92,812.36c1.5,3.43,2.85,6.82,4.09,10.19,3.09,8.45,4.27,40.66,4.81,72.54.22,13.4.33,26.75.43,38.24.13,15.07.22,27,.5,31.64,15-2.65,38.29-4.39,60.32,3.74-1.66-.23-27.36-3.23-58,17.93,13.83,85.47,74.93,99.83,74.93,99.83H803S839,890.85,617.94,830.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M560.82,895.09c.22,13.4.33,26.75.43,38.24a24.6,24.6,0,1,0-.43-38.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M551.92,812.36l9.6,6.58c53.76,36.7,101.07,68.58,143.7,118.41,31.77,37.13,53,96.14,58.81,149.12h39S839,890.85,617.94,830.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-47",
  d: "M628.8,866.22c27.15,20.66,52.52,42.95,76.42,70.89,31.77,37.13,53,96.14,58.81,149.12"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M744,1005s18.37,74.1-60.67,81.48H803s6.66-45.29-2.14-76.19c0,0,2.07,46.58-16.46,44.16S744,1005,744,1005Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M789.42,1083.56H894.94a54.62,54.62,0,0,0,7.71-2.33h0c.68-.24,1.39-.51,2.13-.8h0c15.86-6.32,46.11-24,54.78-68.76-17.8-10.25-33.66-12.64-42.58-13a51,51,0,0,0-7.48.12c2.51-.77,5-1.41,7.54-2,16.65-3.56,33.33-2.39,44.54-.74a179.83,179.83,0,0,0-2.21-41.13c-.56-3.43-1-6.86-1.19-10.31a81.49,81.49,0,0,0-8.55-.5A102.2,102.2,0,0,0,924.81,947,63.2,63.2,0,0,1,958,931.38a105.33,105.33,0,0,1,8.58-37.9q1.59-3.63,3.54-7.32S793.4,894.15,789.42,1083.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-65",
  d: "M789.42,1083.56h48a286.23,286.23,0,0,1,11.71-47.32l.39-1.16c.87-2.49,1.76-5,2.67-7.39,1-2.7,2.08-5.37,3.16-8v0c38.58-93.46,114.8-133.53,114.8-133.53s-131.72,6-170.28,129.47h0C793.74,1035.19,790,1057.68,789.42,1083.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M961.62,996.06a179.83,179.83,0,0,0-2.21-41.13c-.56-3.43-1-6.86-1.19-10.31a81.49,81.49,0,0,0-8.55-.5c-9.5,11.42-19.38,21.71-25.11,29.77-4.91,6.91-7.07,14.77-7.48,22.91C933.73,993.24,950.41,994.41,961.62,996.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M904.8,1080.43h0c15.86-6.32,46.11-24,54.78-68.76-17.8-10.25-33.66-12.64-42.58-13-.23,12.81,3.61,26.2,7.54,37.57C931.18,1055.37,904.8,1080.43,904.8,1080.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M863.07,1067.65a22,22,0,0,0,6.76,15.91h25.11a54.62,54.62,0,0,0,7.71-2.33h0a22.13,22.13,0,1,0-39.6-13.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M855.31,1019.71c-.14.31-1.48,3.22-3.44,8.55a5,5,0,0,0,.28-.57A51.23,51.23,0,0,0,855.31,1019.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M789.42,1083.56h48a345.46,345.46,0,0,1,11.71-47.32l.39-1.16q1.28-3.86,2.37-6.76c-7.73,15.1-20.92,20.36-34.56,21.72-15.81,1.59-17.41-33.61-17.45-34.4C793.74,1035.19,790,1057.68,789.42,1083.56Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Pink_daisy_2",
  "data-name": "Pink daisy 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pink_daisy_2-2",
  "data-name": "Pink daisy 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M1190.52,1080.57s13.75-106.18-48.46-124.35c-62.9-18.38-85.23-37.43-92.33-56.36-3.64-9.68-2-29.73,12.64-40.9,11.39-8.71,30.63-12,61.34-.76a211.6,211.6,0,0,1,22.39,9.85C1235.65,913.34,1190.52,1080.57,1190.52,1080.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M1190.16,1080.57c0,.07,0,0,0,0l.44-.57-.44.57c.5-3,13.85-106.23-48.14-124.35-62.92-18.38-85.25-37.43-92.34-56.36a28.28,28.28,0,0,1-1.59-8.42c24.09-3.7,50.3,3.25,50.3,3.25C1221.76,923.17,1192,1072.86,1190.16,1080.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1141.86,913.25s71.17,27.15,50.27,154c0,0,33.36-117.26-20.44-179.39,0,0-.88,10.25-7.11,11.42s-31.95-6.6-40.36,4C1124.22,903.29,1135.64,909.07,1141.86,913.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M1123.71,858.2c-8.07,2-13.52,8-19.59,10.22-10.27,3.8-15,.89-24.37-7.49-5.12-4.58-12.11-3.7-17.38-2C1073.76,850.25,1093,847,1123.71,858.2Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-37",
  cx: 1120.11,
  cy: 878.96,
  r: 7.32
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-47",
  d: "M1187,1115s6.92-149.87,80.66-209.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1375.37,907.9c-41.35,23.75-89.81-14.24-91-15.16,13.85,7.57,46,4.08,67.28.3,5.34-.95,10-1.92,13.51-2.74,1-.22,1.82-.44,2.6-.63l.44-.11C1379.4,887,1385.31,902.19,1375.37,907.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1284.35,892.71s-31-54.66-.73-92.23c7.2-8.91,21.3-.7,17,9.92,0,.14-.11.28-.17.42C1294.3,825.09,1277.33,873.13,1284.35,892.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1360.31,880.27c-30.93,28.75-76,12.45-76,12.45,25.06-5.37,46.05-18.91,58.27-28.29l1.63-1.26a11.51,11.51,0,0,1,16.91,3l.79,1.28A10.2,10.2,0,0,1,1360.31,880.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1321.52,837.22c-10.87,10.59-28.16,30.25-37.17,55.5,0,0-7.5-34.25,10.73-61a60,60,0,0,1,9.24-10.65c.76-.71,1.53-1.37,2.35-2a10.22,10.22,0,0,1,12.94,0l1.17,1A11.49,11.49,0,0,1,1321.52,837.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M1340.47,860.31c-18,27.82-56.12,32.41-56.12,32.41,4.45-27.05,23.32-42.14,35.93-49.37,1.14-.66,2.22-1.24,3.24-1.77a11.64,11.64,0,0,1,14.1,2.74l1.84,2.11A11.6,11.6,0,0,1,1340.47,860.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1363.31,902.73c-20,11.51-41.73,8.52-58.9,2.29a122.76,122.76,0,0,1-20-12.28c18.1,9.89,67.43.92,83-3A9.77,9.77,0,0,1,1363.31,902.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1288.57,805.24l-.18.42c-4,9.25-12.52,32.7-16.11,53.37-3.63-18.08-3.36-40.33,11.34-58.55a10,10,0,0,1,4.76-3.34A9.62,9.62,0,0,1,1288.57,805.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1348.25,875.11c-18.69,17.38-42.54,18.29-58.47,16.29,23.78-6.3,43.39-19.51,54.46-28.23a11.38,11.38,0,0,1,4.84-2.24.11.11,0,0,0,0,.05l.8,1.29A10.2,10.2,0,0,1,1348.25,875.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1309.47,832.06a168,168,0,0,0-26,32.31c1.73-14.75,7.48-32.35,23.2-45.31a9.67,9.67,0,0,1,4.08-2A11.5,11.5,0,0,1,1309.47,832.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1328.41,855.15c-10.94,16.94-29.37,25.26-42.11,29.18,7.18-24,26.11-37,37.22-42.75a12,12,0,0,1,3.21-1.1l.68.78A11.58,11.58,0,0,1,1328.41,855.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M1316.6,910.46l-.09.09a33.81,33.81,0,0,1-47.6-3.48h0a33.47,33.47,0,0,1-7.49-14.91,33.84,33.84,0,0,1,3.43-23.58,33.35,33.35,0,0,1,7.45-9.23l0,.06,10.57,12.19.3.34,5.3,6.13,1.41,1.63,8,9.23.48.56,5.51,6.35.93,1.08.17.2h0l11.29,13Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-41",
  cx: 1289.36,
  cy: 806.22,
  r: 5.73
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M1277.16,880.64a12.08,12.08,0,0,1-12.07,12.08,12.42,12.42,0,0,1-3.68-.57,33.84,33.84,0,0,1,3.43-23.58h.25A12.06,12.06,0,0,1,1277.16,880.64Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-41",
  cx: 1328.25,
  cy: 853.43,
  r: 4.33
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1333.56,841.31a6.91,6.91,0,0,1-13.28,2c1.14-.66,2.22-1.24,3.24-1.77A11.5,11.5,0,0,1,1333.56,841.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1356.14,862.4a6.92,6.92,0,0,1-13.53,2l1.63-1.26a11.42,11.42,0,0,1,11.86-1.45A5.27,5.27,0,0,1,1356.14,862.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1365.27,891.25a6.91,6.91,0,0,1-13.58,1.79c5.34-.95,10-1.92,13.51-2.74A5.9,5.9,0,0,1,1365.27,891.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1307.14,826.75a7.06,7.06,0,0,1-12.06,5,60,60,0,0,1,9.24-10.65A7.05,7.05,0,0,1,1307.14,826.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1316.51,910.55a33.81,33.81,0,0,1-47.6-3.48c.56.24,17.14,7.41,30-5a32.12,32.12,0,0,0,4.26-5.1l.18-.27c.2-.3.41-.61.6-.92l.91,1.07.19.21,11,12.92Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "White_Daisy_2",
  "data-name": "White Daisy 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "White_Daisy_2-2",
  "data-name": "White Daisy 2"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 232.63,
  cy: 570.5,
  r: 113.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 232.63,
  cy: 570.5,
  r: 98.76
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M268.51,625.62s62.85-58.58,38.7-120c-5.73-14.58-29-9.63-27.77,6,0,.21.32,1.73.34,1.94C281.93,534.69,285.68,603,268.51,625.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M268.48,625.68s-77.56,28.55-124.85-17.46c-13.1-12.75,3.3-28.94,16.8-21l.54.32C179,598.69,240.6,631.25,268.48,625.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M268.48,625.68s31.06-57.63-1.63-105.19c-3.76-5.47-10.39-6.37-16.48-3.74l-1.81.64c-8.64,3.72-12.73,13.24-8.06,21.4C250.81,556.78,266.14,589.12,268.48,625.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M268.49,625.67s-66.46,4.2-96.28-45.2c-3.43-5.69-1.11-12.73,3.81-17.2l1.52-1.39a15.73,15.73,0,0,1,23.35,2.44C213,581.13,236.16,608.44,268.49,625.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M268.49,625.67s1.42-52.49-32.59-82.34c-5.29-4.65-13.66-5.68-19.59-1.89l-2.57,1.77a17,17,0,0,0-6.56,19.28C213.34,580.46,229.61,613.23,268.49,625.67Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-28",
  points: "293.89 593.74 217.31 635.39 272.31 646.43 293.89 593.74"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M296.32,524.58c10.66,29.24,1.7,57.36-10.54,78.72A165.31,165.31,0,0,1,264.88,627c17.3-21.73,16.76-89.28,15.19-110.78A13.15,13.15,0,0,1,296.32,524.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M149.69,601.32l.51.33c11.37,7.41,40.52,24.15,67.14,33.69-24.84.65-54.31-4.84-75.1-28.56a13.28,13.28,0,0,1-3.34-7.08A13,13,0,0,1,149.69,601.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M256.19,538.21c18.76,28.82,14.47,60.68,8.14,81.37-2.88-33-15.89-62.09-24.91-78.8a15.23,15.23,0,0,1-1.85-6.94s.05,0,.07,0l1.89-.76A13.75,13.75,0,0,1,256.19,538.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M190.12,579.76A226,226,0,0,0,227,621.7c-19.18-5.7-41.23-17.38-54.8-41.23a13.38,13.38,0,0,1-1.74-5.89A15.52,15.52,0,0,1,190.12,579.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M225.13,559.94c20,18.42,26.76,44.81,29,62.62-30.24-15.06-43.1-43.18-48.16-59.25a15.74,15.74,0,0,1-.72-4.52l1.19-.72A15.6,15.6,0,0,1,225.13,559.94Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-67",
  cx: 151.17,
  cy: 600.49,
  r: 7.72
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-67",
  cx: 222.81,
  cy: 559.75,
  r: 5.83
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-67",
  d: "M207.94,549.91a9.31,9.31,0,0,1-.35,18.1q-.92-2.49-1.6-4.7A15.53,15.53,0,0,1,207.94,549.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-67",
  d: "M241.14,524.81a9.32,9.32,0,0,1-.42,18.43c-.44-.84-.87-1.67-1.3-2.46a15.42,15.42,0,0,1,.81-16.08A9,9,0,0,1,241.14,524.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-67",
  d: "M182.53,581.62a9.53,9.53,0,0,1,3.86,17.17,80.11,80.11,0,0,1-12-14.73A9.51,9.51,0,0,1,182.53,581.62Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-37",
  points: "296.91 588.66 273.27 648.3 208.95 635.39 246.17 615.62 263.07 606.64 296.91 588.66"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M269.72,617.27a11.84,11.84,0,1,1-23.67,0,11.24,11.24,0,0,1,.12-1.65l16.9-9A11.82,11.82,0,0,1,269.72,617.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-36",
  d: "M275.63,642.35s-5.75-9-2.36-14.37,9-9.12,8.55-14.66,4.93-11.51,9.83-11.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-68",
  d: "M272.13,646.77S404.27,829.13,244,1074.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-65",
  points: "231.78 623.26 273.27 648.3 208.95 635.39 231.78 623.26"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Snake_Plant",
  "data-name": "Snake Plant"
}, /*#__PURE__*/React.createElement("g", {
  id: "Snake_Plant-2",
  "data-name": "Snake Plant"
}, /*#__PURE__*/React.createElement("g", {
  id: "Snake_Plant-3",
  "data-name": "Snake Plant"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M340.31,1050.38a125.44,125.44,0,0,1-7,33.13H114s-5.44-9.73-8-28.65c-1.63-12.25-2-28.36,1-48.17,2.7-17.48-.54-30.53-6.8-42.29A108.71,108.71,0,0,0,93,952.91c-6.48-9.14-14.32-18.12-21.94-28.61C58.5,907,54.88,887.71,57.37,866.62c.89-7.53,2.16-16.1,3-25,.48-5,.81-10.2.85-15.31a86.8,86.8,0,0,0-2.76-24.11c-2.41-8.6-6.66-16.33-13.7-22.37-11.67-10-27.22-15.12-39.64-24.41C-15.67,739.9-19.61,710.1-16,686.05c3.65-24.33,12.14-41.46-10.72-59-13-10-31-19.88-30.06-38.81.56-10.78,9.2-14.18,18.65-14.69a77.17,77.17,0,0,1,17,1.37c54.42,9.71,78.46,21,82,55.85a39.68,39.68,0,0,0,31.32,34.38c8.55,1.72,17.37.56,26.09.36,40.95-.93,66.37,44.55,63.14,81.48-1.76,20.21,6.7,42.84,20.09,57.88,8.25,9.26,19.86,16.72,32.12,19.25,13.78,2.83,26.16,2.23,38.43,10.82a51.79,51.79,0,0,1,20.78,32.36c4,19.89-7.15,38.81-2.41,59.54,4.17,18.17,14.34,34.37,26.59,48.2C338.79,999.53,342.05,1028.53,340.31,1050.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M343.65,1081.73,215.42,1080s-24.54-22.59-28-78c-2.59-41.26,16.11-68.06-11.75-92.81-17.38-15.45-25.74-35.12-28-58.12C144.74,822,144,777.87,114,761.78c-14.74-7.9-32.47-9.71-47.84-16.68-25.72-11.66-36.87-42.41-38.65-68.82-1.8-26.71,3.23-46.9-25.17-60.23-16.13-7.58-35.14-27.33-58.16-32.62,0,0,2.5-10,17.72-9.91a77.17,77.17,0,0,1,17,1.37c54.42,9.71,78.46,21,82,55.85a39.68,39.68,0,0,0,31.32,34.38c8.55,1.72,17.37.56,26.09.36,40.95-.93,66.37,44.55,63.14,81.48-1.76,20.21,6.7,42.84,20.09,57.88,8.25,9.26,19.86,16.72,32.12,19.25,13.78,2.83,26.16,2.23,38.43,10.82a51.79,51.79,0,0,1,20.78,32.36c4,19.89-7.15,38.81-2.41,59.54,4.17,18.17,14.34,34.37,26.59,48.2C338.79,999.53,345.39,1059.88,343.65,1081.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-65",
  d: "M216.28,943.56s74.07,50.85,76,136.41H181.54s1.88-25.86,31.93-56C228.07,1009.34,228.55,975.52,216.28,943.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M446.79,1083.51H254s-13-23.22-6.1-67.52c5.11-33-13.91-48.07-31.6-72.43-11-15.2-14.22-32.16-12-50.71,2.76-23.44,9.79-58.38-11.08-76.27-10.25-8.79-23.93-13.29-34.85-21.45-18.27-13.66-21.73-39.85-18.56-61,3.21-21.38,10.68-36.44-9.42-51.88-11.41-8.78-27.29-17.48-26.43-34.12a12.54,12.54,0,0,1,2.56-7.37c5.83-7.36,20.17-5.88,28.82-4.34,47.84,8.54,69,18.47,72.1,49.09a34.88,34.88,0,0,0,27.53,30.23c7.51,1.5,15.26.49,22.93.31a45.75,45.75,0,0,1,8.26.55c31.1,4.89,49.86,41.18,47.24,71.08a56.51,56.51,0,0,0,0,9.56A73.19,73.19,0,0,0,331,838.55a56.47,56.47,0,0,0,6,5.78,51.51,51.51,0,0,0,22.26,11.14c12.1,2.49,23,2,33.78,9.52a45.51,45.51,0,0,1,18.26,28.44c3.5,17.48-6.29,34.12-2.11,52.33,3.66,16,12.6,30.22,23.36,42.37C468.55,1028.8,446.79,1083.51,446.79,1083.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M367.21,1083.51H254s-13-23.22-6.1-67.52c5.11-33-13.91-48.07-31.6-72.43-11-15.2-14.22-32.16-12-50.71,2.76-23.44,9.79-58.38-11.08-76.27-10.25-8.79-23.93-13.29-34.85-21.45-18.27-13.66-21.73-39.85-18.56-61,3.21-21.38,10.68-36.44-9.42-51.88-11.41-8.78-27.29-17.48-26.43-34.12a12.54,12.54,0,0,1,2.56-7.37c40.53,12.92,58,25.51,57.62,54.36A34.87,34.87,0,0,0,188,728.27c7.3,2.35,15.11,2.22,22.75,2.92,35.85,3.27,53.52,45.53,47,77.46-3.56,17.47,1.57,38.08,11.77,52.55,6.28,8.91,15.67,16.58,26.13,20,11.75,3.85,22.62,4.56,32.48,13.29a45.54,45.54,0,0,1,14.92,30.33c1.49,17.77-10.12,33.19-8,51.76,1.83,16.28,9.1,31.45,18.41,44.75C368.27,1042.51,369.74,1065.37,367.21,1083.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M500.41,1083.51H343.67s0-.65,0-1.78c0-1.71,0-4.52.27-7.8a83.14,83.14,0,0,1,1.4-11c2.49-12.2,5.26-24.72,2.68-37-2.94-14-15.1-22.49-18.28-35.8a34.92,34.92,0,0,1,3.59-25.68,28.17,28.17,0,0,1,2.88-4.08c4.9-5.81,11.3-8.76,17.61-13.4,6.8-5,11.8-12.86,14.24-20.86,4-13,2.76-29.24-4-41.12-.29-.51-.57-1-.85-1.55s-.54-1-.79-1.59-.4-.83-.58-1.25c-.11-.23-.21-.47-.31-.71-.19-.44-.37-.88-.55-1.33s-.39-1-.57-1.51c-.07-.18-.13-.36-.2-.55-.21-.59-.41-1.18-.59-1.78-.1-.3-.19-.59-.27-.89s-.17-.57-.25-.86c-.23-.79-.43-1.59-.62-2.4s-.37-1.62-.52-2.44q-.11-.51-.18-1c-.07-.37-.14-.75-.19-1.12-.08-.52-.16-1.05-.22-1.57a.78.78,0,0,1,0-.14c-.06-.51-.12-1-.17-1.52,0-.17,0-.33-.05-.5q-.07-.79-.12-1.59v0q-.06-.93-.09-1.86t0-1.86c0-.65,0-1.31,0-2,.53-15.85,7.6-31.11,22.81-37.7,5.4-2.34,11.12-4.12,15.88-7.59a26.76,26.76,0,0,0,9.48-29.9c-7.65-22.35,3.88-36.05,34.48-57.37,5.9-4.11,16.36-10.26,22.74-5.42a10.29,10.29,0,0,1,2.88,3.51c5.94,11.32-2.32,22.48-7.46,32.26-9,17.22,1,25.31,10.1,39.19,9,13.71,15,33.08,6.65,48.46-5,9.2-13.07,16.73-17.39,26.15-6,13.06-.43,27.47,6.73,40.22h0c3.34,6,7,11.55,10,16.48,7.47,12.22,10.7,25.06,7.89,39.2-4.5,22.65-12.92,39.26,1.24,60.62C502,1051.7,500.41,1083.51,500.41,1083.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-69",
  d: "M448.41,782.72c6.17,16.66,7.9,38.55-4.37,52.75-7.33,8.49-17.49,14.46-24.18,23.34-13.62,18.08-2,45.31,4.24,63.91,4.93,14.71,5.3,29-.91,43.28-10,22.8-22.59,38.27-12.83,64.25,7.68,20.45,7.76,40.33,6.51,53.26a98.14,98.14,0,0,1-2.42,14.79l-50.55-11.83-12.63-3-7.62-1.78a101.45,101.45,0,0,1,1.67-18.81c2.49-12.2,5.26-24.72,2.68-37-2.94-14-15.1-22.49-18.28-35.8a34.92,34.92,0,0,1,3.59-25.68c5.09-8.73,12.85-11.86,20.49-17.48,6.8-5,11.8-12.86,14.24-20.86,4-13,2.76-29.24-4-41.12a51.06,51.06,0,0,1-3.85-8.49c-7.55-21.43-2.72-49.61,19.53-59.25,5.4-2.34,11.12-4.12,15.88-7.59a26.65,26.65,0,0,0,10.12-15.37h0a26.14,26.14,0,0,0-.64-14.52c-7.65-22.35,3.88-36.05,34.48-57.37,5.9-4.11,16.36-10.26,22.74-5.42-2.28,8.45-9.71,15.41-15.25,22C433.6,754.89,442.17,765.87,448.41,782.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-65",
  d: "M139.24,757.64s-.7-40.8-18.3-52.33S81.61,681.44,78.8,659.6c0,0,10.61,7.58,31.59,6.22,0,0,5.88,6.2,19.94,16.43s16.24,20.44,11.62,39.69C137.69,739.67,138.46,752.34,139.24,757.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M134.31,1000.74c-3.21,14.11-3.41,26.69-.69,42.07a15.5,15.5,0,0,1-12.55,18,15.91,15.91,0,0,1-2.73.24,15.51,15.51,0,0,1-12.35-6.16c-1.63-12.25-2-28.36,1-48.17,2.7-17.48-.54-30.53-6.8-42.29a60.9,60.9,0,0,0-3.93-7.11A40.93,40.93,0,0,0,93,952.91c-6.48-9.14-14.32-18.12-21.94-28.61C58.5,907,54.88,887.71,57.37,866.62c.89-7.53,2.16-16.1,3-25a15.5,15.5,0,0,1,26.4,14.09c-4.7,20.45-4.42,35.43.85,45.82,3.17,6.26,9.19,11.84,15.56,17.74s13.68,12.66,19.19,21.26C134.58,959.58,138.82,981,134.31,1000.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M85.87,813.11a15.87,15.87,0,0,1-24.65,13.22,86.8,86.8,0,0,0-2.76-24.11,15.87,15.87,0,0,1,27.41,10.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M313.34,787.68a56.51,56.51,0,0,0,0,9.56c-1.93-4.74-6.8-13.32-17.34-15.49-14.77-3-24.33-18.25-19.55-29.11s4.06-29.09-10.35-36C297.2,721.49,316,757.78,313.34,787.68Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-37",
  cx: 292.31,
  cy: 812.36,
  r: 11.81
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M390.8,836.76c-18.35,14.06-13.44,36.21-10,44.68s11.72,52.14-27,65.49c6.8-5,11.8-12.86,14.24-20.86,4-13,2.76-29.24-4-41.12a51.06,51.06,0,0,1-3.85-8.49c-7.55-21.43-2.72-49.61,19.53-59.25,5.4-2.34,11.12-4.12,15.88-7.59a26.65,26.65,0,0,0,10.12-15.37C405.77,795,408.92,822.89,390.8,836.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-36",
  d: "M500.41,1083.51H446.8c.55-.24,19.87-9,15.47-41.77-4.46-33.23-18.84-56-7.41-73s23.36-32.83,8.92-62c3.34,6,7,11.55,10,16.48,7.47,12.22,10.7,25.06,7.89,39.2-4.5,22.65-12.92,39.26,1.24,60.62C502,1051.7,500.41,1083.51,500.41,1083.51Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-36",
  cx: 453.16,
  cy: 923.45,
  r: 9.11
})))), /*#__PURE__*/React.createElement("g", {
  id: "Orange_Tulip_2",
  "data-name": "Orange Tulip 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pink_Tulip_2",
  "data-name": "Pink Tulip 2"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 238.97,
  cy: 770.24,
  r: 121.65
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M212.32,867s39.61,12.65,71-16.36a88.19,88.19,0,0,0,17.11-22.07c.21-.4.44-.78.65-1.16,25.09-44.83,30-52.36,30.47-52.45-.43-.16-2.65-1-6.21-2.13h0a118.48,118.48,0,0,0-25.5-4.83h-.05c-22.48-1.63-51.34,3.66-67.16,35.77a89.84,89.84,0,0,0-4.83,12h0a111,111,0,0,0-3,11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M232.65,803.75c15.82-32.11,44.68-37.4,67.16-35.77h.05c2.8,0,5.61-13.73,6.82-23.7s6.47-28.57,6.47-28.57a92.63,92.63,0,0,0-22.29,0C270.13,718.39,256.74,729,248.1,742,233.15,764.53,232.47,794.49,232.65,803.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M248.1,742v0s13.58,15,31,3.8c0,0,7.61-4.92,9-20.21a24.32,24.32,0,0,1,2.76-9.9C270.13,718.39,256.74,729,248.1,742Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M247.45,762.68s-14.54,20-19.63,53c0,0,5.1-15.07,10-21.05,0,0,5.49-16.66,12.61-28.44A7.66,7.66,0,0,1,247.45,762.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M250.48,766.22a9.22,9.22,0,0,0,12.81-2.32l7.21-10.42a9.2,9.2,0,0,0,.78-9.09,9.18,9.18,0,0,0-6.39-5.14,9.25,9.25,0,0,0-9.54,3.75l-7.21,10.41a9.82,9.82,0,0,0-1,2A9.28,9.28,0,0,0,250.48,766.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M247.09,755.41A9.2,9.2,0,0,0,263,756.8l7.21-10.41a9.35,9.35,0,0,0,1-2,9.18,9.18,0,0,0-6.39-5.14,9.25,9.25,0,0,0-9.54,3.75l-7.21,10.41A9.82,9.82,0,0,0,247.09,755.41Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 261.68,
  cy: 746.25,
  r: 4.09
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M247.45,762.68S244,768.06,243,770c0,0,.9,3,3.5,3.61,0,0,4-7.41,4-7.41h0A9.11,9.11,0,0,1,247.45,762.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M227.82,815.7c13.67-20,44.67-13.28,54.61-30.47s42.93-12.41,42.93-12.41h0a118.48,118.48,0,0,0-25.5-4.83h-.05c-22.48-1.63-51.34,3.66-67.16,35.77A89.84,89.84,0,0,0,227.82,815.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M271.58,831.8a16,16,0,0,0,11.76,18.83,88.19,88.19,0,0,0,17.11-22.07c.21-.4.44-.78.65-1.16a15.94,15.94,0,0,0-29.52,4.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M221.45,869s-41.3-4.77-58-44.13a88.12,88.12,0,0,1-6.5-27.15c0-.46-.08-.9-.12-1.34-4.42-51.18-5.77-60-6.18-60.33.45,0,2.84.14,6.53.61h0a118.72,118.72,0,0,1,25.23,6.09s0,0,0,0c21.17,7.76,45.29,24.46,46.5,60.24a92.42,92.42,0,0,1-.52,12.87h0a110.24,110.24,0,0,1-1.78,11.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M229,803c-1.21-35.78-25.33-52.48-46.5-60.24,0,0,0,0,0,0-2.55-1.14.54-14.82,3.53-24.4s5.87-28.7,5.87-28.7a92.63,92.63,0,0,1,20.32,9.16c17.79,11,25.64,26.12,28.16,41.54C244.64,767,232.93,794.59,229,803Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M232.37,759.43s5,24.17-3.94,56.42c0,0,1.56-15.83-.49-23.31,0,0,1.85-17.45.21-31.12A7.57,7.57,0,0,0,232.37,759.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M228.15,761.42a9.23,9.23,0,0,1-10.72-7.4l-2.29-12.45a9.21,9.21,0,0,1,7.41-10.72,8.87,8.87,0,0,1,3.56,0,9.24,9.24,0,0,1,7.16,7.34l2.28,12.46a9.61,9.61,0,0,1,.14,2.26A9.29,9.29,0,0,1,228.15,761.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M235.69,753a9.22,9.22,0,0,1-15.1-5.29l-2.28-12.46a9.61,9.61,0,0,1-.14-2.26,9.24,9.24,0,0,1,4.38-2.1,8.87,8.87,0,0,1,3.56,0,9.24,9.24,0,0,1,7.16,7.34l2.28,12.46A9.61,9.61,0,0,1,235.69,753Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 226.16,
  cy: 738.6,
  r: 4.09
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M232.37,759.43s.91,6.32,1.06,8.53c0,0-2,2.33-4.68,1.86,0,0-.61-8.41-.6-8.4h0A9.08,9.08,0,0,0,232.37,759.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M264.86,863s-14.09-20.36-37.37-22.1-56,9.65-69.22-33.54c0,0,1.22,40.1,54,59.6C212.32,867,236.4,874.7,264.86,863Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M223.08,777.07s-18.28-14.54-39.73-17c0,0-10.71-2.43-21.86-15.87,0,0-6-8.94-10.83-8.17C150.66,736,204.73,737.82,223.08,777.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M238.05,731s-3-9.13-16.84-12.11-17.54-24.64-17.54-24.64S232.14,703.07,238.05,731Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-57",
  cx: 196.91,
  cy: 716.45,
  r: 5.52
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M180.87,849.77s-2.26,33.57,25.11,43.15a41.31,41.31,0,0,0,4.92,1.38c38.13,8.27,46-28.16,46-28.16s-20.1,7.46-45.51,0A87.85,87.85,0,0,1,180.87,849.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M180.87,849.77s-2.26,33.57,25.11,43.15c-7.1-5.26-14.73-21.25-2.58-25.53a19.22,19.22,0,0,1,8.92-.4l-.95-.9A87.85,87.85,0,0,1,180.87,849.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M210.9,894.3S185.84,990,191.38,1098.22"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Rose_1",
  "data-name": "Rose 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rose_1-2",
  "data-name": "Rose 1"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-25",
  x: 1476.08,
  y: 703.67,
  width: 196.92,
  height: 262.66,
  rx: 83.79,
  transform: "translate(824.25 -781.62) rotate(37.17)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-33",
  d: "M1521,909.52s-85.11,114.19-70.9,205.48"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M1659.48,827.86l0,0-2.81,2.19c-4.09,2.69-12.58,6.81-25.63,5.92l-.5-.06c-8.75-.66-19.49-3.58-32.27-10.62-10.7-5.88-17.91-12.47-22.73-18.93v0c-12.81-17.21-8.81-33.61-8.81-33.61l-38.82,65.37a48.78,48.78,0,0,0,17,66.85l8.7,5.16s-74.92-37.57-46.63-91.34l31.65-53.29a44.66,44.66,0,0,1,37.94-22.12c.43,0,.87,0,1.29,0,12.41.31,28.26,4.41,47.24,16.77C1676.79,793.78,1659.48,827.86,1659.48,827.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1544.9,905l16.26-122.9s-75.88,55.18-50.26,91.7C1510.9,873.78,1520,888.11,1544.9,905Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1659.48,827.86,1620.78,893a49,49,0,0,1-67.18,17.12l-8.7-5.16a48.77,48.77,0,0,1-17-66.85l38.82-65.37s-4,16.4,8.81,33.61v0c4.82,6.46,12,13.05,22.73,18.93,12.78,7,23.52,10,32.27,10.62l.5.06c13,.89,21.54-3.23,25.63-5.92a21,21,0,0,0,2.81-2.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1645.34,811.83,1630.5,836c-8.75-.67-19.49-3.59-32.28-10.63-10.68-5.87-17.89-12.46-22.71-18.93h0c-12.82-17.23-8.81-33.62-8.81-33.62s9-17.38,38.59-5.38a70.17,70.17,0,0,1,8.32,4c1.19.64,2.34,1.32,3.46,2.06l.09,0a79,79,0,0,1,16.18,13.64C1640.25,794.79,1647.38,804.74,1645.34,811.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M1607.69,789.47c-5.22,2.88-13.4,7.47-10.19,12.36-8.48-9.46-7-18.93-7-18.93l-15,23.47c-12.81-17.22-8.81-33.6-8.81-33.6s9-17.38,38.59-5.38a70.17,70.17,0,0,1,8.32,4l3.55,2.11S1616.89,784.39,1607.69,789.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M1645.34,811.83,1636,827,1630.5,836c-8.75-.67-19.49-3.59-32.28-10.63-10.68-5.87-17.89-12.46-22.71-18.93h0v0l15-23.47s-1.48,9.47,7,18.93a7.48,7.48,0,0,0,1.76,1.83,40.91,40.91,0,0,0,7,5.35l1.08.66C1631.81,824.08,1645.34,811.83,1645.34,811.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1604.62,808s1.23,2.93-2.66,9.49a35.12,35.12,0,0,1-5.38,6.82s10,6,17,7.9a47,47,0,0,0,5.62-7.86,35.73,35.73,0,0,0,3.11-8.44A66.93,66.93,0,0,1,1604.62,808Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1522.66,852.74s-.18.73-.47,2A4,4,0,0,1,1522.66,852.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M1633,872.44,1620.78,893a49,49,0,0,1-67.18,17.12l-8.7-5.16a48.76,48.76,0,0,1-23.77-45.11c.4-2.12.78-3.87,1.06-5.1-.11,10.79,25,45.16,58.28,45.75C1616,901.16,1633,872.44,1633,872.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1640.85,819.13s-2.65,12.13,15.78,11c0,0-26.1,10.08-43.07,2.17C1613.56,832.25,1629,834.59,1640.85,819.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1571.8,755.94a38.8,38.8,0,0,1-38.58,18.66l5.4-9.09a44.66,44.66,0,0,1,37.94-22.12A38.26,38.26,0,0,1,1571.8,755.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M1553.6,910.14s-7.2,10.92-28.07,2.11a18,18,0,0,1-8.41-7.26,31.57,31.57,0,0,1-3.74-9.1,29.2,29.2,0,0,1-.67-9.38,32.16,32.16,0,0,1,1.75-7.88h0c.06.06.38.39,1,1a0,0,0,0,1,0,0c2.13,2.09,7.68,7.34,17,14.78l0,0c3.61,2.89,7.79,6.1,12.56,9.58q4,2.94,8.54,6.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M1521,909.52s18.38,3.11,22.72-6.43l9.85,7S1539.93,924.88,1521,909.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1520.33,891.06a5.16,5.16,0,0,1-5.16,5.16,5.08,5.08,0,0,1-1.79-.33,29.2,29.2,0,0,1-.67-9.38,5.17,5.17,0,0,1,7.62,4.55Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Multicoloured_Flower_3",
  "data-name": "Multicoloured Flower 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Multicoloured_Flower_3-2",
  "data-name": "Multicoloured Flower 3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-48",
  d: "M432.6,913.88s2.7,100.2-31.19,189.42"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M429.19,830.78c-1.42-3-24.25-57-45.17-47.8,0,0-5.07,2-6.34,9.17s-14.59,1-17.76,6.63,1.27,9.68-4.43,13.25-33.61,24.64,55.79,38.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M418.45,836.12c-4.88-8-17.16-28.11-23.81-28.38-9-.37-3,4.79-6.6,8.39s-10.16-1.31-10.36,5.07c-.27,8.66,36.65,19.42,36.65,19.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M448.35,868.56s26.29,52.18,16.57,73.59c-3.18,7-13.42,10.06-21.69,6.71-4.13-1.68-9.91-3.61-14-3.31-7.13.51-57.35,14.21-4-77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M412.7,857s-96.53,30.27-59.23,64c3.5,3.16,8.32,3.89,12.11,6.42,3.61,2.42,3.63,6.93,7.5,9.11,7.21,4.06,19.85-2.54,23-7.83,4.75-8,24-35.86,29.1-60.17a34.8,34.8,0,0,1-9.14-6.09A11.28,11.28,0,0,1,412.7,857Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M416,862.54q-9.56,5.16-18.69,10.79c-5.44,3.36-10.77,6.83-15.88,10.5a46.42,46.42,0,0,0-8.27,7.1c-1.49,1.75-2.66,4.16-1.16,5.91a5.44,5.44,0,0,0,3.55,1.56c1.38.15,3.72,1.09,3.64,3.32a3.29,3.29,0,0,0,2.18,2.91c1.71.71,3.8.14,5.49-.6a40.42,40.42,0,0,0,8.68-5.38,81.11,81.11,0,0,0,15.75-16.07,62.72,62.72,0,0,0,8.91-16.73A13.59,13.59,0,0,1,416,862.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M322.21,872.27c.7,6.48,13.93,9.76,20.41,8.43,6.27-1.29,23.21-4,40.93-8.8h0l.11,0a178.77,178.77,0,0,0,28.79-10.06,21,21,0,0,1,0-8.75,10.11,10.11,0,0,1,2.83-5.1s-83.32-36.88-91,4.09c-.7,3.82,1.49,7,1.49,10.63C325.8,866.15,321.86,868.8,322.21,872.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M412.35,853.06q-10.14-2.37-20.45-4.24c-6.14-1.11-12.32-2.08-18.54-2.82a57.08,57.08,0,0,0-11.08-.52c-2.42.19-5.23.94-5.88,2.82a3.16,3.16,0,0,0,.72,2.93,2.61,2.61,0,0,1-.76,4,2.72,2.72,0,0,0-1.28,3c.38,1.39,2.12,2.23,3.76,2.76a45,45,0,0,0,9.81,1.75,107.31,107.31,0,0,0,23.36-.52,93.29,93.29,0,0,0,19.92-4.8A8.73,8.73,0,0,1,412.35,853.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M404.92,791.39c2.59,16.8,14.39,38.46,15.32,40.34l29.63,4.71c54.48-58.59,16.18-59,9-58.54s-7.36-4.95-14.4-7.37-11.73,9.32-18.65,4.74-12.38-3.33-12.38-3.33a11,11,0,0,0-4.85,2.16C404.36,777.5,403.75,784,404.92,791.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M432.63,829.84c-3.13-8.56-10.94-30.05-6.27-33.86,6.32-5.15,6.25,1.9,11.93,2.61s6.38-6.48,11.89-1.88c7.48,6.24-10.73,34.21-10.73,34.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M437.82,870a258.71,258.71,0,0,0,12.52,23.11l0,.07c9.46,15.58,23.15,34.28,37.05,40.1,8.2,3.43,18.33.14,21.63-6.83,1.63-3.47,4.29-8.05,7.56-10.06,5.69-3.48,54.24-20.63-61.69-59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M454.92,857.42c24.21,15.14,61.75,25.25,72,28.6,6.74,2.19,21.6.22,23.53-6.71,1-3.7-2.75-7-2.14-10.79.68-3.92,3.62-7.06,3.54-11.31a22.83,22.83,0,0,0-3.07-11.59c-5.2-8.73-16.49-12.3-29.51-13.09-28.35-1.76-64.87,9.59-64.87,9.59a10.66,10.66,0,0,1,2.13,5.84A23.3,23.3,0,0,1,454.92,857.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M456.66,848q11.37-1.37,22.85-2.17c6.83-.48,13.68-.81,20.54-.88a62.91,62.91,0,0,1,12.05.75c2.58.48,5.47,1.63,5.83,3.73a3.58,3.58,0,0,1-1.31,3.08,2.81,2.81,0,0,0,.1,4.42,2.84,2.84,0,0,1,.83,3.34c-.66,1.45-2.68,2.16-4.55,2.53a49.68,49.68,0,0,1-10.92.74A115.31,115.31,0,0,1,477,860.21a96.79,96.79,0,0,1-20.63-7.51A9.47,9.47,0,0,0,456.66,848Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M444.91,836.84a15.9,15.9,0,0,1,6.37,2.23,28.88,28.88,0,0,1,7.35,6.48c3.48-.61,7-1.39,10.57-2.3a.65.65,0,0,0,.2,0l1.67-.42c23.79-6.36,47.35-17.93,55-21.21a18.49,18.49,0,0,0,8.73-9.06c1.28-3,1.37-6-.76-8.21-2.66-2.75-7.79-2.58-10.71-5.14s-4.09-6.22-7.86-8.66C475.39,764.43,444.91,836.84,444.91,836.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M451.36,839q5.49-7.26,11.53-14.23c3.59-4.15,7.34-8.22,11.31-12.15a42.76,42.76,0,0,1,7.74-6.39c1.94-1.17,4.64-2.14,6.7-1.1a3.69,3.69,0,0,1,1.93,2.55,3.57,3.57,0,0,0,3.93,2.54,4.08,4.08,0,0,1,3.42,1.49c.89,1.23.32,2.79-.45,4.07a30.91,30.91,0,0,1-5.77,6.62A84.53,84.53,0,0,1,474,834.71,87.85,87.85,0,0,1,455.31,842,12.7,12.7,0,0,0,451.36,839Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M432.83,870.48c-3.69,8.42-12.89,29.55-8.47,33.55,6,5.41,6.37-1.64,12.08-2.1s6,6.74,11.76,2.38c7.87-5.93-8.49-34.62-8.49-34.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M450.89,863c9.78,4.21,34.32,14.8,34.42,20.16.14,7.22-6.07,2.24-10.68,5s1.27,8.2-6.67,8.13c-10.78-.1-22.81-30.15-22.81-30.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M408.51,852.82c0,12.09,12.2,21.89,27.26,21.89S463,864.91,463,852.82a15.68,15.68,0,0,0-.47-3.94c-2.27-10.23-13.4-18-26.77-18s-24.52,7.72-26.8,18A16.15,16.15,0,0,0,408.51,852.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M409,848.88c2.31,10.21,13.43,18,26.8,18s24.47-7.74,26.77-18a20.76,20.76,0,0,0-8.23-12.06v0a30.82,30.82,0,0,0-18.54-5.87c-.29,0-.58,0-.84,0C421.91,831.26,411.19,838.86,409,848.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M428.71,844.14c2.51,5.68,10.28,8.64,17.34,6.62s10.77-8.24,8.26-13.94v0a30.82,30.82,0,0,0-18.54-5.87c-.29,0-.58,0-.84,0C429.21,833.49,426.46,839,428.71,844.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M322.21,872.27c.7,6.48,13.93,9.76,20.41,8.43,6.27-1.29,23.21-4,40.93-8.8-2.43.37-33.46,5-41.23-1.08-8.08-6.31-12.61-3.47-16.52-8.14C325.8,866.15,321.86,868.8,322.21,872.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M469.26,843.22l.14,0,1.67-.42c23.79-6.36,47.35-17.93,55-21.21a18.49,18.49,0,0,0,8.73-9.06s-12.2,4.93-29.34,3.61S481.9,838.49,469.26,843.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M450.34,893.11l0,.07c9.46,15.58,23.15,34.28,37.05,40.1,8.2,3.43,18.33.14,21.63-6.83,0,0-18.36,7.63-26.92-9.2S460.85,894.56,450.34,893.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M518,837.8c0,7.54,7.59,13.64,17,13.64a18.39,18.39,0,0,0,13.89-5.82c-5.2-8.73-16.49-12.3-29.51-13.09A10.93,10.93,0,0,0,518,837.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-53",
  d: "M404.92,791.39c9.08,10.7,19.23,28.91,20,30.2-.35-1.27-6-22-6.42-30.83-.29-5.82-5.87-12.53-9.9-16.66C404.36,777.5,403.75,784,404.92,791.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-54",
  d: "M440.13,874.71s3.32,49,26.94,57.46c0,0-1.16-14.68-1.84-17.28,0,0-20.65-30.1-22.08-41Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-52",
  cx: 501,
  cy: 796.74,
  r: 6.58
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-53",
  cx: 364.69,
  cy: 821.59,
  r: 6.58
}))), /*#__PURE__*/React.createElement("g", {
  id: "Multicoloured_Flower_2",
  "data-name": "Multicoloured Flower 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Multicoloured_Flower_2-2",
  "data-name": "Multicoloured Flower 2"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 823.8,
  cy: 913.5,
  r: 153.74
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 823.8,
  cy: 916.5,
  r: 111.77
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 823.8,
  cy: 919.46,
  r: 78.42
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-48",
  d: "M828,918.32S783,1023.1,862,1117.05"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M831.33,876.81c1.79-3,31.84-57.9,48.28-44.8,0,0,4,3,3.77,10.88s12.48,3.32,14.17,9.86-2.93,10.27,1.35,15,24.53,31.75-55.72,32.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M839.64,884.21c5.75-7.92,20.23-27.77,26.06-27.05,7.87,1,1.71,5.64,4.15,10.08s9.07.11,8,7c-1.4,9.41-35.51,15.42-35.51,15.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M807.53,914.73s-32.71,52.39-28.32,77a13.76,13.76,0,0,0,17.58,10.54c3.9-1.18,9.29-2.39,12.82-1.44,6.09,1.63,47.13,24.08,18.06-82.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M840.69,907.67s78.12,47.4,39.33,78.19c-3.63,2.89-8,2.94-11.73,5.11-3.59,2.06-4.46,6.93-8.24,8.7-7,3.29-16.77-5.77-18.49-12-2.61-9.4-14-42.41-13.89-69.45a31,31,0,0,0,9.09-5.2A13.3,13.3,0,0,0,840.69,907.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M836.8,913.15q7.32,7,14.19,14.5c4.09,4.45,8.06,9,11.81,13.77a44.36,44.36,0,0,1,5.84,8.92c1,2.12,1.53,4.91-.11,6.57a4.48,4.48,0,0,1-3.38,1.15,3.59,3.59,0,0,0-3.79,3,3.61,3.61,0,0,1-2.45,2.82c-1.61.51-3.32-.43-4.65-1.48a35.37,35.37,0,0,1-6.52-7.13,83.1,83.1,0,0,1-10.64-19.77,75.63,75.63,0,0,1-4.58-19.44A12.86,12.86,0,0,0,836.8,913.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M916.41,937.92c-1.84,6.9-13.95,8.44-19.33,6-5.2-2.35-19.4-7.86-33.89-15.73h0l-.1,0A138.76,138.76,0,0,1,840,912.88a28.52,28.52,0,0,0,1.68-9.45,12.06,12.06,0,0,0-1.49-5.93s79.35-27.2,78.25,18.24c-.12,4.24-2.62,7.33-3.31,11.26C914.44,930.76,917.37,934.22,916.41,937.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M841.73,903.45q9.27-1,18.57-1.47c5.55-.27,11.1-.38,16.65-.24a41.2,41.2,0,0,1,9.72,1.13c2.07.57,4.36,1.81,4.57,3.94a4.09,4.09,0,0,1-1.18,3.06,3.29,3.29,0,0,0-.09,4.45,3.34,3.34,0,0,1,.54,3.38c-.59,1.45-2.25,2.09-3.78,2.41a32.45,32.45,0,0,1-8.86.4,76.16,76.16,0,0,1-20.19-4.12,69.27,69.27,0,0,1-16.39-8.2A11.69,11.69,0,0,0,841.73,903.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M859.86,837.93c-5.43,17.76-19.78,39.37-20.94,41.26l-26.64.59c-36.23-71.61-2.88-66.24,3.3-64.64s7.32-4.23,13.89-5.77,8.44,11.85,15.31,8,11.38-1.72,11.38-1.72a8.89,8.89,0,0,1,3.81,3.07C863,823,862.28,830.09,859.86,837.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M828.51,875.26c4.34-8.77,15.2-30.8,11.86-35.64-4.51-6.52-5.79,1.11-10.86,1s-4.32-8-10-3.84c-7.68,5.61,2.84,38.61,2.84,38.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M816.41,917.88s-6.23,10.65-15.25,23.08l0,.07c-11.17,15.4-26.6,33.53-39.77,37.7a13.76,13.76,0,0,1-17.5-10.67c-.77-4-2.21-9.35-4.67-12-4.29-4.61-43.21-30.54,64.75-54.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M803.93,901.69c-23.89,12.67-58.42,17.89-68,20-6.27,1.33-18.81-3.06-19.17-10.84-.19-4.16,3.72-7.19,3.89-11.34.16-4.33-1.8-8.18-.92-12.76a29.93,29.93,0,0,1,4.85-12.06c6.17-8.64,16.66-10.78,28.12-9.66,25,2.41,54.53,20.24,54.53,20.24a13.45,13.45,0,0,0-3,6A31,31,0,0,0,803.93,901.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M804.21,891.22q-9.63-3.21-19.44-5.83c-5.84-1.55-11.73-2.95-17.68-4.06a44.63,44.63,0,0,0-10.61-1c-2.33.13-5.05.93-5.77,3.15a4.47,4.47,0,0,0,.56,3.53,3.59,3.59,0,0,1-.92,4.76,3.62,3.62,0,0,0-1.36,3.47c.3,1.68,1.92,2.75,3.47,3.44a35.73,35.73,0,0,0,9.35,2.46,83.48,83.48,0,0,0,22.44.24,75.7,75.7,0,0,0,19.35-5A12.86,12.86,0,0,1,804.21,891.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M816.52,881a12.14,12.14,0,0,0-5.95,1.44,28.48,28.48,0,0,0-7.62,5.88c-2.9-1.19-5.85-2.57-8.74-4.09a.65.65,0,0,1-.17-.08l-1.37-.71c-19.46-10.5-37.74-26.58-43.74-31.29-2.64-2.06-5.16-6.65-5.86-11.12-.56-3.39-.06-6.7,2.21-8.76,2.83-2.56,7.26-1.6,10.28-3.92,3.17-2.43,4.72-6.1,8.46-8.17C803.75,798.07,816.52,881,816.52,881Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M810.5,882.35q-3.39-8.69-7.32-17.13c-2.34-5-4.82-10-7.52-14.85a41.08,41.08,0,0,0-5.52-8.08c-1.46-1.57-3.63-3-5.61-2.22a4.06,4.06,0,0,0-2.16,2.46,3.31,3.31,0,0,1-3.9,2.16,3.32,3.32,0,0,0-3.25,1.08c-1,1.19-.8,3-.38,4.47a32.7,32.7,0,0,0,3.77,8,76.37,76.37,0,0,0,13,16,69.21,69.21,0,0,0,14.89,10.7A11.7,11.7,0,0,1,810.5,882.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M820.65,919.16c1.61,9.66,5.6,33.9,1,37.55-6.21,4.94-5.22-2.74-10.1-4.11s-6.45,6.38-10.66.78c-5.72-7.59,13.93-36.12,13.93-36.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M806.38,908.32c-9.3,3.06-32.62,10.78-33.72,16.55-1.49,7.79,4.85,3.35,8.33,7s-2.65,8.67,4.26,9.8c9.38,1.54,25.52-29.11,25.52-29.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M845.12,903.78a24,24,0,0,1-47.35-8.29,22.89,22.89,0,0,1,1.15-4.19,24,24,0,0,1,46.54,8.14A22.08,22.08,0,0,1,845.12,903.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M845.46,899.44a24,24,0,0,1-46.54-8.14,23.59,23.59,0,0,1,9.44-11.79v0A23.79,23.79,0,0,1,825.58,876c.25,0,.5.09.73.15A23.92,23.92,0,0,1,845.46,899.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M829.21,891.32a12,12,0,0,1-20.85-11.81v0A23.79,23.79,0,0,1,825.58,876c.25,0,.5.09.73.15A12,12,0,0,1,829.21,891.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M916.41,937.92c-1.84,6.9-13.95,8.44-19.33,6-5.2-2.35-19.4-7.86-33.89-15.73,2,.77,28.13,10.46,36,5.1,8.22-5.59,11.61-1.83,15.89-6.29C914.44,930.76,917.37,934.22,916.41,937.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M794.16,884.16s-.07,0-.12,0l-1.37-.71c-19.46-10.5-37.74-26.58-43.74-31.29-2.64-2.06-5.16-6.65-5.86-11.12a51.53,51.53,0,0,0,24.8,8.37C783,850.57,784.08,877.12,794.16,884.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M801.16,941l0,.07c-11.17,15.4-26.6,33.53-39.77,37.7a13.76,13.76,0,0,1-17.5-10.67s14.51,11,25.12-5.84S791.75,940.93,801.16,941Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M752.89,870.9a15,15,0,0,1-28.29,3.75c6.17-8.64,16.66-10.78,28.12-9.66A14.64,14.64,0,0,1,752.89,870.9Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-52",
  cx: 823.96,
  cy: 985.88,
  r: 6.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-53",
  d: "M859.86,837.93c-9.91,10.18-22.18,28.32-23.06,29.6.55-1.32,9.36-22.83,11.42-32.35,1.35-6.24,7.46-12.65,11.75-16.5C863,823,862.28,830.09,859.86,837.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-54",
  d: "M813.51,922.63s-12.17,52.5-34.28,58c0,0,3.78-15.69,4.87-18.4,0,0,23.64-29.39,26.94-41Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Multicoloured_Flower_1",
  "data-name": "Multicoloured Flower 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Multicoloured_Flower_1-2",
  "data-name": "Multicoloured Flower 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1777.1,
  cy: 855.49,
  r: 153.74
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1777.1,
  cy: 858.49,
  r: 111.77
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1777.1,
  cy: 861.45,
  r: 78.42
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-48",
  d: "M1776.24,883.31s48.49,127-39.57,231.69"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M1772.54,837.05c-2-3.33-35.49-64.55-53.82-49.95,0,0-4.48,3.32-4.2,12.13s-13.91,3.7-15.8,11,3.27,11.46-1.5,16.72-27.35,35.4,62.11,36.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1763.28,845.3c-6.42-8.83-22.55-31-29-30.16-8.78,1.07-1.91,6.29-4.63,11.23s-10.11.14-9,7.86c1.57,10.48,39.6,17.18,39.6,17.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1799.07,879.32s36.47,58.4,31.57,85.85a15.34,15.34,0,0,1-19.59,11.76c-4.36-1.32-10.36-2.67-14.3-1.61-6.79,1.82-52.53,26.84-20.13-92.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M1762.11,871.45s-87.09,52.84-43.85,87.16c4.06,3.22,8.88,3.28,13.08,5.69,4,2.31,5,7.73,9.18,9.7,7.84,3.67,18.69-6.43,20.61-13.33,2.91-10.48,15.64-47.27,15.49-77.42a34.53,34.53,0,0,1-10.14-5.8A14.71,14.71,0,0,1,1762.11,871.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1766.44,877.55q-8.16,7.85-15.82,16.17c-4.56,5-9,10.06-13.16,15.35A49.64,49.64,0,0,0,1731,919c-1.08,2.37-1.7,5.47.12,7.33a5,5,0,0,0,3.77,1.28,4,4,0,0,1,4.22,3.37,4,4,0,0,0,2.73,3.14c1.81.57,3.71-.48,5.19-1.65a39.84,39.84,0,0,0,7.27-8,93.2,93.2,0,0,0,11.86-22,84.55,84.55,0,0,0,5.1-21.67A14.35,14.35,0,0,1,1766.44,877.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1677.7,905.17c2,7.69,15.55,9.4,21.54,6.69,5.81-2.62,21.63-8.77,37.78-17.54h0l.11-.05a155.6,155.6,0,0,0,25.75-17,31.8,31.8,0,0,1-1.88-10.54,13.59,13.59,0,0,1,1.67-6.62s-88.46-30.31-87.23,20.35c.13,4.72,2.92,8.17,3.69,12.55C1679.89,897.18,1676.63,901.05,1677.7,905.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1760.94,866.74q-10.32-1.14-20.7-1.64c-6.18-.3-12.37-.42-18.55-.26a45.83,45.83,0,0,0-10.84,1.26c-2.3.63-4.86,2-5.09,4.39a4.51,4.51,0,0,0,1.31,3.41,3.66,3.66,0,0,1,.11,5,3.69,3.69,0,0,0-.61,3.77c.66,1.61,2.51,2.33,4.21,2.69a36.32,36.32,0,0,0,9.88.44,84.94,84.94,0,0,0,22.51-4.59,77.18,77.18,0,0,0,18.27-9.15A13.28,13.28,0,0,1,1760.94,866.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M1740.73,793.7c6.06,19.8,22,43.9,23.35,46l29.69.66c40.4-79.83,3.22-73.84-3.67-72.06s-8.17-4.71-15.49-6.43-9.4,13.21-17.06,8.87-12.69-1.92-12.69-1.92a9.85,9.85,0,0,0-4.24,3.43C1737.26,777.06,1738,785,1740.73,793.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1775.68,835.32c-4.84-9.78-16.94-34.34-13.21-39.73,5-7.27,6.45,1.24,12.1,1.13s4.81-8.9,11.12-4.29c8.55,6.25-3.18,43-3.18,43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1789.17,882.83s6.95,11.87,17,25.72l0,.08c12.45,17.17,29.65,37.38,44.33,42a15.35,15.35,0,0,0,19.51-11.9c.85-4.46,2.46-10.42,5.2-13.41,4.78-5.15,48.18-34-72.17-60.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M1803.09,864.78c26.63,14.13,65.12,20,75.77,22.25,7,1.48,21-3.41,21.37-12.08.21-4.64-4.14-8-4.34-12.64-.17-4.84,2-9.12,1-14.23a33.29,33.29,0,0,0-5.41-13.44c-6.88-9.64-18.57-12-31.35-10.77-27.82,2.68-60.79,22.56-60.79,22.56a15.07,15.07,0,0,1,3.3,6.68A34.77,34.77,0,0,1,1803.09,864.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1802.78,853.11q10.73-3.58,21.66-6.5c6.52-1.73,13.08-3.28,19.71-4.53a49.62,49.62,0,0,1,11.83-1.14c2.6.14,5.63,1,6.43,3.51a4.94,4.94,0,0,1-.62,3.93,4,4,0,0,0,1,5.31,4,4,0,0,1,1.51,3.87c-.33,1.87-2.14,3.06-3.87,3.83a39.76,39.76,0,0,1-10.42,2.74,92.76,92.76,0,0,1-25,.27,84,84,0,0,1-21.56-5.55A14.51,14.51,0,0,0,1802.78,853.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1789.05,841.68a13.51,13.51,0,0,1,6.63,1.61,31.73,31.73,0,0,1,8.49,6.55c3.24-1.32,6.52-2.86,9.75-4.56a.48.48,0,0,0,.19-.09l1.52-.79c21.7-11.7,42.08-29.63,48.76-34.88,2.95-2.29,5.75-7.42,6.54-12.39.62-3.78.07-7.47-2.46-9.77-3.16-2.85-8.1-1.78-11.46-4.37-3.54-2.7-5.27-6.8-9.43-9.1C1803.29,749.27,1789.05,841.68,1789.05,841.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1795.76,843.22q3.78-9.68,8.16-19.1c2.61-5.61,5.37-11.15,8.39-16.55a45.55,45.55,0,0,1,6.15-9c1.63-1.75,4-3.37,6.25-2.47a4.54,4.54,0,0,1,2.41,2.75,3.67,3.67,0,0,0,4.34,2.39,3.74,3.74,0,0,1,3.63,1.22c1.12,1.33.89,3.31.42,5a36.53,36.53,0,0,1-4.19,9,85.18,85.18,0,0,1-14.53,17.8,77.14,77.14,0,0,1-16.59,11.93A13.11,13.11,0,0,0,1795.76,843.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1784.44,884.26c-1.79,10.76-6.24,37.78-1.12,41.86,6.93,5.5,5.82-3.06,11.26-4.59s7.18,7.12,11.88.88c6.38-8.47-15.52-40.28-15.52-40.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M1800.35,872.17c10.37,3.41,36.36,12,37.59,18.45,1.66,8.68-5.41,3.73-9.29,7.83s3,9.67-4.74,10.94c-10.46,1.71-28.45-32.46-28.45-32.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M1757.17,867.1a26.79,26.79,0,0,0,52.78-9.24,24.22,24.22,0,0,0-1.29-4.67,26.77,26.77,0,0,0-51.87,9.09A23.21,23.21,0,0,0,1757.17,867.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M1756.79,862.28a26.77,26.77,0,0,0,51.87-9.09,26.28,26.28,0,0,0-10.51-13.13v0a26.47,26.47,0,0,0-19.19-3.92,5,5,0,0,0-.81.17A26.65,26.65,0,0,0,1756.79,862.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M1774.9,853.22a13.36,13.36,0,0,0,23.25-13.16v0a26.47,26.47,0,0,0-19.19-3.92,5,5,0,0,0-.81.17A13.31,13.31,0,0,0,1774.9,853.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1677.7,905.17c2,7.69,15.55,9.4,21.54,6.69,5.81-2.62,21.63-8.77,37.78-17.54-2.27.86-31.35,11.67-40.15,5.69-9.16-6.24-12.94-2-17.71-7C1679.89,897.18,1676.63,901.05,1677.7,905.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1814,845.24s.08,0,.14,0l1.52-.79c21.7-11.7,42.08-29.63,48.76-34.88,2.95-2.29,5.75-7.42,6.54-12.39,0,0-10.77,8-27.65,9.33S1825.22,837.39,1814,845.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1806.18,908.55l0,.08c12.45,17.17,29.65,37.38,44.33,42a15.35,15.35,0,0,0,19.51-11.9s-16.17,12.3-28-6.52S1816.66,908.52,1806.18,908.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M1860,830.46a16.67,16.67,0,0,0,31.53,4.18c-6.88-9.64-18.57-12-31.35-10.77A16.19,16.19,0,0,0,1860,830.46Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-52",
  cx: 1780.75,
  cy: 958.63,
  r: 6.99
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-53",
  d: "M1740.73,793.7c11,11.35,24.73,31.57,25.71,33-.61-1.47-10.43-25.45-12.72-36.06-1.51-7-8.33-14.1-13.1-18.39C1737.26,777.06,1738,785,1740.73,793.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-54",
  d: "M1792.41,888.12s13.56,58.53,38.21,64.66c0,0-4.22-17.5-5.43-20.51,0,0-26.35-32.76-30-45.66Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Lavender_1-3",
  "data-name": "Lavender 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lavender_1-4",
  "data-name": "Lavender 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M91.37,835.69S79.73,845.88,66,848.2c0,0-6-4.61-8.86-26.41l15.67-15.25L88.87,817Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M83.2,841.46s-8.47-8.58-5.9-21l7.88-.38s-.65,9.73,6.19,15.6C91.37,835.69,89,838.39,83.2,841.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M133.08,733.85a13.83,13.83,0,0,1-27.32-.7,13.51,13.51,0,0,1,.12-4.34,13.83,13.83,0,0,1,27.2,5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M130.05,726.88a13.83,13.83,0,0,1-24.29,6.27,13.51,13.51,0,0,1,.12-4.34,13.82,13.82,0,0,1,24.28-6.26A13.44,13.44,0,0,1,130.05,726.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M116.13,727.51c-5.61-.27-8.34.59-10.37,5.64a13.51,13.51,0,0,1,.12-4.34A13.83,13.83,0,0,1,122,717.73S121.74,727.78,116.13,727.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M137.91,754.69a13.84,13.84,0,0,1-27.32-.71,13.45,13.45,0,0,1,.12-4.33,13.83,13.83,0,0,1,27.2,5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M134.88,747.72A13.83,13.83,0,0,1,110.59,754a13.45,13.45,0,0,1,.12-4.33A13.82,13.82,0,0,1,135,743.39,13.74,13.74,0,0,1,134.88,747.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M121,748.35c-5.61-.27-8.34.59-10.37,5.63a13.45,13.45,0,0,1,.12-4.33,13.83,13.83,0,0,1,16.12-11.09S126.57,748.62,121,748.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M118.73,743.72a17.12,17.12,0,1,1-3.61-14A17.1,17.1,0,0,1,118.73,743.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M115,735.11a17.09,17.09,0,0,1-30,7.74,17.1,17.1,0,0,1,30.16-13.09A16.91,16.91,0,0,1,115,735.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M97.78,735.89c-6.93-.34-10.31.72-12.82,7A17.13,17.13,0,0,1,105,723.8S104.71,736.22,97.78,735.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M96.39,761.07a15.72,15.72,0,1,1-3.31-12.81A15.71,15.71,0,0,1,96.39,761.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M93,753.17a15.69,15.69,0,0,1-27.55,7.1,15.69,15.69,0,0,1,27.68-12A15.68,15.68,0,0,1,93,753.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M77.16,753.88c-6.36-.31-9.46.67-11.76,6.39a15.7,15.7,0,0,1,18.41-17.49S83.52,754.19,77.16,753.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M105.9,784.57a13.84,13.84,0,1,1-11.09-16.12,13.84,13.84,0,0,1,11.09,16.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M102.87,777.6a13.83,13.83,0,0,1-24.29,6.26A13.83,13.83,0,0,1,103,773.27,13.74,13.74,0,0,1,102.87,777.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M126.23,770.87a17.24,17.24,0,1,1-13.81-20.1,17.46,17.46,0,0,1,4.23,1.37,17.1,17.1,0,0,1,5.77,4.44l.17.2A17.21,17.21,0,0,1,126.23,770.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M122.46,762.19A17.24,17.24,0,0,1,92.18,770a17.25,17.25,0,0,1,20.24-19.22,17.46,17.46,0,0,1,4.23,1.37,17.1,17.1,0,0,1,5.77,4.44l.17.2A17,17,0,0,1,122.46,762.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M105.11,763c-7-.34-10.4.73-12.93,7a17.25,17.25,0,0,1,20.24-19.22S112.1,763.3,105.11,763Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M130.44,798.74a17.26,17.26,0,1,1-3.64-14.09A17.24,17.24,0,0,1,130.44,798.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M126.67,790.05a17.24,17.24,0,0,1-30.28,7.81,17.24,17.24,0,0,1,30.41-13.21A16.93,16.93,0,0,1,126.67,790.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M109.32,790.83c-7-.33-10.4.74-12.93,7a17.28,17.28,0,0,1,20.24-19.22S116.31,791.17,109.32,790.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M122.33,822.74a20,20,0,0,1-39.59-1,19.84,19.84,0,0,1,.17-6.28,20,20,0,0,1,23.36-16.06,20.26,20.26,0,0,1,3.68,1.06,19.64,19.64,0,0,1,6.59,4.24,19.27,19.27,0,0,1,1.56,1.69A20,20,0,0,1,122.33,822.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M117.94,812.65a20,20,0,0,1-35.2,9.08,19.84,19.84,0,0,1,.17-6.28,20,20,0,0,1,23.36-16.06,20.26,20.26,0,0,1,3.68,1.06,19.64,19.64,0,0,1,6.59,4.24,19.27,19.27,0,0,1,1.56,1.69A20.06,20.06,0,0,1,117.94,812.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M97.77,813.56c-8.13-.39-12.09.85-15,8.17a20.07,20.07,0,0,1,23.53-22.34S105.89,814,97.77,813.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M71.4,807.89A17.24,17.24,0,0,1,37.35,807a16.94,16.94,0,0,1,.14-5.4,17.24,17.24,0,0,1,33.91,6.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M67.62,799.21A17.24,17.24,0,0,1,37.35,807a16.94,16.94,0,0,1,.14-5.4,17.24,17.24,0,0,1,30.27-7.81A16.93,16.93,0,0,1,67.62,799.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M50.28,800c-7-.33-10.4.74-12.93,7a16.94,16.94,0,0,1,.14-5.4A17.24,17.24,0,0,1,57.58,787.8S57.26,800.33,50.28,800Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M85.48,780.86A17.25,17.25,0,0,1,51.43,780h0a17.24,17.24,0,0,1,20.23-19.21l.78.16q.77.18,1.5.42a15.88,15.88,0,0,1,1.77.7h0a17.72,17.72,0,0,1,1.68.87,17.25,17.25,0,0,1,4.46,3.86,17.23,17.23,0,0,1,3.64,14.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M81.7,772.18c-.06.31-.12.61-.2.92A17.23,17.23,0,0,1,51.43,780a17.24,17.24,0,0,1,20.23-19.21l.78.16q.77.18,1.5.42a15.88,15.88,0,0,1,1.77.7,14.69,14.69,0,0,1,1.67.87,17.25,17.25,0,0,1,4.46,3.86A17,17,0,0,1,81.7,772.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M64.36,773c-7-.34-10.4.73-12.93,7a17.24,17.24,0,0,1,20.24-19.21S71.35,773.3,64.36,773Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M107.9,738a13.84,13.84,0,0,1-27.32-.71A13.45,13.45,0,0,1,80.7,733a13.83,13.83,0,0,1,27.2,5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M104.87,731a13.83,13.83,0,0,1-14.61,11.28,13.26,13.26,0,0,1-1.51-.19,13.84,13.84,0,0,1-4.91-1.94,13.45,13.45,0,0,1-3.26-2.89A13.45,13.45,0,0,1,80.7,733a13.82,13.82,0,0,1,16.12-11.08,13.65,13.65,0,0,1,8.16,4.82A13.16,13.16,0,0,1,104.87,731Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M91,731.67c-5.62-.27-8.35.59-10.38,5.63A13.45,13.45,0,0,1,80.7,733a13.83,13.83,0,0,1,16.12-11.09S96.56,731.94,91,731.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M92.19,739.45a4.34,4.34,0,0,1-1.93,2.87,13.26,13.26,0,0,1-1.51-.19,13.84,13.84,0,0,1-4.91-1.94,4.23,4.23,0,0,1-.22-2.32,4.36,4.36,0,0,1,8.57,1.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M124.36,718.17A13.84,13.84,0,0,1,97,717.46a14,14,0,0,1,.12-4.33,13.84,13.84,0,0,1,27.21,5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M121.33,711.2A13.83,13.83,0,0,1,97,717.46a14,14,0,0,1,.12-4.33,13.83,13.83,0,0,1,24.29-6.26A13.74,13.74,0,0,1,121.33,711.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M107.41,711.83c-5.62-.27-8.35.58-10.38,5.63a14,14,0,0,1,.12-4.33A13.83,13.83,0,0,1,113.27,702S113,712.1,107.41,711.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M97.39,806.65a17.24,17.24,0,0,1-34-.88,17,17,0,0,1,.14-5.4,17.24,17.24,0,0,1,33.91,6.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M93.61,798a17.23,17.23,0,0,1-30.27,7.8,17,17,0,0,1,.14-5.4,17.24,17.24,0,0,1,30.27-7.8A16.94,16.94,0,0,1,93.61,798Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M76.27,798.75c-7-.34-10.4.73-12.93,7a17,17,0,0,1,.14-5.4,17.23,17.23,0,0,1,20.09-13.81S83.25,799.09,76.27,798.75Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 75.61,
  cy: 805.12,
  r: 4.35
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M122.36,757a4.35,4.35,0,1,1-5.71-4.9,17.1,17.1,0,0,1,5.77,4.44A3.4,3.4,0,0,1,122.36,757Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M84.25,770.66a6.26,6.26,0,1,1-8.55-8.61h0a14.69,14.69,0,0,1,1.67.87,17.25,17.25,0,0,1,4.46,3.86A17,17,0,0,1,84.25,770.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M116.46,805.7a4.76,4.76,0,1,1-6.51-5.25,19.64,19.64,0,0,1,6.59,4.24A5.81,5.81,0,0,1,116.46,805.7Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-29",
  cx: 116.87,
  cy: 708,
  r: 2.06
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-56",
  d: "M72.85,834S14.6,939.87,61.63,1104.84"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Pink_daisy_1",
  "data-name": "Pink daisy 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pink_daisy_1-2",
  "data-name": "Pink daisy 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M336.65,1044.53c.24-1.4,10.8-62.15,48.73-60.19,38.36,2,54.4-4.26,62-13.36,3.87-4.65,6.81-16.08.89-25.08-4.61-7-14.62-12.55-33.79-12.26a121.73,121.73,0,0,0-14.3,1.12C341.87,942.53,336.73,1042.89,336.65,1044.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M336.69,1044.37a.31.31,0,0,1,0,.1h0v0c.31-1.76,10.92-62.11,48.73-60.16,38.37,2,54.4-4.26,62-13.36a16.41,16.41,0,0,0,2.51-4.36c-12.62-6.7-28.46-7.91-28.46-7.91C347.66,950.66,337.19,1039.75,336.69,1044.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M393.79,960.6s-43.51,6.18-56.43,80.41c0,0,3.06-76.24,44.83-100.23,0,0-1.49,5.84,1.73,7.69s19,2.52,21.56,10C405.48,958.49,398,959.48,393.79,960.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M260.33,968.29a37.55,37.55,0,0,0,51.19,13.78c-.67,0-20.69,1.49-29.62-16.17a34.66,34.66,0,0,1-2.6-6.91l-.09-.34c-.11-.39-.21-.79-.29-1.18l-1.35.78-.27.15L261,967.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M414.47,933.64c4.08,2.66,5.94,7,8.87,9.44,5,4.08,8.14,3.39,14.93.56,3.72-1.55,7.41.29,10,2.26C443.65,938.89,433.64,933.35,414.47,933.64Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-37",
  cx: 412.45,
  cy: 945.82,
  r: 4.29
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-47",
  d: "M343.12,1104.89c.83-38.84-5.27-84.54-29.72-123.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M199.56,944C234.23,984,299,961.91,300.51,961.36c-17.3,2.88-49.74-12.55-70.68-24.31-5.26-2.95-9.79-5.68-13.17-7.82l-2.49-1.61-.42-.28C203,920.54,191.22,934.34,199.56,944Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M300.59,961.35s52.56-46,34.52-96.47c-4.29-12-22.08-8.54-21.45,4.18l0,.51C314.9,886.78,315.11,943.39,300.59,961.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M225.47,920.5c21.91,41.48,75.12,40.86,75.12,40.86-24.32-14.8-41.37-36.68-50.76-51-.43-.66-.85-1.3-1.25-1.93a12.79,12.79,0,0,0-18.83-3.06l-1.3,1A11.35,11.35,0,0,0,225.47,920.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M281.9,889.55c7.53,15.07,18.48,42,18.68,71.81,0,0,20.4-33.17,11.06-67.87a66.32,66.32,0,0,0-5.79-14.56c-.53-1-1.1-2-1.71-3a11.35,11.35,0,0,0-13.6-4.69l-1.58.57A12.8,12.8,0,0,0,281.9,889.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M253.58,906.83c8.68,35.76,47,54.53,47,54.53,5.24-30-9-52.74-19.62-64.93-.95-1.11-1.87-2.12-2.74-3a12.79,12.79,0,0,0-10.44-4,13.2,13.2,0,0,0-5.36,1.67l-2.7,1.55A12.87,12.87,0,0,0,253.58,906.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M214.09,943c16.8,19.41,40.65,24.22,61,24a136.6,136.6,0,0,0,25.46-5.56c-22.6,3.75-71.06-23.72-85.93-33.47A10.84,10.84,0,0,0,214.09,943Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M328.18,868.06l0,.5c.79,11.17,1.16,38.89-2.63,61.89,10.42-17.64,18.28-41.08,9.53-65.57a11.08,11.08,0,0,0-3.77-5.25A10.71,10.71,0,0,0,328.18,868.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M240,919.5c13.24,25.07,37.93,34.75,55.37,38.5-22.63-15.32-38.37-36.36-46.79-49.56a12.56,12.56,0,0,0-4.26-4.11l0,0L243,905.43A11.35,11.35,0,0,0,240,919.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M296.44,888.55A186.71,186.71,0,0,1,311.87,932c3.58-16.11,4-36.68-7.74-56a11,11,0,0,0-3.55-3.62A12.81,12.81,0,0,0,296.44,888.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M268.11,905.83c5.28,21.77,21.56,37.25,33.5,46,1.26-27.83-13.84-48.37-23.39-58.46a12.88,12.88,0,0,0-3-2.33l-1,.57A12.88,12.88,0,0,0,268.11,905.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M260.26,968.17a.75.75,0,0,0,.07.12,37.55,37.55,0,0,0,51.19,13.78h0a37.6,37.6,0,0,0,13.91-51.29l-.07.05-15.55,8.9-.44.26-7.81,4.48-2.07,1.19-11.79,6.75-.7.42-8.1,4.65-1.37.78-.25.15h0l-16.6,9.52Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-41",
  cx: 326.99,
  cy: 868.8,
  r: 6.37
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-37",
  d: "M312.54,951.32a13.43,13.43,0,0,0,8.25,17.09,13.79,13.79,0,0,0,4.06.76,37.64,37.64,0,0,0,5-26l-.26-.09A13.41,13.41,0,0,0,312.54,951.32Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-41",
  cx: 268.91,
  cy: 904.08,
  r: 4.81
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M267.78,889.42a7.68,7.68,0,0,0,13.18,7c-.95-1.11-1.87-2.12-2.74-3A12.79,12.79,0,0,0,267.78,889.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M236.38,903.28a7.69,7.69,0,0,0,13.45,7.09c-.43-.66-.85-1.3-1.25-1.93a12.72,12.72,0,0,0-11.91-5.86A6.91,6.91,0,0,0,236.38,903.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M216.24,930.2a7.67,7.67,0,0,0,13.59,6.85c-5.26-2.95-9.79-5.68-13.17-7.82A6.45,6.45,0,0,0,216.24,930.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M300.82,883.82a7.86,7.86,0,0,0,10.82,9.67,66.32,66.32,0,0,0-5.79-14.56A7.84,7.84,0,0,0,300.82,883.82Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Rose_Bud_1",
  "data-name": "Rose Bud 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rose_Bud_1-2",
  "data-name": "Rose Bud 1"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-25",
  x: 1361.33,
  y: 748.9,
  width: 149.96,
  height: 185.75,
  rx: 71.98,
  transform: "translate(449.93 -499.35) rotate(23.29)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M1480,814.25a35.49,35.49,0,0,1,2.49,13.56,38.16,38.16,0,0,1-5.8,19.74c-18.43-5.11-18.56-46-18.56-46s13.38-3.51,19.63,7.86A38.4,38.4,0,0,1,1480,814.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1462.87,816.28l-59.36,1.41s-.29-11.15,13.34-19c4.62-2.67,10.84-5,19.22-6.33,15-2.43,21.92,2.27,25,8.15C1464.74,807.54,1462.87,816.28,1462.87,816.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-33",
  d: "M1425.39,886.86s-41.92,141.78-1.54,230.84"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M1457.48,880.66s-3.25,13.78-27.73,12.59a19.51,19.51,0,0,1-11.24-4.24,33.62,33.62,0,0,1-7.19-7.86,31.39,31.39,0,0,1-4.18-9.27,34.91,34.91,0,0,1-1.15-8.67h0l1.36.63,0,0c2.94,1.33,10.54,4.6,22.76,8.69h0q7.13,2.4,16.33,5.07,5.14,1.49,10.94,3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M1424.16,892.15s19.83-3.67,20.69-15l12.64,3.49S1449.08,900.73,1424.16,892.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1416.58,873.66a5.58,5.58,0,0,1-3.33,7.16,5.45,5.45,0,0,1-1.93.33,31.39,31.39,0,0,1-4.18-9.27,5.59,5.59,0,0,1,9.44,1.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M1462.86,816.26v0a93.12,93.12,0,0,1-2.46,28.64,0,0,0,0,0,0,0c-3.88,14.77-12.68,28.14-30.88,29l-22.82-8.72s-30.47-23.29.77-51.45c11-9.9,25.4-5.64,33.35-5.64,7.63,0,12-6.27,17.26-4.47a8.66,8.66,0,0,1,2.88,1.72C1462.15,806.42,1462.49,810.8,1462.86,816.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M1478.39,865.19s0,0,0,0A21.62,21.62,0,0,1,1477,868h0c-.18.33-.4.66-.62,1-3.44,5-9.52,9.66-19.48,13.09l-27.31-8.1c30.66-1.46,34.64-38.43,33.34-57.67a82.55,82.55,0,0,0,3.35,10c1.64,4,3.84,8.29,6.58,11.31C1477.37,842.62,1483.05,854.33,1478.39,865.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M1462.86,816.26v0a93.12,93.12,0,0,1-2.46,28.64c0-.42-.54-6.78-6.33-13.13-6-6.57-5.4-13.34-1.93-18.62,1.73-2.62,8.21-5,5.94-9.5a8.66,8.66,0,0,1,2.88,1.72C1462.15,806.42,1462.49,810.8,1462.86,816.26Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-18",
  cx: 1419.95,
  cy: 827.82,
  r: 9.56
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1480,814.25a35.49,35.49,0,0,1,2.49,13.56l-.16.07a7,7,0,1,1-4.84-13.21A6.93,6.93,0,0,1,1480,814.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1476.32,869a3.38,3.38,0,0,1,.62-1C1476.76,868.3,1476.54,868.63,1476.32,869Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1478.39,865.19c1.32-5.29-3.93-12-7.69-20a49.85,49.85,0,0,1-4.48-18.91c1.64,4,3.84,8.29,6.58,11.31C1477.37,842.62,1483.05,854.33,1478.39,865.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M1461.05,800.49c-3.16-4.32-13.69,1.85-21.72-2.65s-22.3.76-22.48.83c4.62-2.67,10.84-5,19.22-6.33C1451.08,789.91,1458,794.61,1461.05,800.49Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Blue_Tulip_1",
  "data-name": "Blue Tulip 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Blue_Tulip_1-2",
  "data-name": "Blue Tulip 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1166.02,
  cy: 923.11,
  r: 134.37
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M1140.84,1002.84s37.18,11.88,66.67-15.35a82.6,82.6,0,0,0,16.06-20.72c.2-.37.41-.73.61-1.09,23.56-42.09,28.14-49.15,28.61-49.24-.4-.16-2.49-1-5.83-2h0a111.84,111.84,0,0,0-23.94-4.54h0c-21.11-1.54-48.21,3.43-63.06,33.58a84.15,84.15,0,0,0-4.53,11.21v0a101.61,101.61,0,0,0-2.82,10.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1159.92,943.48c14.85-30.15,41.95-35.12,63.06-33.58h0c2.62,0,5.27-12.89,6.41-22.24s6.07-26.82,6.07-26.82a86.54,86.54,0,0,0-20.93,0c-19.46,2.53-32,12.44-40.14,24.67C1160.39,906.66,1159.75,934.79,1159.92,943.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M1174.43,885.48v0s12.75,14.12,29.08,3.57c0,0,7.14-4.61,8.48-19a22.94,22.94,0,0,1,2.59-9.3C1195.11,863.34,1182.54,873.25,1174.43,885.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1173.81,904.92s-13.65,18.73-18.43,49.79c0,0,4.79-14.14,9.43-19.75,0,0,5.16-15.64,11.84-26.71A7.24,7.24,0,0,1,1173.81,904.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1176.66,908.25a8.67,8.67,0,0,0,12-2.19l6.77-9.77a8.66,8.66,0,0,0,.73-8.54,8.47,8.47,0,0,0-2.93-3.49,8.37,8.37,0,0,0-3.07-1.34,8.69,8.69,0,0,0-9,3.52l-6.77,9.78a9.3,9.3,0,0,0-1,1.87A8.7,8.7,0,0,0,1176.66,908.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M1173.48,898.09a8.41,8.41,0,0,0,2.93,3.49,8.66,8.66,0,0,0,12-2.18l6.77-9.77a9.37,9.37,0,0,0,1-1.88,8.47,8.47,0,0,0-2.93-3.49,8.37,8.37,0,0,0-3.07-1.34,8.69,8.69,0,0,0-9,3.52l-6.77,9.78A9.3,9.3,0,0,0,1173.48,898.09Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 1187.18,
  cy: 889.5,
  r: 3.84
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1173.81,904.92s-3.22,5.05-4.2,6.89c0,0,.84,2.77,3.28,3.39l3.77-7h0A8.57,8.57,0,0,1,1173.81,904.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M1155.39,954.69c12.83-18.76,41.93-12.46,51.26-28.6S1247,914.44,1247,914.44h0a111.84,111.84,0,0,0-23.94-4.54h0c-21.11-1.54-48.21,3.43-63.06,33.58A84.15,84.15,0,0,0,1155.39,954.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M1196.47,969.81a15,15,0,0,0,11,17.68,82.6,82.6,0,0,0,16.06-20.72c.2-.37.41-.73.61-1.09a15,15,0,0,0-27.71,4.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M1149.41,1004.69s-38.78-4.48-54.45-41.43a82.66,82.66,0,0,1-6.1-25.49c0-.43-.08-.84-.11-1.25-4.15-48.06-5.42-56.38-5.81-56.65.43,0,2.67.13,6.13.58v0a111.46,111.46,0,0,1,23.69,5.73l0,0c19.87,7.28,42.52,23,43.65,56.55a85.56,85.56,0,0,1-.48,12.09h0a104,104,0,0,1-1.66,10.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1156.45,942.73c-1.13-33.59-23.78-49.27-43.65-56.55l0,0c-2.4-1.07.5-13.92,3.31-22.92s5.51-26.94,5.51-26.94a86.61,86.61,0,0,1,19.07,8.6c16.7,10.31,24.08,24.52,26.44,39C1171.18,909,1160.18,934.88,1156.45,942.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1159.66,901.87s4.73,22.69-3.7,53c0,0,1.46-14.87-.46-21.89,0,0,1.74-16.38.2-29.21A7.18,7.18,0,0,0,1159.66,901.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1155.69,903.73a8.66,8.66,0,0,1-10.06-6.94l-2.15-11.69a8.67,8.67,0,0,1,2.85-8.09,8.58,8.58,0,0,1,4.11-2,8.34,8.34,0,0,1,3.34,0,8.7,8.7,0,0,1,6.72,6.9l2.15,11.69a9,9,0,0,1,.12,2.12A8.69,8.69,0,0,1,1155.69,903.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M1162.77,895.79a8.65,8.65,0,0,1-14.17-5l-2.15-11.69a9,9,0,0,1-.12-2.12,8.58,8.58,0,0,1,4.11-2,8.34,8.34,0,0,1,3.34,0,8.7,8.7,0,0,1,6.72,6.9l2.15,11.69A9,9,0,0,1,1162.77,895.79Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-17",
  cx: 1153.82,
  cy: 882.32,
  r: 3.84
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1159.66,901.87s.85,5.93,1,8c0,0-1.91,2.18-4.39,1.74l-.57-7.89h0A8.56,8.56,0,0,0,1159.66,901.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M1190.16,999.13s-13.23-19.12-35.09-20.75-52.53,9.06-65-31.48c0,0,1.15,37.64,50.75,55.94C1140.84,1002.84,1163.44,1010.09,1190.16,999.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M1150.93,918.43s-17.15-13.65-37.3-16c0,0-10.05-2.28-20.51-14.9,0,0-5.59-8.39-10.18-7.67C1082.94,879.87,1133.71,881.58,1150.93,918.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M1165,875.14s-2.81-8.57-15.81-11.37-16.47-23.13-16.47-23.13S1159.44,849,1165,875.14Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-30",
  cx: 1126.37,
  cy: 861.52,
  r: 5.18
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1111.31,986.68s-2.12,31.52,23.57,40.52a38.7,38.7,0,0,0,4.62,1.29c35.8,7.76,43.16-26.44,43.16-26.44s-18.86,7-42.72,0A82.23,82.23,0,0,1,1111.31,986.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M1111.31,986.68s-2.12,31.52,23.57,40.52c-6.66-4.94-13.83-20-2.42-24a18.12,18.12,0,0,1,8.38-.39l-.9-.84A82.23,82.23,0,0,1,1111.31,986.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M1139.5,1028.49a903,903,0,0,0-15.87,89.07"
}))), /*#__PURE__*/React.createElement("g", {
  id: "White_Daisy_1",
  "data-name": "White Daisy 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "White_Daisy_1-2",
  "data-name": "White Daisy 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1029.9,819.41S962.12,756.23,988.17,690c6.18-15.72,31.32-10.38,30,6.45,0,.23-.35,1.87-.37,2.1C1015.43,721.35,1011.39,795,1029.9,819.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1029.94,819.47s83.65,30.79,134.64-18.83c14.13-13.75-3.56-31.21-18.12-22.64l-.58.35C1126.39,790.37,1060,825.48,1029.94,819.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1029.94,819.47s-33.5-62.15,1.75-113.44c4-5.9,11.21-6.87,17.78-4l2,.69c9.31,4,13.73,14.29,8.69,23.09C1049,745.16,1032.46,780.05,1029.94,819.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1029.93,819.46s71.67,4.53,103.83-48.75c3.7-6.13,1.19-13.72-4.1-18.54l-1.65-1.5a17,17,0,0,0-25.18,2.63C1089.75,771.43,1064.8,800.88,1029.93,819.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1029.93,819.46s-1.54-56.6,35.14-88.8c5.71-5,14.73-6.13,21.13-2l2.77,1.91c6.66,4.25,9.65,13.31,7.08,20.79C1089.4,770.7,1071.86,806.05,1029.93,819.46Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-28",
  points: "1002.53 785.03 1085.12 829.95 1025.81 841.85 1002.53 785.03"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M999.91,710.44c-11.5,31.54-1.83,61.86,11.37,84.9a178.65,178.65,0,0,0,22.54,25.55c-18.65-23.44-18.08-96.29-16.39-119.48C1010.79,699.59,1002.92,702.21,999.91,710.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M1158.05,793.2l-.56.36c-12.26,8-43.7,26.05-72.4,36.34,26.79.7,58.57-5.23,81-30.81a14.36,14.36,0,0,0,3.61-7.63A13.93,13.93,0,0,0,1158.05,793.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M1043.19,725.14c-20.23,31.08-15.6,65.45-8.78,87.76,3.11-35.61,17.14-67,26.87-85a16.55,16.55,0,0,0,2-7.48l-.08,0-2-.83A14.83,14.83,0,0,0,1043.19,725.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M1114.45,770a243.91,243.91,0,0,1-39.79,45.24c20.69-6.15,44.46-18.75,59.1-44.48a14.32,14.32,0,0,0,1.88-6.34A16.72,16.72,0,0,0,1114.45,770Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M1076.69,748.57c-21.52,19.88-28.86,48.33-31.3,67.54,32.62-16.25,46.48-46.57,51.94-63.9a16.5,16.5,0,0,0,.77-4.87l-1.28-.79A16.84,16.84,0,0,0,1076.69,748.57Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-67",
  cx: 1156.45,
  cy: 792.31,
  r: 8.33
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-67",
  cx: 1079.19,
  cy: 748.38,
  r: 6.29
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-67",
  d: "M1095.22,737.76a10,10,0,0,0,.38,19.52c.66-1.79,1.23-3.49,1.73-5.07A16.72,16.72,0,0,0,1095.22,737.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-67",
  d: "M1059.42,710.69a10.06,10.06,0,0,0,.45,19.88c.48-.91.94-1.8,1.41-2.66a16.63,16.63,0,0,0-.88-17.34A8,8,0,0,0,1059.42,710.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-67",
  d: "M1122.64,772a10.27,10.27,0,0,0-4.17,18.51,86.46,86.46,0,0,0,13-15.88A10.21,10.21,0,0,0,1122.64,772Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-37",
  points: "999.27 779.55 1024.77 843.87 1094.13 829.95 1053.99 808.63 1035.77 798.95 999.27 779.55"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M1028.6,810.41a12.76,12.76,0,1,0,25.52,0,11.56,11.56,0,0,0-.13-1.78l-18.22-9.69A12.76,12.76,0,0,0,1028.6,810.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-36",
  d: "M1022.22,837.46s6.21-9.71,2.55-15.51-9.67-9.83-9.22-15.81-5.32-12.41-10.6-12.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-47",
  d: "M1026,842.22s-74.36,116.12-48.46,275.34"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1064.97,
  cy: 758.21,
  r: 113.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1064.97,
  cy: 758.21,
  r: 98.76
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-65",
  points: "1069.52 816.87 1024.77 843.87 1094.14 829.95 1069.52 816.87"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Lotus_1",
  "data-name": "Lotus 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lotus_1-2",
  "data-name": "Lotus 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 641.73,
  cy: 748.38,
  r: 206.84
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 645.34,
  cy: 742.16,
  r: 150.38
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-70",
  d: "M641.69,794s-46.38,108.67,17.15,313.88"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M651.52,794c-2.2,6-7.64,22.36-11.95,46.63-10.16,6.39-18.78-1.52-18.78-1.52,2.51-14.52,5.17-27.78,9.59-41.68A164.88,164.88,0,0,0,651.52,794Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M636.6,662.6a184.78,184.78,0,0,0-10.37,33.63,117.22,117.22,0,0,0-24-25.31,71.52,71.52,0,0,0-14.75,20.38c-6.31-6.64-17.2-15.06-17.2-15.06s1.29-35.92,35.6-61.75C605.89,614.49,634.6,644.11,636.6,662.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M636.6,662.6s-6.25,13.13-10.37,33.63l-19.46-16.8s0-12.34,10.9-14.76,14.58-5.74,15.36-13.36C633,651.31,636.16,657.3,636.6,662.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M521.71,703.31s7.87,6.19,14.3,11.41c3,2.48,5.76,4.73,7.16,6,0,0-3.79-14.55-6.79-27.94-5.32-23.79,6-52,10.09-56.1C545.75,637.09,522.77,650.48,521.71,703.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M583.57,701a67.89,67.89,0,0,0-1.09,38.14,35.57,35.57,0,0,1-14-7c-9.68-8.08-16.81-11.59-16.81-11.59q-.33,3.53-.45,6.84c-3.23-2.52-6-4.79-8.05-6.6h0c-.15-.53-3.85-14.78-6.79-27.92-5.33-23.79,6-52,10.09-56.1h0a93,93,0,0,0,6.28,16.64h0c3.8,7.82,9.49,16.74,17.53,22.91,0,0,10.83,8.37,17.13,15l.06.06A70.72,70.72,0,0,0,583.57,701Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M710.25,676.67c-2.24,1.72-10.25,8.14-11.59,12.93a51,51,0,0,0-8.18-6.67s-7.91,16-15.53,27h0a53.24,53.24,0,0,0-8.14-2.69,93.2,93.2,0,0,0-34.73-1.94c-1.76-3-3.7-6-5.83-9,.8-3.83,1.9-8.55,3.44-13.86a181,181,0,0,1,6.93-19.77c7.24-17.31,18.61-36.55,36.3-51.34a102.52,102.52,0,0,1,19.35,19A88.61,88.61,0,0,1,706,654.52,68.93,68.93,0,0,1,710.25,676.67Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-38",
  cx: 647.3,
  cy: 738.34,
  rx: 44.13,
  ry: 36
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M719.53,749.12a45.18,45.18,0,0,1-4.77,17.18c-.28.55-.57,1.08-.88,1.61s-.43.76-.65,1.13c-.42.71-.87,1.4-1.34,2.07-17.54,25.58-58.54,28.06-58.54,28.06a54.46,54.46,0,0,1-5.83-20.79c-.14-1.68-.21-3.38-.21-5.08a76.53,76.53,0,0,1,2.51-19.21c3.94-15.38,11.92-29.13,19.68-37.26a57.93,57.93,0,0,0,5.43-6.92h0c7.62-11,15.53-27,15.53-27a51,51,0,0,1,8.18,6.67v0l.72.71.73.75c.48.51,1,1,1.5,1.61a70.52,70.52,0,0,1,17.49,38.23c.32,2.38.55,4.86.66,7.42A85.69,85.69,0,0,1,719.53,749.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M719.1,730.92A48.31,48.31,0,0,1,715.27,741c-.33.63-.65,1.24-1,1.85-.25.43-.5.87-.76,1.29-.48.8-1,1.59-1.53,2.36-10.2,14.88-27.33,22.92-41.7,27.25a16.31,16.31,0,0,1-20.51-19.47,1.21,1.21,0,0,0,.05-.18c3.94-15.38,11.92-29.13,19.68-37.26a57.93,57.93,0,0,0,5.43-6.92h0c7.62-11,15.53-27,15.53-27a51,51,0,0,1,8.18,6.67v0l.72.71.73.75c.48.51,1,1,1.5,1.61,1,1.14,2.08,2.38,3.13,3.73a69.43,69.43,0,0,1,10.63,19.21A73.61,73.61,0,0,1,719.1,730.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M778.91,787s-20.36,56.51-77,46.81c-37.06-6.35-48.25-33.73-48.58-34.59l0,0s31.63-1.91,51.22-19.72l0,0a47.15,47.15,0,0,0,7.28-8.3,41,41,0,0,0,2.87-4.81,122.16,122.16,0,0,1,14.7.71c2.93.31,6.13.75,9.43,1.37l1.59.33c1.47.29,2.94.63,4.41,1a60.56,60.56,0,0,1,16.27,6.48l7.36,4.46,0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M778.91,787s-20.37,56.52-77,46.82c-37.07-6.36-48.26-33.74-48.59-34.59.76.73,30.46,29.58,66.47,16.82C756.31,803.11,778.91,787,778.91,787Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M761.15,776.2a60.49,60.49,0,0,0-16.26-6.48A109.31,109.31,0,0,0,729.45,767c58.18-17.8,55.91-79.06,55.91-79.06C802.05,743.37,761.15,776.2,761.15,776.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M729.45,767a122,122,0,0,0-14.69-.71,45.18,45.18,0,0,0,4.77-17.18,85.59,85.59,0,0,0,.22-10.78s7.26-7.83,18.2-17.61l.27-.25.65-.57c12.65-11.23,29.89-24.75,46.49-32C785.36,688,787.63,749.21,729.45,767Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M759.41,703.31s-7.87,6.19-14.3,11.41c-3,2.48-5.76,4.73-7.16,6,0,0,3.79-14.55,6.79-27.94,5.33-23.79-6-52-10.09-56.1C735.37,637.09,758.35,650.48,759.41,703.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M744.74,692.79c-2.94,13.14-6.64,27.39-6.79,27.92v0c-10.94,9.78-18.2,17.61-18.2,17.61-.9-22-10.26-36.89-18.15-45.65-1-1.13-2-2.14-3-3.07h0c1.34-4.8,9.36-11.22,11.6-12.94l.58-.43c17.36-13.32,23.81-39.56,23.81-39.56h0C738.71,640.77,750.07,669,744.74,692.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M624.51,805.24c-5.5,8.65-18.78,24-45.33,28.54-56.59,9.7-77-46.81-77-46.81l6-3.63,0,0c2.62-1.57,6.36-3.85,11.74-7.11a60.49,60.49,0,0,1,16.26-6.48c1.48-.38,3-.72,4.41-1l1.6-.33c3.3-.62,6.49-1.06,9.43-1.37,2.32-.25,4.47-.41,6.38-.52h0c4,8.82,8.3,12.93,8.3,12.93C585.41,800.89,607.4,805.72,624.51,805.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M624.51,805.24c-5.5,8.65-18.79,24-45.33,28.55-56.6,9.7-77-46.82-77-46.82s22.59,16.14,59.08,29c25.53,9.06,47.91-2.84,59-10.76C621.74,805.28,623.14,805.28,624.51,805.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M520,776.2a60.63,60.63,0,0,1,16.26-6.48A109.55,109.55,0,0,1,551.67,767C493.49,749.21,495.76,688,495.76,688,479.07,743.37,520,776.2,520,776.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M558.05,766.49c-1.9.11-4.06.27-6.38.52C493.49,749.21,495.76,688,495.76,688c10.62,4.61,20.65,9.37,30,16.07,11.1,7.92,25.43,23,25.39,24.14C550.66,745.52,554.24,758.13,558.05,766.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M653.36,799.2a70.21,70.21,0,0,1-12.57,4A85.79,85.79,0,0,1,629.12,805c-1.49.13-3,.21-4.61.26-1.37,0-2.77,0-4.19,0-16.42-.4-36.44-6.08-54-25.82,0,0-4.3-4.12-8.32-13-3.81-8.36-7.39-21-6.85-38.33,0-.27,0-.56,0-.84q.1-3.32.44-6.84a95.12,95.12,0,0,1,16.81,11.59,35.51,35.51,0,0,0,14,7h0c6.36,1.66,13.11,1.95,19.76,1.95,11.79,0,33.27,10,44.32,32.37A68.13,68.13,0,0,1,653.36,799.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M653.46,799.19a69.61,69.61,0,0,1-12.58,4A85.29,85.29,0,0,1,629.21,805c-1.48.12-3,.21-4.6.26-1.37,0-2.77,0-4.19,0-16.42-.39-36.44-6.07-54-25.82,0,0-4.29-4.11-8.31-12.94a73.71,73.71,0,0,1-4.72-14.25c3.87,8.08,7.81,11.86,7.81,11.86,17.51,19.75,37.53,25.42,54,25.82,1.42,0,2.82,0,4.19,0,1.58,0,3.12-.13,4.61-.26a85.79,85.79,0,0,0,11.67-1.81C643.42,786.08,652.78,789.43,653.46,799.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-43",
  d: "M649.82,754.09c-1.6,6.22-3,14.85-2.35,21.3l-.91-2c-11-22.34-32.53-32.37-44.32-32.37-6.65,0-13.4-.29-19.76-1.95h0A67.94,67.94,0,0,1,583.56,701l.48-1.44.64-1.75c.22-.57.43-1.14.67-1.69a.58.58,0,0,1,.06-.17c.21-.49.41-1,.63-1.48.47-1.08,1-2.13,1.45-3.14a71.52,71.52,0,0,1,14.75-20.38,117.22,117.22,0,0,1,24,25.31c2.13,3,4.06,6,5.82,9A141.52,141.52,0,0,1,649.82,754.09Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 664.74,
  cy: 712.1,
  rx: 3.5,
  ry: 2.19
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 658.38,
  cy: 720.48,
  rx: 3.5,
  ry: 2.19
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 646.81,
  cy: 718.54,
  rx: 3.5,
  ry: 2.19
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 652.12,
  cy: 709.75,
  rx: 3.5,
  ry: 2.19
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-31",
  cx: 640.1,
  cy: 709.75,
  rx: 3.5,
  ry: 2.19
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-45",
  d: "M641.73,725.14s10.42,3,20,1.74"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M658.38,732.46s-6.74,12.4-8.56,21.63a176.05,176.05,0,0,0-6.23-24s1.33-.85,3.71,3.59S656.07,736.45,658.38,732.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M710.25,676.67c-2.24,1.72-10.25,8.14-11.59,12.93a51,51,0,0,0-8.18-6.67s-7.91,16-15.53,27h0c-.24-.11-17.2-6-22.21-7.3,16-.91,9-7.49,15.52-14.72,6-6.63,11.71,2.91,22.48-9.18,4.24-4.76-.26-15.77,13-29.76C707.67,656.8,710.08,668.68,710.25,676.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-46",
  d: "M587.43,691.24c-2.45,4.82-5.89,12.76-6.38,20.24,0,0-13.43-6.24-13.64-16.14s-2.22-13.91-8.27-19-4.88-12.39-6.37-23c3.8,7.82,9.49,16.74,17.53,22.91C570.3,676.24,581.13,684.61,587.43,691.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M647.47,775.4l-.91-2c-11-22.34-32.54-32.38-44.32-32.38-6.65,0-13.4-.28-19.76-1.94h0a68.51,68.51,0,0,1-.69-31.52c2.05,13.4,14.5,12.79,21.37,12.9s10.08-.11,21.79,6.7c8.1,4.72,13.5-.31,16-3.85,7.15,17.36,8.82,30.76,8.82,30.76C648.22,760.31,646.85,768.94,647.47,775.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M646.81,773.43s-16-9.16-27.32-6.42-27.81,2.06-32.28-12.92c-2.59-8.66-8.35-14.67-12.76-18.19a38.76,38.76,0,0,0,8.27,3.2h0c6.36,1.66,13.11,1.94,19.76,1.94C614.28,741.05,635.76,751.09,646.81,773.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M688.49,709.91c-4.84,9.65-12.51,4.38-17.35,20.12-5.89,19.15-18,19.76-21.32,23.8,3.95-15.28,11.89-28.92,19.6-37a57.93,57.93,0,0,0,5.43-6.92h0c7.38-10.67,15-26,15.51-26.93a.12.12,0,0,1,0-.05S693.34,700.26,688.49,709.91Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-42",
  cx: 568.27,
  cy: 742.92,
  r: 7.02
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M715.37,715.63a11.44,11.44,0,1,1-10.63-19.21A69.43,69.43,0,0,1,715.37,715.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M558.07,766.5c-.82.11-7.49,1.29-23.08,12.25-16.67,11.75-26.77,4.59-26.77,4.59l0,0c2.62-1.57,6.36-3.85,11.74-7.11a60.49,60.49,0,0,1,16.26-6.48c1.48-.38,3-.72,4.41-1l1.6-.33c3.3-.62,6.49-1.06,9.43-1.37,2.32-.25,4.47-.41,6.38-.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-41",
  d: "M768.54,780.69a22.8,22.8,0,0,0-22.41,4.39c-10.74,9.15-24.47,8.35-28.5,1.89s-13.06-7.52-13.06-7.52l0,0a108.5,108.5,0,0,0,10.15-13.11,122.16,122.16,0,0,1,14.7.71c2.93.31,6.13.75,9.43,1.37l1.59.33c1.47.29,2.94.63,4.41,1a60.56,60.56,0,0,1,16.27,6.48l7.36,4.46Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-41",
  cx: 551.33,
  cy: 782.71,
  r: 6.72
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-46",
  d: "M692.25,630.26l-5.16,3.33c-5.17,3.34-13.32,4.85-18.85,3.1s-11.42,4.57-20.93,23.9c-8.92,18.11-16.72,21.43-17.64,21.78a181,181,0,0,1,6.93-19.77c7.24-17.31,18.61-36.55,36.3-51.34A102.52,102.52,0,0,1,692.25,630.26Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Orange_Tulip_1",
  "data-name": "Orange Tulip 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pink_Tulip_1",
  "data-name": "Pink Tulip 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-25",
  cx: 1653.41,
  cy: 960.94,
  r: 121.65
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M1636.13,1036.83s39.6,12.65,71-16.36a88,88,0,0,0,17.11-22.07c.21-.4.44-.78.65-1.16,25.1-44.83,30-52.36,30.47-52.45-.42-.16-2.65-1-6.21-2.13h0a118.6,118.6,0,0,0-25.51-4.83h0c-22.49-1.64-51.35,3.66-67.17,35.77a92.61,92.61,0,0,0-4.83,11.95h0a111,111,0,0,0-3,11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M1656.45,973.59c15.82-32.11,44.68-37.41,67.17-35.77h0c2.8,0,5.62-13.73,6.83-23.7s6.47-28.57,6.47-28.57a92.12,92.12,0,0,0-22.29,0c-20.73,2.69-34.13,13.25-42.76,26.27C1657,934.37,1656.28,964.33,1656.45,973.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M1671.91,911.81v0s13.58,15,31,3.8c0,0,7.61-4.92,9-20.21a24.47,24.47,0,0,1,2.77-9.9C1693.94,888.23,1680.54,898.79,1671.91,911.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1671.25,932.52s-14.54,20-19.63,53c0,0,5.1-15.07,10.05-21,0,0,5.49-16.66,12.61-28.44A7.65,7.65,0,0,1,1671.25,932.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1674.28,936.06a9.23,9.23,0,0,0,12.82-2.32l7.21-10.42a9.25,9.25,0,0,0,.78-9.09,9.15,9.15,0,0,0-3.12-3.72,9,9,0,0,0-3.27-1.42,9.24,9.24,0,0,0-9.54,3.75l-7.22,10.41a9.77,9.77,0,0,0-1,2A9.26,9.26,0,0,0,1674.28,936.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M1670.9,925.25A9.07,9.07,0,0,0,1674,929a9.23,9.23,0,0,0,12.81-2.33l7.21-10.41a9.82,9.82,0,0,0,1-2,9.15,9.15,0,0,0-3.12-3.72,9,9,0,0,0-3.27-1.42,9.24,9.24,0,0,0-9.54,3.75l-7.22,10.41A9.77,9.77,0,0,0,1670.9,925.25Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 1685.49,
  cy: 916.09,
  r: 4.09
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1671.25,932.52s-3.43,5.38-4.48,7.34c0,0,.9,2.95,3.5,3.61,0,0,4-7.41,4-7.41h0A9.11,9.11,0,0,1,1671.25,932.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M1651.62,985.54c13.67-20,44.68-13.28,54.61-30.47s42.93-12.41,42.93-12.41h0a118.6,118.6,0,0,0-25.51-4.83h0c-22.49-1.64-51.35,3.66-67.17,35.77A92.61,92.61,0,0,0,1651.62,985.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M1695.39,1001.64a15.94,15.94,0,0,0,11.75,18.83,88,88,0,0,0,17.11-22.07c.21-.4.44-.78.65-1.16a15.93,15.93,0,0,0-29.51,4.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M1645.26,1038.79s-41.3-4.77-58-44.13a87.83,87.83,0,0,1-6.51-27.15c0-.46-.08-.9-.12-1.34-4.42-51.18-5.77-60-6.18-60.33.45,0,2.84.14,6.53.61h0a118.72,118.72,0,0,1,25.23,6.09s0,0,0,0c21.16,7.76,45.29,24.46,46.49,60.24a90.91,90.91,0,0,1-.52,12.87h0a110.24,110.24,0,0,1-1.78,11.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M1652.76,972.8c-1.2-35.78-25.33-52.48-46.49-60.24,0,0,0,0,0,0-2.56-1.14.53-14.82,3.53-24.4s5.86-28.7,5.86-28.7a92.2,92.2,0,0,1,20.32,9.16c17.79,11,25.65,26.12,28.16,41.54C1668.44,936.85,1656.73,964.43,1652.76,972.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M1656.18,929.27s5,24.17-3.94,56.42c0,0,1.55-15.83-.5-23.31,0,0,1.86-17.45.22-31.12A7.6,7.6,0,0,0,1656.18,929.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M1652,931.26a9.23,9.23,0,0,1-10.72-7.4L1639,911.41a9.22,9.22,0,0,1,7.4-10.72,8.92,8.92,0,0,1,3.57,0,9.24,9.24,0,0,1,7.15,7.34l2.29,12.46a9.55,9.55,0,0,1,.13,2.25A9.28,9.28,0,0,1,1652,931.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M1659.49,922.79a9.09,9.09,0,0,1-4.37,2.11,9.23,9.23,0,0,1-10.72-7.39l-2.29-12.46a3.29,3.29,0,0,1,4.24-4.36,8.92,8.92,0,0,1,3.57,0,9.24,9.24,0,0,1,7.15,7.34l2.29,12.46A9.55,9.55,0,0,1,1659.49,922.79Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 1649.96,
  cy: 908.44,
  r: 4.09
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1656.18,929.27s.91,6.32,1.06,8.53c0,0-2,2.33-4.68,1.86l-.61-8.4h0A9.13,9.13,0,0,0,1656.18,929.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M1688.66,1032.87s-14.09-20.36-37.37-22.1-56,9.65-69.22-33.54c0,0,1.23,40.1,54.06,59.6C1636.13,1036.83,1660.21,1044.54,1688.66,1032.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M1646.88,946.91s-18.27-14.54-39.73-17c0,0-10.71-2.43-21.85-15.87,0,0-6-8.94-10.84-8.17C1574.46,905.84,1628.54,907.66,1646.88,946.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M1661.86,900.8s-3-9.13-16.84-12.11-17.55-24.64-17.55-24.64S1655.94,872.91,1661.86,900.8Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-57",
  cx: 1620.72,
  cy: 886.29,
  r: 5.52
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1604.67,1019.61s-2.26,33.57,25.11,43.15a41.85,41.85,0,0,0,4.92,1.38c38.14,8.27,46-28.16,46-28.16s-20.09,7.46-45.51,0A88,88,0,0,1,1604.67,1019.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M1604.67,1019.61s-2.26,33.57,25.11,43.15c-7.1-5.26-14.73-21.25-2.57-25.53a19.21,19.21,0,0,1,8.92-.4l-1-.9A88,88,0,0,1,1604.67,1019.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M1634.7,1064.14s-5.4,20.63-10.64,53.56"
}))));

function SvgBeeBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeBg);
export default __webpack_public_path__ + "static/media/bee_bg.59169463.svg";
export { ForwardRef as ReactComponent };